import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 246.17 253.17">
    <title>kou</title>
    <path
      d="M540,395c-.8-1.27-2.18-.92-3.33-1.22a4.38,4.38,0,0,1-1.19-4.94,6.94,6.94,0,0,1,1.35-1.9c1.87-1.76,4.22-3.71,6.6-2.79,7.47,2.91,14.48-1.27,21.79-.87,5.19.29,5.42-.16,6,5.29.1,1.13-.32,2.43,1,3.2a6.93,6.93,0,0,1,1.47.89l.23.53c-2.63,2.4-6.37-.76-9,1.8h-3a7.65,7.65,0,0,0-6,0h-8a7.65,7.65,0,0,0-6,0Z"
      transform="translate(-429.92 -141.92)"
      fill="#dbd9d2"
    />
    <path
      d="M430.91,282.14l-.43-.22L430,282v-7c.35-.47.67-.43,1,.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#3f3f3f"
    />
    <path
      d="M540.85,142.86A1.53,1.53,0,0,0,541,142h6C545.15,143.72,543,143.11,540.85,142.86Z"
      transform="translate(-429.92 -141.92)"
      fill="#616161"
    />
    <path
      d="M431,275.06l-.48-.06H430v-6C431.8,270.78,430.73,273,431,275.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#0c0c0c"
    />
    <path d="M542,395a4.52,4.52,0,0,1,6,0Z" transform="translate(-429.92 -141.92)" fill="#e8e6e3" />
    <path
      d="M675.19,255.75l.81.25v6c-.36.47-.68.42-1-.08Z"
      transform="translate(-429.92 -141.92)"
      fill="#464646"
    />
    <path d="M556,395a4.52,4.52,0,0,1,6,0Z" transform="translate(-429.92 -141.92)" fill="#e5e3dd" />
    <path
      d="M676,280c-2.18-1.67-.58-3.95-.95-5.91.27-.51.58-.56.95-.09Z"
      transform="translate(-429.92 -141.92)"
      fill="#393939"
    />
    <path
      d="M565,142a1.52,1.52,0,0,0,.15.86c-2.12.25-4.3.86-6.15-.86Z"
      transform="translate(-429.92 -141.92)"
      fill="#616161"
    />
    <path
      d="M430,256l.82-.25c.37,2.17.86,4.35-.82,6.25Z"
      transform="translate(-429.92 -141.92)"
      fill="#454545"
    />
    <path
      d="M675,261.92a3.57,3.57,0,0,0,1,.08v5C674.33,265.56,675.19,263.65,675,261.92Z"
      transform="translate(-429.92 -141.92)"
      fill="#0f0f0f"
    />
    <path
      d="M676,274a5.86,5.86,0,0,0-.95.09c.14-1.73-.72-3.64.95-5.09Z"
      transform="translate(-429.92 -141.92)"
      fill="#0c0c0c"
    />
    <path
      d="M489,216c1-11.87,5.78-22,13.72-30.82,4.2-4.69,8.93-8.08,15-9.67A5.44,5.44,0,0,1,522,176a17.74,17.74,0,0,1,1.59,5c.68,2.79,0,4.23-2.76,4.84-8.28.64-12.8,6.88-18,12.1-3.58,5.12-4.74,11.21-6.88,16.91C494.31,219.17,492.09,219.49,489,216Z"
      transform="translate(-429.92 -141.92)"
      fill="#171715"
    />
    <path
      d="M521,185c2.38-1.83,1.08-4.18.62-6.21A4.71,4.71,0,0,1,522,176h2c3.54,1.91,2.91-1.69,4-3a17.78,17.78,0,0,1,8-9c2.14-.29,2.45,1.06,2.24,2.65s-.76,2.88-2.59,3c-.91,0-1.47,0-.15.59a3.09,3.09,0,0,1,0,3.2c-.44.67-1.17,1.09-1.59,1.78a13,13,0,0,1,1.19-1.27c1.31-1.38,2.75-2.46,4.8-2.21.83.43,1.48,1.11,2.27,1.6,2.67,1.26,5.28,2.55,1.24,5.36-2.39,1.58-5.49,1.23-7.84,2.88-.1.36-1.15.12-.63.65.28.29,1.23.09,1.83.38a1.6,1.6,0,0,1,.63,1.21,3.46,3.46,0,0,1-1,1.8c-1.05,1.16-3.35,1.29-3,3.63.67,1.39-3,1.59-.9,3.35,3.12.36,3.75,4.07,6.57,4.83a7.9,7.9,0,0,1,3.24,3.54c.09,1.4-.94,2-1.88,2.73-2.47,1.45-5.26.76-7.89,1.17a3.93,3.93,0,0,1-2.68-.48,5.78,5.78,0,0,1-1.53-2.34c-.93-3.49-1.19-7.71-6.73-6.2a5,5,0,0,1-2.74.58,2.9,2.9,0,0,1-2.36-2.51,3.23,3.23,0,0,1,2.24-2.66c.31-.11.64-.14.95-.25,1.7-.61,4.43.8,5-1.89C525.19,186.55,522.21,186.4,521,185Z"
      transform="translate(-429.92 -141.92)"
      fill="#181816"
    />
    <path
      d="M489,216c2.83,2.34,4.84,2.17,6-1.72,1.74-6,3-12.19,7-17.28,3,3.92,3.65,7.84-.25,11.72,1.34-1.45,1.92-3.44,4-4a2.23,2.23,0,0,1,1.59,1.32c.2,2.28-1.1,4.16-1.68,6.23-1,2.16-2.52,4.17-2.3,6.76,0,3.43,0,6.85,0,10.26,0,1.61-.29,3.36.8,4.7,2.87,3.51,1.12,5.91-1.75,8.12a2,2,0,0,1-1.48.19c-.87-.49-1.41-1.4-2.24-1.9-3.85-2.32-3.72-5-.77-7.91,2-4,1.3-8.41,1.65-12.65-.19,2,0,4-.16,6-.6,1.39-.4,4.22-.77,4.16-4-.65-.07,4.21-3.79,3.69-1.82-2.68-2.67-6.45-3.1-10.27-.13-1.14.84-1.82-1.32-1.74s-2.32-1.85-1.46-3.63Z"
      transform="translate(-429.92 -141.92)"
      fill="#1c1c1a"
    />
    <path
      d="M609,242l0,1c0,3.16-2.74,4.39-4.74,5.74-1.7,1.14-1.94-.79-2-2.12.76-5.37-2.94-1.66-4.54-2.21-2.45-1.47-4.67-3.1-4.72-6.35a2.84,2.84,0,0,1,2.48-.9c.84.09,1.61.59,2.47.41.76-3.9-1.79-7.65-.49-11.55,1.05-2.13,1.38-2.45,4.28-3.81.59-.28.1-.6,0-.78-.81-1.83-.27-4-1.53-5.72-.85-6-4.63-10.83-6.57-16.39-.24-2.2-1.46-4.55.93-6.37,4.4,1,4.94,5.39,7.26,8.23a7.39,7.39,0,0,1,1.28,2.59c.32,1.68,1.25,3.16,1.62,4.82,1,8.13,3.37,16.13,1.74,24.5C605.89,236.25,608.62,238.89,609,242Z"
      transform="translate(-429.92 -141.92)"
      fill="#191918"
    />
    <path
      d="M471.77,363.11a2.53,2.53,0,0,1-1.87-1.74c-.59-2.81,1.59-3.12,3.4-3.7,1.54-.49,3.27.34,4.76-.64l4.93-1c3-.84,6.08-1.12,9-2L494,354c2-1.23,4.47-1.52,6.56-2.65,2.94.19,4.65-1.71,6.29-3.73a5.61,5.61,0,0,1,2.11-1.62,3.52,3.52,0,0,1,2.06-3c1.65-1,.87-4.71,4.23-3.91,1.6,4.44.64,8.59-1.43,12.62-2.39,3.72-5.57,6.17-10.2,6.18a4,4,0,0,0-1.94.27c-4.07,2.15-8.33,2.51-11.62,1.13-.45.11.26,0,.7.71s.06,1.2-.56,1.57-1.37.76-1.87.51C482.57,359.13,477.36,364.05,471.77,363.11Z"
      transform="translate(-429.92 -141.92)"
      fill="#2e2f32"
    />
    <path
      d="M609,242c-3.43-3-5-6.88-3.74-11.14,1.94-6.53-.94-12.46-1.68-18.63-.19-1.6.53-2.82.38-4.24a1.82,1.82,0,0,1,2-.37c2.39,4.71,6.38,5.38,11,4.37.57,4.8-3.65,7.09-5.65,10.52-1.29,2.23-2.27,11.92-.43,13.81C614.17,239.68,612.43,241,609,242Z"
      transform="translate(-429.92 -141.92)"
      fill="#131313"
    />
    <path
      d="M499,234c-2.33,1.3-4.07,2.59-.35,4.44A3.92,3.92,0,0,1,501,242c-.81,1.77,0,4.47-3,5a7.92,7.92,0,0,1-1-5,1.75,1.75,0,0,0-3,0c-1,0-2,.07-3,0-1.26-.09-2.8.49-3.62-.93-1-1.68.34-2.72,1.35-3.82a8.75,8.75,0,0,0,2.29-6.81c-.16-2.34-.05-4.29-3.52-3.57-2.28.48-3.35-1.25-1.68-2.9s1.71-4.22,3.15-6c.08.65,0,1.78.27,1.89,6.44,2.38,3.42,9.14,6.35,12.92.06-2.56,2.61-4.22,3.38-6.78A13.86,13.86,0,0,1,499,234Z"
      transform="translate(-429.92 -141.92)"
      fill="#181816"
    />
    <path
      d="M602,184c.6,3.1,3.87,4.29,5,7-.6,3-3,.32-4.27,1.37a2.1,2.1,0,0,1-1.25-.41c-2.34-2.36-4-5.27-6.23-7.72-1.92-2.07-4.3-3.72-5.57-6.35a11.78,11.78,0,0,0-2.07-6c-1-1.28-1-2.37.41-3.32a1.89,1.89,0,0,1,2,.43c3.93,5,9.37,6.53,16.07,6.07-1.54,2.68-3.22,2.94-5,2.93-1.11.5-1.89,1.82-3.38,1.35C599.74,180.31,600.09,182.88,602,184Z"
      transform="translate(-429.92 -141.92)"
      fill="#171716"
    />
    <path
      d="M535,170l-2,2.52c-.28-.33-.8-.64-.81-1-.06-1.62,1.06-2.13,2.43-2.54,3-.92,4.26-2.45,1.35-5,3.67-4.53,9-5.47,14.21-5.91,7.66-.64,15.37-.66,22.81,1.92l-.54.55c-3,1.26-6.13.84-9.19.32-2-.33-3.87-.83-5.66.47a6.9,6.9,0,0,1-1.36.58c-6,.74-11,3.95-16,7.06C538.57,170,537.15,171.68,535,170Z"
      transform="translate(-429.92 -141.92)"
      fill="#161615"
    />
    <path
      d="M513,351c2.08-3.8,1.6-8,2-12.09-.16-2.38,2.35-3.08,3.08-4.9L524,329c1,1.56,0,3.85,1.91,5.07a17.78,17.78,0,0,1,.07,7.62c-.65,1.69-.5,3.64-1.62,5.19-.81.57-1.34.22-1.75-.52a17.67,17.67,0,0,1-.08-2.75c.07.28-.09,1.21-.05,2.13C518.58,346.15,517.23,351.15,513,351Z"
      transform="translate(-429.92 -141.92)"
      fill="#313236"
    />
    <path
      d="M603,192c.08-1.22.5-1.78,1.67-.85.83.66,1.62.94,2.33-.15,2.26,2.05,4.22,4.26,7.85,4.27,2.22,0,2,1.67.16,2.75-1.65,0-1.62.84-1,2-.36,3.33-4.63,6.27-1,10-5,1.11-5,1.11-6.23-4.59-.82.72-.05,1.9-.8,2.6h-2a5.47,5.47,0,0,1-2-4c1.92-.25.88-1.6.93-2.54A12.94,12.94,0,0,0,603,192Z"
      transform="translate(-429.92 -141.92)"
      fill="#161616"
    />
    <path
      d="M530,325c-2.15-.82-2.83-2-3.48-6.08a1.17,1.17,0,0,0-.49-.79c-5.5-2.57-7.88-8.23-12-12.13-.74-1.58-.12-2.86.88-4.05,3-1.24,3.7,1.43,4.81,3,4.34,6.08,9.12,11.66,15.84,15.25a2.9,2.9,0,0,1,1,1.13,2.94,2.94,0,0,1-.46,3C534.16,325.38,532.21,326.35,530,325Z"
      transform="translate(-429.92 -141.92)"
      fill="#090404"
    />
    <path
      d="M587,334.05a6.43,6.43,0,0,0,2.93,3c.71.93,1.61,1.76,1.69,3a3.08,3.08,0,0,1-.46,1.34c-1.63,1.13-2.46,3.77-5.22,2.8a2.31,2.31,0,0,1-.2-2.13c-.9,2.14-1.6,5-3.89,6.91-1,1-2.11,2-3.76,1.34-1.75-1.82-.44-4-.67-6a25.69,25.69,0,0,0,.09-4.58c-.48-3.43,4.18-4.41,3.73-7.83a3.31,3.31,0,0,1,.49-1.92c1-.73,1.64-.06,2.32.52A18.34,18.34,0,0,1,587,334.05Z"
      transform="translate(-429.92 -141.92)"
      fill="#303133"
    />
    <path
      d="M641,356c-1,3-3.65,4.48-5.9,6.33-2.59-.82-5.39-.91-7.83-2.27-1.8-1.2-3.9-1.5-5.95-2-1.78-.44-4-.46-4.41-3,6.91-1.3,13.9-1,20.87-1.07C639.35,354,639.94,355.28,641,356Z"
      transform="translate(-429.92 -141.92)"
      fill="#010105"
    />
    <path
      d="M530,325l6-1.13c1.8-.4,3,.21,3.31,2.11-1.35,2.66-.74,5.86-2.27,8.48a4.22,4.22,0,0,1-3.73,2.33,3.17,3.17,0,0,1-1.43-.49,6.6,6.6,0,0,1-1.5-3.34c-.48-2,1.47-3.05,2.09-4.19-.27-1-.73-1-.74-.72-.13,3.18-3.94,1.92-4.85,4.1A3.13,3.13,0,0,1,525,333c-.75.2-1.68.77-2.19.51-.94-.47-.24-1.27.13-2A23.44,23.44,0,0,0,524,329,8.18,8.18,0,0,1,530,325Z"
      transform="translate(-429.92 -141.92)"
      fill="#343436"
    />
    <path
      d="M589,307c-1.32.75,6,5.17-1.49,3.44-1-.24-2.37.91-3.24,2-1.17,1.48-1.86,3.52-4.43,3.43-.67,0-2,1.52-1.4,2.22,5.1,5.5-.92,5.28-3.41,6.87l-.56.46a7.36,7.36,0,0,1-5.49-1.16c-.72-2.59,1.51-3.71,2.67-5.37a22.38,22.38,0,0,0,5.77-4.49c2.43-2.08,4.29-4.75,6.84-6.69a13.63,13.63,0,0,0,3.62-1.1A1.16,1.16,0,0,1,589,307Z"
      transform="translate(-429.92 -141.92)"
      fill="#050405"
    />
    <path
      d="M605,288c-3.51,2.44-4.75,5.88-4.52,10,.15,2.69-3.88,2.17-3.81,5.77.09,4.46-3.81.14-5.67,1.2-.85-2.31.87-3.62,2-5.1s2.69-2.53,1.73-4.67a6.36,6.36,0,0,1-.49-3.53,3.07,3.07,0,0,1,.76-1.31,41.34,41.34,0,0,1,5.44-3.42C602.1,286,604.13,284.92,605,288Z"
      transform="translate(-429.92 -141.92)"
      fill="#010103"
    />
    <path
      d="M591,162l-1,1c-2.64,1.24-3.15,3.42-2.66,6-1.41,2.14-3,3-5,.7s-5.32-2.6-7.24-5c-1.12-1.37-2.36-2.73-2.06-4.73v0l5,1c1.95-1.56,4.11-1.59,6.38-.91,1.55.47,3.1.83,4.63-.07h0C591.1,159.23,591.81,159.85,591,162Z"
      transform="translate(-429.92 -141.92)"
      fill="#181817"
    />
    <path
      d="M515.14,301.84,514,306h-5c-1-1.16-1.8-2.38-1-4-2.87-1.62-3.34-4.23-3-7.18.1-.88-.39-2,1.18-2.22,1.79-.25,1.73.85,1.92,2.05A4.87,4.87,0,0,0,510,298a1,1,0,0,1,1.18-.21c1.34,1,1.85,2.88,3.48,3.65Z"
      transform="translate(-429.92 -141.92)"
      fill="#010307"
    />
    <path
      d="M606,208c-.82-1.77-1.68-3.54-.29-5.53,1.72.37,3,2.27,2.79,3-1.25,4.52,2.35,3.73,4.52,4.52a5.47,5.47,0,0,1,4,2C612.3,215.89,608.14,214.38,606,208Z"
      transform="translate(-429.92 -141.92)"
      fill="#191919"
    />
    <path
      d="M591,340,589.91,337c3.31,1.09,6.79.88,10.18,1.1.27,3.85-4,1.36-4.74,3.46.23,1.91,1.62.89,2.4,1.13,2,.63,5.48.22,1.34,3.38-1.4,1.07.85,1.8.94,2.86l-.5.43c-2.86.45-3.39-2.44-5.15-3.57a6,6,0,0,1-1.22-1.61C592.37,342.83,591.8,341.34,591,340Z"
      transform="translate(-429.92 -141.92)"
      fill="#010204"
    />
    <path
      d="M605,288c-1.52-1.56-2.79-1.08-4.25.25A10.54,10.54,0,0,1,595,291a2.15,2.15,0,0,1-.56-2,4.69,4.69,0,0,1,1.43-2.39c1.16-.77,2.57-.83,3.8-1.41,1.89-.77,3.22-2.29,4.69-3.61a3.9,3.9,0,0,1,2.47-1,3.63,3.63,0,0,1,2.35,1.29c.3,1.09-.29,1.69-1.17,2.13a16,16,0,0,1,.46,2.88c0,.9.43,2.06-.74,2.63C606.13,290.3,606,288.29,605,288Z"
      transform="translate(-429.92 -141.92)"
      fill="#080302"
    />
    <path
      d="M605,253c3.82-.4,6.61,1,8.13,4.65,1.38,2.33.53,4.95,1,7.4a3.7,3.7,0,0,1-1.1,2.92,1.1,1.1,0,0,1-1.36-.11c-1.37-2-.62-4.4-1-6.59-.4-2.38-1.26-4.1-4.08-2.37-2.24,2.46-4.15,1.64-5.93-.59a3.34,3.34,0,0,1-.46-2.07,2.76,2.76,0,0,1,1.07-1.76C602.41,253.65,603.83,253.61,605,253Z"
      transform="translate(-429.92 -141.92)"
      fill="#bfa38f"
    />
    <path
      d="M501.13,284.72A5,5,0,0,0,501,284c.25-2-2-3.09-1.93-5a3.08,3.08,0,0,1,.61-1.93c2.8,1.77,2.92-1.6,4.43-2.31a2.19,2.19,0,0,1,1.34.45c2,1.89,1.49,4.68,2.55,6.91.58,1.84,1.26,3.72-1.22,4.78C504.47,287.27,502.21,287.54,501.13,284.72Z"
      transform="translate(-429.92 -141.92)"
      fill="#c99d80"
    />
    <path
      d="M493.27,254.92c.42-.74.66-1.74,1.89-1.22,3.08-.76,5.14,1.49,7.61,2.55a4.53,4.53,0,0,1,2.18,3.51,3.81,3.81,0,0,1-.45,2c-1.14,1.3-2.42.76-3.69.3a9.58,9.58,0,0,1-1.12-.55,16.63,16.63,0,0,0-2.16-1,21.37,21.37,0,0,1-3.36-1.09c-.84-.74-.72-1.81-1-2.75A3.62,3.62,0,0,1,493.27,254.92Z"
      transform="translate(-429.92 -141.92)"
      fill="#dcb096"
    />
    <path
      d="M589,160c-3.51,2.13-7.35.51-11,1,1.51-3.42.22-4.33-4.1-2.7,5-3.6,9.62-2.75,12,1.18C586.64,160.65,588,159.73,589,160Z"
      transform="translate(-429.92 -141.92)"
      fill="#030303"
    />
    <path
      d="M616.89,355.06c3.2,2.65,7.88,1.17,11,4-4,3.16-7.94,3.93-12.07.27a12.22,12.22,0,0,0-4.92-2.34c-1.26-.59-2.31-1.33-2.1-3a1.57,1.57,0,0,1,2.16,0C612.82,355.11,614.85,355.1,616.89,355.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#2c2d2f"
    />
    <path
      d="M478.07,357c-2.14,2.54-6.7.52-8.16,4.34a9.49,9.49,0,0,1-3.58-3.38c2.57-1.8,6.88-2.2,10.75-1A4.12,4.12,0,0,0,478.07,357Z"
      transform="translate(-429.92 -141.92)"
      fill="#030306"
    />
    <path
      d="M498,247c2-1.06-.37-4.72,3-5h1c1.73-1.1,2.32,0,2.64,1.43a13.64,13.64,0,0,0,1,3.26c.42,1,.91,2,.46,3.17-1.25,1.21-2.81,0-4.15.54A2.1,2.1,0,0,1,500,249,3.3,3.3,0,0,1,498,247Z"
      transform="translate(-429.92 -141.92)"
      fill="#181819"
    />
    <path
      d="M500,277v2c-2.11.77-3.28-1.76-5.25-1.49a2.21,2.21,0,0,1-1.63-1.82L493,274a2.73,2.73,0,0,1-.6-2.74,4.3,4.3,0,0,1,1.28-1.79c1.4-1,2.68-1,3.76.48.39,1.24.56,2.5,1.91,3.31S501.34,275.46,500,277Z"
      transform="translate(-429.92 -141.92)"
      fill="#cb9e83"
    />
    <path
      d="M490,274c-1.67-4.56-1.19-13.84.84-16.08l.6.45c1.08,1.78.7,3.91,1.44,5.78a11.23,11.23,0,0,1-1.09,8.63A6.29,6.29,0,0,1,490,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#060506"
    />
    <path
      d="M615,264c.85.15,1.8.41,1.82,1.37.08,3.89,0,7.79,0,13.07L613,274A20.13,20.13,0,0,1,615,264Z"
      transform="translate(-429.92 -141.92)"
      fill="#040408"
    />
    <path
      d="M608,284l1-2a5.1,5.1,0,0,1-.7-4c.31-.68.73-1.18,1.59-1,1.62.59,1.94,2,2.4,3.47.55,1.74,1.54,3.71,0,5S609.46,284.47,608,284Z"
      transform="translate(-429.92 -141.92)"
      fill="#000404"
    />
    <path
      d="M611.19,274l-1.08,1c-1.18.57-1.88-.16-2.57-.93-1-2.18-.84-4.66-1.85-6.83,1-3.7,2.84-1.21,4.44-.6.91-.05,1.34.58,1.79,1.2l.21.22C613.75,270.38,612.67,272.23,611.19,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#c99d85"
    />
    <path
      d="M596,295c1.36,1.91.46,3.28-1,4.56a13.69,13.69,0,0,0-4,5.45h-1a2.42,2.42,0,0,1-1.61-2.19c.34-2.15,1.07-4.07,3.08-5.24,1-.12,1.86-.17,2.13-1.48S594.56,294,596,295Z"
      transform="translate(-429.92 -141.92)"
      fill="#080302"
    />
    <path
      d="M501.13,284.72c1.66,1.34,3.64,1.44,5.65,1.42,1.91.59,4.61.54,3.13,3.87C505.46,290.71,501.89,288.55,501.13,284.72Z"
      transform="translate(-429.92 -141.92)"
      fill="#120a06"
    />
    <path
      d="M611.19,274l.93-5.92c1-.28,1.13-1,1-1.9,1.13-2.64-.36-5.57.89-8.2,1.85,1.74.69,4,1,6a21.7,21.7,0,0,1-2,10Z"
      transform="translate(-429.92 -141.92)"
      fill="#130906"
    />
    <path
      d="M603,246c.49.68-1,3.71,1.73,1.64,1.66-1.25,2.87-3.09,4.29-4.67,2.82.71,1.77,2,.23,2.82-2.31,1.25-3.57,3.4-5.2,5.26-1.52.55-3,1-3.9-1C600.09,248,599.21,245.35,603,246Z"
      transform="translate(-429.92 -141.92)"
      fill="#121616"
    />
    <path
      d="M495,277c2.79-2.2,3.1,1.91,5,2-.62,1.86,4.81,2.51,1,5l-2.89-2.07C495.9,281.05,494.36,279.74,495,277Z"
      transform="translate(-429.92 -141.92)"
      fill="#c7a793"
    />
    <path
      d="M509.91,290c.33-2.4-1.37-3.17-3.13-3.87,2.08-1.27-.09-2.78.22-4.14l.6-.27c2,.06,3.1,1.52,4.34,2.76a5.7,5.7,0,0,1,1.4,4.32,6.23,6.23,0,0,1-2.21,2.45.8.8,0,0,1-1.07-.41A.83.83,0,0,0,509.91,290Z"
      transform="translate(-429.92 -141.92)"
      fill="#ac907a"
    />
    <path
      d="M508.94,346l-1,2c-1.73,1-3.24,2.54-5.46,2.46L502,350c3.2-2.26,3.52-6.54,6.45-9.12C509.87,342.44,506.61,344.52,508.94,346Z"
      transform="translate(-429.92 -141.92)"
      fill="#030305"
    />
    <path
      d="M611,354l-2,.09c-2.05.77-3.81,0-5.51-1-1.12-1.37-3.6-1.57-3.5-4l0-.07C604.36,349.16,608.46,349.86,611,354Z"
      transform="translate(-429.92 -141.92)"
      fill="#060606"
    />
    <path
      d="M591,162a1.78,1.78,0,0,0-2-2c2.63-4,2.94-3.92,6.4,1.25C594.14,162.83,592.21,160.61,591,162Z"
      transform="translate(-429.92 -141.92)"
      fill="#030303"
    />
    <path
      d="M518,334c0,2.27-2.32,3.1-3.08,4.9L511,343C509.63,337.06,515.49,336.83,518,334Z"
      transform="translate(-429.92 -141.92)"
      fill="#030305"
    />
    <path
      d="M495,277l3.12,4.91c-1.25,1.78-2.4,3.89-3.39-.24-.48-2-2.09-3.72-1.6-6Z"
      transform="translate(-429.92 -141.92)"
      fill="#040607"
    />
    <path
      d="M584,331l-2-1c-2.87-.2-4.75-2.31-7-3.63a1.19,1.19,0,0,1-.05-1.28L575,325c3.41-.46,5.62,3.13,9.08,2.77A18.67,18.67,0,0,1,585,331C584.69,331.42,584.37,331.44,584,331Z"
      transform="translate(-429.92 -141.92)"
      fill="#050405"
    />
    <path
      d="M608,274l2.11,1-.22,1.92-.88,1c-.48.56-.75,1.33-1.52,1.62a2.67,2.67,0,0,1-2.86-.67,4.08,4.08,0,0,1,.59-4.49C606,273.66,606.89,273.13,608,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#d2a28c"
    />
    <path
      d="M502.1,257l-6.94-3.26L496,253a8.19,8.19,0,0,1,5-.5C502.63,253.67,503.35,255.07,502.1,257Z"
      transform="translate(-429.92 -141.92)"
      fill="#ba9e8e"
    />
    <path
      d="M587,169c-2.56-3.75-.45-5.2,3-6-2,2-2,4,0,6l-2,0Q587.5,169.63,587,169Z"
      transform="translate(-429.92 -141.92)"
      fill="#030303"
    />
    <path
      d="M508,302a6.71,6.71,0,0,1,1,4c-1.45-.24-3.53.69-3.86-1.76C504.85,302.09,506.47,302,508,302Z"
      transform="translate(-429.92 -141.92)"
      fill="#060001"
    />
    <path
      d="M510.07,290.85l.77.47a6.64,6.64,0,0,1,2.48,5.63c-.53.88-1.16,1.56-2.33,1.05h-1C509.91,295.61,508.77,293.22,510.07,290.85Z"
      transform="translate(-429.92 -141.92)"
      fill="#120a06"
    />
    <path
      d="M500.93,352c-2.23.95-4.41,2.09-6.94,2,2-2.67,5.25-2.83,8-4l0,.1C502.56,351.2,501.55,351.47,500.93,352Z"
      transform="translate(-429.92 -141.92)"
      fill="#0d0d0e"
    />
    <path
      d="M500.8,253.14,496,253c1.48-1.19,3.52-1.8,4-4l2,1C502.76,251.49,503.39,252.93,500.8,253.14Z"
      transform="translate(-429.92 -141.92)"
      fill="#100d0c"
    />
    <path
      d="M602,184c-2.42-.48-3.46-2.58-4.12-4.41-.31-.86,1.84-1.45,3.17-1.57C599.23,180.35,601.27,182.07,602,184Z"
      transform="translate(-429.92 -141.92)"
      fill="#161616"
    />
    <path
      d="M614,200c-.92.27-2,.82-2-.9,0-1.21.29-2.38,1.63-2.67,1.14-.24,1.18.81,1.35,1.59A2.1,2.1,0,0,1,614,200Z"
      transform="translate(-429.92 -141.92)"
      fill="#1a1a1a"
    />
    <path
      d="M601,251c1,.33,2.06-1.18,3.06.05a2,2,0,0,0,1,2c-.8,1-1.5,2.11-3,1.78C600.7,253.79,599.84,252.66,601,251Z"
      transform="translate(-429.92 -141.92)"
      fill="#211d12"
    />
    <path
      d="M616.56,257.77c-2.48-2.49-.63-4.07-.16-6.48A10.14,10.14,0,0,1,616.56,257.77Z"
      transform="translate(-429.92 -141.92)"
      fill="#030709"
    />
    <path
      d="M490,274l1-1q.39.33.26.67T491,274c1,1.55,1.06,3-.5,4.28C488.93,277,489,275.56,490,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#040607"
    />
    <path
      d="M492,354a17.08,17.08,0,0,1-9,2A15.52,15.52,0,0,1,492,354Z"
      transform="translate(-429.92 -141.92)"
      fill="#030306"
    />
    <path
      d="M528,173c0,1.79-.08,3.69-1.91,4.55-1,.48-1.61-.69-2.08-1.53C526.24,176.2,526.65,174,528,173Z"
      transform="translate(-429.92 -141.92)"
      fill="#171715"
    />
    <path
      d="M614,258c-.25,2.74.57,5.59-.89,8.2q0-4.26.06-8.53A3.43,3.43,0,0,1,614,258Z"
      transform="translate(-429.92 -141.92)"
      fill="#a68b78"
    />
    <path
      d="M491,274v-1a6.94,6.94,0,0,0,1-4c1.78-.15,1.58.83,1.11,2l-.14,3Z"
      transform="translate(-429.92 -141.92)"
      fill="#160b07"
    />
    <path
      d="M588.86,302.65,590,305a2.08,2.08,0,0,0-1,2h-1a2,2,0,0,1-1.54-1.38C586.34,303.88,587,302.82,588.86,302.65Z"
      transform="translate(-429.92 -141.92)"
      fill="#120906"
    />
    <path
      d="M493.27,254.92l.69,1c-.41.78-.59,1.71-1.46,2.19a1.54,1.54,0,0,1-1.28.07l-.39-.24C491,256.38,491.25,254.94,493.27,254.92Z"
      transform="translate(-429.92 -141.92)"
      fill="#100d0c"
    />
    <path
      d="M494,242c.15-1,.41-2,1.75-1.8,1,.14,1.13,1,1.25,1.82Z"
      transform="translate(-429.92 -141.92)"
      fill="#0e0d0b"
    />
    <path
      d="M584,331h1a3,3,0,0,1,2,3.06A6.63,6.63,0,0,1,584,331Z"
      transform="translate(-429.92 -141.92)"
      fill="#080808"
    />
    <path
      d="M584,319.59a5.25,5.25,0,0,1,.64.64,4.78,4.78,0,0,1-1.18,1.41c-.48.29-1,0-.72-.66A6.83,6.83,0,0,1,584,319.59Z"
      transform="translate(-429.92 -141.92)"
      fill="#050405"
    />
    <path
      d="M615.41,377.22a34.1,34.1,0,0,1-9.31,5.12c-1.4-1-.82-2.75-1.52-4-1-1.87-2.2-3.15-4.68-2.49-2.13.57-4.09.74-4,3.83,0,2.37-1,4.75.08,7.13a52.06,52.06,0,0,1-13.79,4.28c-3.72,1.38-4.33-1-4.47-3.79-.18-3.45.38-7-2.19-9.94-.23-7.32,3.25-13.89,4.29-21a4.21,4.21,0,0,1,3.36-3.77c3.43-.6,4.87,2.14,6.8,4.07,1.75,1.75,3.3,3.67,4.93,5.52,1.46,1.33,3.12,2.49,4.18,4.19,2.09,3.35,4.82,5.11,9,4.73S614.11,373.82,615.41,377.22Z"
      transform="translate(-429.92 -141.92)"
      fill="#3c3d41"
    />
    <path
      d="M611,356c1.13.16,2.72-.11,3.3.54,4,4.4,8.59,4.36,13.62,2.48,1.91,2.12,6-.54,7.15,3.31-2.59,3.11-5.88,5.38-9.18,7.64-.79.68-1.83.67-2.75,1-6.22,2.1-6.27,2.09-7.58-4.49-.42-2.13-1.17-3.56-3.6-2.38-3.45,1.68-7,1.39-10.66,1a4.64,4.64,0,0,1-3-2.36c-.43-3.19-3.23-5.41-3.61-8.63,1.18-1.41,3.22-2.57,4.14-.88C602,358.92,606.89,355.5,611,356Z"
      transform="translate(-429.92 -141.92)"
      fill="#333438"
    />
    <path
      d="M601,364c3.87-.71,8.18,1.65,11.71-2.24.9-1,4-.27,4.23,2.48.16,1.64,0,3.32.07,5,0,1.9.33,2.95,2.55,1.37,1.83-1.29,4.21-.38,6.33-.61a28.71,28.71,0,0,1-8.66,6.13c-2.28,1-2.89-.5-3.34-2.23a4.15,4.15,0,0,0-4.23-3.41C605.17,370.4,603.07,367.25,601,364Z"
      transform="translate(-429.92 -141.92)"
      fill="#36373b"
    />
    <path
      d="M596,386.78c-2-1-4.14-1.85-1.78-4.57.4-.47.87-1.31.71-1.77-2.6-7.3,5.09-6.61,6.88-6.4,3.46.41,5.31,4.2,4.34,8.3A42.76,42.76,0,0,1,596,386.78Z"
      transform="translate(-429.92 -141.92)"
      fill="#3f4044"
    />
    <path
      d="M601,364c1.73,1.43,4.37,1.77,5.18,4.31,0,.15.2.41.27.4,6-1,8.15,3.52,10.78,7.38a2,2,0,0,1-1.82,1.13c-2.94-2.91-5.42-6.36-10.64-4.94-2.7.74-4.45-1.86-5.77-3.91a23,23,0,0,0-5-5.38c1.45-1.44,3-2.23,5-1A3.45,3.45,0,0,0,601,364Z"
      transform="translate(-429.92 -141.92)"
      fill="#393a3e"
    />
    <path
      d="M576,377c4.34,2.09,2.76,6.08,3,9.45.14,2.28-.38,4.8,3.2,4.61-2.55,1.43-5.45,1.52-8.21,2.14l.1-.4c-1.26-2.11-.24-4.46-.64-6.69-.21-1.13.76-2.12,2.19-2.18.13,0,.89.7.47-.06C574.76,381.53,574.13,379.32,576,377Z"
      transform="translate(-429.92 -141.92)"
      fill="#3e3f44"
    />
    <path
      d="M534.06,393.68A93.58,93.58,0,0,1,516,388.85c-2.83-3.66-1.12-7.52-.34-11.24.67-3.21,2.75-5.9,4.74-9.54-3.41,1-5.33,2.77-7.51,4.17-3,2-6.22,4.14-9.93,1.22-.67-3.56,2.85-4.64,4.15-7,2.68-2.78,6.14-4.84,7.87-8.5a12.31,12.31,0,0,1,6.07-5.56c3.87-1.75,6.47-.44,7.18,3.62.6,3.42,1.91,6.63,2.64,10,.36,1.41.6,2.85,1.05,4.24.39,2.2.81,4.39,1.32,6.56a55.79,55.79,0,0,0,1.63,7.26,11.4,11.4,0,0,1,.27,4.48C534.32,390.14,537,392.49,534.06,393.68Z"
      transform="translate(-429.92 -141.92)"
      fill="#3a3c40"
    />
    <path
      d="M530,366a92.06,92.06,0,0,1-2.89-9.34c-.9-4.45-2-5.12-6.19-2.74-2.09,1.19-4.48,2.2-4.89,5.06l-.41.28c-7,4.54-15.76,2.82-23.12,6.33-5.61,2.68-11.52,2.42-17.35.36a7.47,7.47,0,0,1-3.34-2.86c.38-.31.9-1,1.13-.88,4.55,1.73,8.1-6,13.07-1.34.69.66,2.54.09,4,.09-.64-1.65-2.11-.5-3.08-1.49,1.7-.85,3.18-1.91,5.16-1,2.35,1.13,4.53-.08,6.77-.51s3.91-4.12,6.42-.66c1.68-3.19,6.79-2.25,7.71-6.36,2.65-.45,3.18-3,4.55-4.69,1.54-1.88,2.87-1.69,4.46-.31.33-.44.67-.47,1,0l1,1a34,34,0,0,0,5.43,5.66c1.46,2.14.91,4.75,1.69,7a12.79,12.79,0,0,1,.38,3.34A4.27,4.27,0,0,1,530,366Z"
      transform="translate(-429.92 -141.92)"
      fill="#333438"
    />
    <path
      d="M503,373c3.24,1.69,6.24.47,8.7-1.4a53.62,53.62,0,0,1,6.16-4.13c1.11-.62,2.18-2.11,3.46-.9s.68,2.8-.43,4c-4.94,5.23-5.32,11.66-4.91,18.31a70.79,70.79,0,0,1-18.28-7.69C496.85,376.74,498.89,374.2,503,373Z"
      transform="translate(-429.92 -141.92)"
      fill="#3d3e42"
    />
    <path
      d="M475.11,366c8.74,1.55,16.56-2.39,24.82-3.81,4.52-.78,9.08-.57,12.71-3.81,1.61-1.44,2.09,1.3,3.36.66-2.11,3.22-5.15,5.52-8,8-7.06-1.77-13.25-.36-18.3,5.06a4.36,4.36,0,0,1-5.74,1A50.55,50.55,0,0,1,475.11,366Z"
      transform="translate(-429.92 -141.92)"
      fill="#35363a"
    />
    <path
      d="M484,373a5.87,5.87,0,0,0,5.47-2.49c4.08-5,10.13-5.74,16.15-5.81.8,0,1.61,1.48,2.42,2.28l-5,6c-2.26,2.4-5,4.52-5.3,8.16l-2.7-1.32c-1.43-1.69.91-2.93.59-4.57-2.19-.6-2.8,2.85-5,1.93A19.76,19.76,0,0,1,484,373Z"
      transform="translate(-429.92 -141.92)"
      fill="#38393d"
    />
    <path
      d="M490.56,377.19A3,3,0,0,0,491,377c1.88-1.49,3.16-5.6,6-3.35,2.27,1.81-1.57,4-2,6.24A10.36,10.36,0,0,1,490.56,377.19Z"
      transform="translate(-429.92 -141.92)"
      fill="#3c3d41"
    />
    <path
      d="M534.06,393.68c1.59-1.59-.18-3.16,0-4.74.41-.44.59-1.11,1.3-1.23.67.17,1.12.47.8,1.27l.53,4.8Z"
      transform="translate(-429.92 -141.92)"
      fill="#2f3034"
    />
    <path
      d="M576,377c.1,1.81.13,3.62.31,5.42.12,1.23,2,3.37-1.46,2.51-.11,0-.88,1.4-.7,1.61,1.83,2.16-.3,4.19-.09,6.26L572,393c-1.23-1.14-.83-2.83-1.4-4.19-.15-1.49,0-3-.09-4.49a7.69,7.69,0,0,1,1-3.56c2-2.85,1.3-5.89.62-8.93-.89-3.86.55-7.43,1.35-11.08a10.76,10.76,0,0,1,.92-5.06,5.45,5.45,0,0,1,1.9-2.33,40.06,40.06,0,0,1,4.55-1.76c1.28-.43,3-1,3.19,1.41-4.88,1.93-3.6,7.13-4.45,10.48C578.41,368,576.44,372.32,576,377Z"
      transform="translate(-429.92 -141.92)"
      fill="#39393d"
    />
    <path
      d="M571,384l0,5c.57.92,0,1.2-.77,1.39.42-4.61-.66-7.16-6.18-5.51a16.18,16.18,0,0,1-7.93,0c-3-.69-2.59,4.55-5.93,2.75a24.13,24.13,0,0,0-7-2.49c-2.49-.45-4.18,1.72-6.17,2.85a5.31,5.31,0,0,1-1.41-4.5c1.88-3.8,4.81-5,9-4.19,3.56.67,7.24.68,10.85,1.16,3.37.45,6.91,1.19,9.9-1.64a3.9,3.9,0,0,1,4.25-.44c1.72,1,1.21,2.75,1.6,4.21A1.15,1.15,0,0,1,571,384Z"
      transform="translate(-429.92 -141.92)"
      fill="#dad7d0"
    />
    <path
      d="M536.08,384.06c1.39,1.06.78,2.59.93,3.94l-.87,1-1.12-1c-.77-.77-.45-1.73-.45-2.64A1.68,1.68,0,0,1,536.08,384.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#e0e0de"
    />
    <path
      d="M570.2,390.38,571,389c1.5,1,.88,2.61,1,4C569.51,393.42,570.77,391.27,570.2,390.38Z"
      transform="translate(-429.92 -141.92)"
      fill="#282a29"
    />
    <path
      d="M506,205l-5.25,7.43c.62-5.22,4.16-10,1.25-15.43,3.36-4.5,8-7.63,12.3-11,2-1.55,4.43-.82,6.7-1,3.9-1,5.32,2,5.35,4.49,0,3.12-3.23,2.3-5.37,2.5-.65.06-1.32,0-2,0-4.08-1-5.34,0-5.63,4.12C512.24,200.19,508.7,202.24,506,205Z"
      transform="translate(-429.92 -141.92)"
      fill="#1f1f1e"
    />
    <path
      d="M601,202l-6-9c-3.86-2.28-6.22-6.15-9.55-9a20.21,20.21,0,0,0-4.91-3.22c-3.16-1.27-6.2-2.77-9.32-4.12-4.46-4.32-10.09-3.26-15.46-3.34-2.15,0-4.3,0-6.45,0-2.8-.17-5.46,1.54-8.31.63a2.06,2.06,0,0,1-1-2c0-.49-.09-1.12.4-1.29,6-2.11,11.66-5.2,18.27-4.93a59.14,59.14,0,0,0,12.43,3.69,60,60,0,0,1,18.19,9.6c2.13,2.21,4.35,4.34,6.34,6.69,1.78,2.78,3.66,5.5,5.47,8.27a9.18,9.18,0,0,1,1,5.93A3.72,3.72,0,0,1,601,202Z"
      transform="translate(-429.92 -141.92)"
      fill="#161614"
    />
    <path
      d="M505,212c-.25-2.31,1.14-4.06,2-6,2.51-5.12,5.52-9.64,12-10l2-1c2.45-.09,4.94.07,5.32,3.13.36,2.88,1.07,6.17-3,7.38-1.87,0-1.79-1.49-2-3.43-2.53,3-6.33,4.11-7,8.18a8.9,8.9,0,0,0,1.11,5.82,4.75,4.75,0,0,1,.1,1.46c-.86,3.17-.74,6.65-2.91,9.41-2,1.87-1,4.41-1.47,6.61-.3,1.3-.58,2.93-2.27,2.74s-1.58-1.81-1.44-3.16c.29-2.83.34-5.64-.94-8.29-.35-3.16-.54-6.27,3.14-7.69C508.21,215.16,504.53,215.51,505,212Z"
      transform="translate(-429.92 -141.92)"
      fill="#242422"
    />
    <path
      d="M541,174c2.75-.33,5.13-2.13,8-2,.09.33.3.81.53.78,8.2-1.05,14.27,4.51,21.36,6.85,3.68.68,5.56,4.86,9.58,4.88a2.66,2.66,0,0,1,1.2.66,90.26,90.26,0,0,0,5.88,7.59,6,6,0,0,1,1,3.38c-.23,1.42-.34,2.89-1.44,4a1.37,1.37,0,0,1-1.65-.71c-1.87-5.11-6.28-7.74-10.34-10.72a22.44,22.44,0,0,0-15.33-7c-5.28-.25-10.44-1.52-15.58-2.76A2.7,2.7,0,0,1,543,178C547.27,174.2,541.15,175.59,541,174Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1b19"
    />
    <path
      d="M540,203l2-2c2.38-.43,3.4,1.95,5.29,2.56a10.45,10.45,0,0,1,2.55,3.35c2.89,6.12,8.85,10.54,9.81,17.72a4.2,4.2,0,0,1-.07,2.06,2.7,2.7,0,0,1-2,1.58c-1.79.29-1.13,1.65-1.16,2.71-.12,1.92.44,4.08-1.8,5.27-1.61-.39-1.79-1.91-2.44-3.06-.74-1.87-2-3.59-1.94-5.72.25-1.53-.17-3-.14-4.58.43-2.87-1.74-4.91-2.39-7.44a7.59,7.59,0,0,0-3.85-5,51.6,51.6,0,0,0-4-5C539.32,204.64,539.85,203.82,540,203Z"
      transform="translate(-429.92 -141.92)"
      fill="#1d1e1c"
    />
    <path
      d="M559,167c-6.84-.26-12.67,3.32-19,5l-5,2h0q0-2,0-4c2.05.27,3.23-1.19,4.77-2.16,5-3.16,9.91-6.72,16.23-6.84a1.15,1.15,0,0,1,.3.86c0,.31-.07.46-.13.46-.76,1.43-2.29,1.5-4,2.09,3.88-.83,7.28-2.16,10.94-1.56,1.44.24,3.32.35,3.09,2.35-.21,1.85-2,1.79-3.52,1.88C561.47,167.16,560.26,165.84,559,167Z"
      transform="translate(-429.92 -141.92)"
      fill="#1d1d1b"
    />
    <path
      d="M547,204c-2.68.69-3.17-2.28-5-3a6.34,6.34,0,0,1-3-3c-3.29-.8-2.44-3.57-2-5.39.61-2.41,3.07-1.64,4.94-1.56,2.73.87,5.34,1.94,7.17,4.3a3.36,3.36,0,0,1,.4,1.3,9,9,0,0,0,1,5.1,3.65,3.65,0,0,1,.07,1.41C549.73,205,548.48,205,547,204Z"
      transform="translate(-429.92 -141.92)"
      fill="#22211e"
    />
    <path
      d="M523,205c4-3.75,3.27-7.63-2-10,5.5-2,7.86.11,8,7-1.6,3-3,6-5.57,8.36a22.71,22.71,0,0,0-2.87,1.56c-.84.7-1.57,1.64-2.85,1.52a1.79,1.79,0,0,1-1.26-2.13A12.57,12.57,0,0,1,523,205Z"
      transform="translate(-429.92 -141.92)"
      fill="#1d1d1b"
    />
    <path
      d="M549,196l-7-4a9.68,9.68,0,0,0-1.79-1c-2.22-1.34-5.2.11-7.21-2-1.72-1.22-3.22-2.39.35-3a16.71,16.71,0,0,0,2.65-1l.65.16c2.66,2.15,6.37,1.68,9.1,3.65a9.1,9.1,0,0,1,4.75,4.2A2.31,2.31,0,0,1,549,196Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1b19"
    />
    <path
      d="M519,196c-5.29,1.79-8.31,6.3-12,10l-1-1c.84-4.16,5.3-5.51,7-9,.2-2.92,1.73-3.21,4-2Z"
      transform="translate(-429.92 -141.92)"
      fill="#171715"
    />
    <path
      d="M541,191l1,1c-4.26.09-5.1,1.78-3,6-4,.73-4-4.29-7-5C534.17,188.63,537.57,189.75,541,191Z"
      transform="translate(-429.92 -141.92)"
      fill="#1c1c19"
    />
    <path
      d="M517,194c-1.71-.08-3.24.2-4,2-1.5-.15-2-.76-1.35-2.3,1.23-3,4.27-3.73,6.69-4.37s.94,1.58.67,2.67A3.45,3.45,0,0,0,517,194Z"
      transform="translate(-429.92 -141.92)"
      fill="#252523"
    />
    <path
      d="M541,191c-3.15,0-6.41-.51-9,2-.86.19-1.75,1.33-2.58.24s-.05-1.75.84-2.33,1.83-1.27,2.74-1.91C535.62,189.86,539.17,187,541,191Z"
      transform="translate(-429.92 -141.92)"
      fill="#141412"
    />
    <path
      d="M543,178h1c.43,1.53,4,.66,2.7,3.5a5,5,0,0,1-2.06.71c-2.55-.19-5,1.29-7.61.36-.86-.28-2.36.26-2-1.56C536.85,177.83,540.48,179.4,543,178Z"
      transform="translate(-429.92 -141.92)"
      fill="#1e1e1c"
    />
    <path
      d="M523,210c2.08-2.6,2.51-6.46,6-8a2.07,2.07,0,0,1,1,2c-.08,3-2.44,4.36-4.17,6.2a4.37,4.37,0,0,1-1.82,1C523.24,211.15,522.67,211,523,210Z"
      transform="translate(-429.92 -141.92)"
      fill="#221d18"
    />
    <path
      d="M524.76,209.88,530,204l3.21-.38a4.74,4.74,0,0,1,.56,1.29c-1.09,3.33-4.29,4.41-6.78,6.19C526.17,211.68,525.17,210.92,524.76,209.88Z"
      transform="translate(-429.92 -141.92)"
      fill="#baa38f"
    />
    <path
      d="M537,182c2.7-.05,5.23-1.5,8-1,1.25,2.54-1,2.73-2.36,3.54a8.27,8.27,0,0,1-1.43.42c-1.51.17-3,.34-4.2-1v-1q-.53-.33-.35-.67C536.77,182.11,536.88,182,537,182Z"
      transform="translate(-429.92 -141.92)"
      fill="#181816"
    />
    <path
      d="M533.11,204.65c0-.34.06-.69.1-1L540,203c1.12.66.1,1.34,0,2a3.67,3.67,0,0,1-3.18,1.69C535.32,206.49,533.8,206.32,533.11,204.65Z"
      transform="translate(-429.92 -141.92)"
      fill="#24221e"
    />
    <path
      d="M537,182q0,.5,0,1c-1.82-.47-3.41,1.36-5.58.49.53-1.92,2-2.31,3.58-2.49A2.07,2.07,0,0,0,537,182Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1b19"
    />
    <path
      d="M535,174c-.18,1.31-.34,2.67-1.76,3.23-.16.06-1-.9-1-1.42-.11-2.07,1.54-1.7,2.8-1.81Z"
      transform="translate(-429.92 -141.92)"
      fill="#1d1d1b"
    />
    <path
      d="M537,184h5a1.08,1.08,0,0,1-.35,1.48c-2,1.11-3.85.7-5.65-.48h0Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1b19"
    />
    <path
      d="M505,212c1,2.63,3.82,2.69,5.72,4a2.11,2.11,0,0,1,1.13,2.41c-.41,1.64-1.37.34-2.11.43-3.07.38-1.77,3.41-2.74,5.12-.12,1-.19,2-1.44,2.23-1.93-1.41-.7-3.38-1.18-5.83.33,5.33.41,9.94,2.41,14.25.15,2.3,2.18,4,1.93,6.45-1.09,1.23-.78,2.57-.27,3.93a2.32,2.32,0,0,1-.35,1.28c-.92.74-1.86,1.39-3.1.7s-2.14-1.51-1.47-3.16c.57-1.41-.45-1.69-1.52-1.84,5-4-.44-8,0-12a28.6,28.6,0,0,0,0-12C501.75,215.38,503.47,213.73,505,212Z"
      transform="translate(-429.92 -141.92)"
      fill="#21221f"
    />
    <path
      d="M499,234q0-4,0-8,0-3.38,0-6.76C499.39,224.17,501.21,229.13,499,234Z"
      transform="translate(-429.92 -141.92)"
      fill="#222220"
    />
    <path
      d="M502,218a15.67,15.67,0,0,1,0,12Q502,224,502,218Z"
      transform="translate(-429.92 -141.92)"
      fill="#242422"
    />
    <path
      d="M593.19,237.93c1,2.53,3.26,4,4.76,6.15,2,2.25,1.76,5.12,2.06,7.83.34,2.15-.08,4.29-.07,6.43a14.08,14.08,0,0,1-1.43,4.37c-2.56.15-1,2.48-1.87,3.55-.43.68-1,1.13-1.84.76a5.72,5.72,0,0,1-1.11-3.44c-.78-4.07-.54-8.19-.63-12.29.3-3.34-1.46-5.83-3.39-8.24a9.09,9.09,0,0,0-2.29-1.3,3.78,3.78,0,0,1-1.11-.87c-1.14-4,1.82-3.71,4.21-4a4.94,4.94,0,0,1,2.16.54Z"
      transform="translate(-429.92 -141.92)"
      fill="#9f846e"
    />
    <path
      d="M601,216c3,2.8,1.68,5.93,1.52,9.56-2.32-1.11-.77-3-2.15-3.64-.9,1.29.44,3.92-2.38,4.08-2.64-.31-2.15-2.5-2.15-4a4.56,4.56,0,0,0-2.44-4.35c-.41-4.43-3.22-8.7-.89-13.32,2.51-1.31,3,.94,4,2.28C598.63,209.42,599.14,213,601,216Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1b19"
    />
    <path
      d="M581,180c6.29,2.59,10.26,7.67,14,13-1.65,2-.34,4,0,6a1.64,1.64,0,0,1-1.23.49c-2.68-.91-3.06-3.81-4.77-5.55-2.92-2.75-5.16-6.12-8-8.94h0c-.54-.43-1.26-.31-1.85-.59-1.26-.59-2.52-1.49-2.11-2.95s1.87-.83,3-.64C580.64,180.94,580.78,180.41,581,180Z"
      transform="translate(-429.92 -141.92)"
      fill="#1d1d1b"
    />
    <path
      d="M594,218c1.51-1.43,2.87-2.86,3,.88.11,2.38-1,5,1,7.12.57,3.81,1.16,7.63,1.68,11.45.07.5,1.12,1.64-.56,1.45-.4,0-.74-.59-1.11-.9-1.21-.56-2.16-1.56-3.43-2a15,15,0,0,0-3.31-.85,4.38,4.38,0,0,1-2-.88C591.91,229.15,592.47,223.43,594,218Z"
      transform="translate(-429.92 -141.92)"
      fill="#1e1e1c"
    />
    <path
      d="M594,199h1c.75,4.85,5.36,8.06,5.57,13.15.05,1.29.28,2.56.43,3.85-3.48-1.57-3.17-5.54-5.09-8.12-1-1.3-1.17-3.15-2.91-3.88a2.22,2.22,0,0,1-.62-1.94A4.89,4.89,0,0,1,594,199Z"
      transform="translate(-429.92 -141.92)"
      fill="#1f1f1d"
    />
    <path
      d="M599,252c-.44-2.63-1.62-5.16-1.07-7.93,1.38-1.78,3-2.12,5.11-1.21,2.72,1.19,1.61,2.12-.06,3.13-3.21.65-1.57,3.24-2,5l1,3.81L600.86,256C598.17,255.6,600.46,252.94,599,252Z"
      transform="translate(-429.92 -141.92)"
      fill="#181813"
    />
    <path
      d="M591.81,234.1l3.2.9c1,.79,2.12,1.52,1,3l-2.81-.07-.25.13C591.51,237,590.64,235.86,591.81,234.1Z"
      transform="translate(-429.92 -141.92)"
      fill="#272118"
    />
    <path
      d="M601,202v-2c2-.78,2.1,1.18,3,2-.08,1.26.45,3.12-2,2A2.07,2.07,0,0,0,601,202Z"
      transform="translate(-429.92 -141.92)"
      fill="#111"
    />
    <path
      d="M596,238l-1-3c2,0,2.27,1.72,3,3C597.34,239.11,596.67,238.08,596,238Z"
      transform="translate(-429.92 -141.92)"
      fill="#171611"
    />
    <path
      d="M500.93,352l1.08-1.9,6-2.12C506.07,350.05,504.81,353.3,500.93,352Z"
      transform="translate(-429.92 -141.92)"
      fill="#292a2b"
    />
    <path
      d="M559,167c1.69-2.13,4.59,0,6.81-2.16-6.24-2.31-11.69.65-17.33,1.57,2.12-2.35,4.88-3.26,7.51-4.41a10.94,10.94,0,0,1,6.83,0c-1.87-1.21-4.14.3-5.83-1,.47-2.77,2.76-2.29,4.26-1.85,3.89,1.15,7.82.71,11.74.86,1.83,5.43,8.08,5.89,11.19,10,1,1.25,1.77-.94,2.84-1l1,0c-1.16,2.43,2.28,2.68,2.35,5a9,9,0,0,1-.35,4l-.67.25c-5.1-1.9-9.24-5.77-14.63-7.14-1.3-.33-2.42-1-3.69-.11C567.08,169.45,562.56,169.67,559,167Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1b19"
    />
    <path
      d="M604,202l-3-2c0-2.06.19-4.14-1-6a2.36,2.36,0,0,1,2-2h1C608,194.87,604.4,198.59,604,202Z"
      transform="translate(-429.92 -141.92)"
      fill="#191919"
    />
    <path
      d="M602,192a3.44,3.44,0,0,1-2,2c-2-2.47-4.15-4.82-5-8a2.28,2.28,0,0,1,1-2C598.4,186.36,601,188.57,602,192Z"
      transform="translate(-429.92 -141.92)"
      fill="#1d1d1b"
    />
    <path
      d="M596,184a2.07,2.07,0,0,1-1,2,22,22,0,0,1-6-6,2.29,2.29,0,0,1,1-2h0A17.64,17.64,0,0,1,596,184Z"
      transform="translate(-429.92 -141.92)"
      fill="#21211f"
    />
    <path
      d="M557,161h5.82l0,1H556q0-.5,0-1Z"
      transform="translate(-429.92 -141.92)"
      fill="#1f1f1f"
    />
    <path
      d="M525,333l1-1c2.19-.16,2.1,1.71,2.33,2.94a4.88,4.88,0,0,0,2.64,3.8c.61,2.65-2.66,2.9-3,5-.65,1-1,2.35-2.52,2.51-1.5-1.26-1.06-2.72-.42-4.2Z"
      transform="translate(-429.92 -141.92)"
      fill="#272a30"
    />
    <path
      d="M525,342c.18,1.38-.54,3,1.22,3.94,1.83.16,1.82,1.69,2.21,2.93-1.43,1.61,1.07,1.91,1,3.06a1.36,1.36,0,0,1-.64,1.07c-2.42-1.35-5.19-2.42-4.82-6C524.24,345.32,523.33,343.4,525,342Z"
      transform="translate(-429.92 -141.92)"
      fill="#373533"
    />
    <path d="M523,346h-1v-3.88l.8-.05Z" transform="translate(-429.92 -141.92)" fill="#373a40" />
    <path
      d="M512.85,297c-.26-2-2.21-3.5-2-5.71C511,290,511.5,289,513,289c2.4,0,2.9,1.89,3.59,3.6.43,1.95,1.67,3.48,2.73,5.09a4.25,4.25,0,0,1,.29,1.25,2.59,2.59,0,0,0,1.21,2.57,3,3,0,0,1,.85.9c.59,1.36,1.39,2.6,2.07,3.92,2.85,4.32,7,7.33,10.61,11a4.39,4.39,0,0,1,1.2,2.5,1.55,1.55,0,0,1-.68,1.16c-7.34-3.26-11.76-9.61-16.45-15.65-1-1.26-1.4-3-3.28-3.44h0C513.14,300.83,511.89,299.45,512.85,297Z"
      transform="translate(-429.92 -141.92)"
      fill="#ac937d"
    />
    <path
      d="M538.91,326.13c-.42-1.47-2-1.47-2.93-2.26q0-1.43,0-2.86c3.54-1.5,5.4,1.06,7.48,3.08,1.91,1.64,4.23,1.66,6.52,1.52s3.53.51,3.5,2.94a1.93,1.93,0,0,1-.95,1.13c-2.26.94-4.63.59-7,.59a9.13,9.13,0,0,1-2.29-.42C541.55,328.93,539.28,328.65,538.91,326.13Z"
      transform="translate(-429.92 -141.92)"
      fill="#190e06"
    />
    <path
      d="M543,325a11.79,11.79,0,0,0-7-4l-1.11-.07.28-1c.91-2.23,3.23-2.51,5-3.6,1.92-.28,3.45-.09,3,2.49-1.14,2,1.43,3.69.38,5.65Z"
      transform="translate(-429.92 -141.92)"
      fill="#191818"
    />
    <path
      d="M584,353c-3-2.51-5,2.5-7.91,1a1.76,1.76,0,0,1-.55-1.91,2.57,2.57,0,0,1,1.48-1.41c2.08.24,4.08.37,4-2.66a11.31,11.31,0,0,0,4.06-9.4c1.77,2.12,1.77,2.12.93,5.38,3,3,6.89,5.11,9.32,8.76A1.24,1.24,0,0,1,595,354c1.61,2.53,4.36,4.48,4,8l-5,1C590.7,359.63,588.22,355.45,584,353Z"
      transform="translate(-429.92 -141.92)"
      fill="#34363a"
    />
    <path
      d="M595,353c-3.07-2.93-7.44-4.56-9-9,2.29,0,2.5-3.37,5-3,.69,1.31,2.28,1.73,3,3l1,1a5.52,5.52,0,0,1,1,2.33C596.27,349.35,596.69,351.35,595,353Z"
      transform="translate(-429.92 -141.92)"
      fill="#323337"
    />
    <path
      d="M582,332c1.47,1.87.08,4.4-.88,4.38-3-.06-1.52,3-3.12,3.62-1.76.35-2.11-1.07-2.74-2.17a7,7,0,0,1-.31-3.16C577.31,330,578.42,329.61,582,332Z"
      transform="translate(-429.92 -141.92)"
      fill="#313139"
    />
    <path
      d="M577.1,351l-1,1c-.79.69-1,1.82-1.86,2.45a6.58,6.58,0,0,1-1.11.64,3.48,3.48,0,0,1-3.13.2,2.24,2.24,0,0,1-.59-1.13,2.73,2.73,0,0,1,.27-1.23,9.71,9.71,0,0,1,1.87-1.53c.81-.64.87-1.66,1.23-2.53a5.17,5.17,0,0,1,.83-.88,3.74,3.74,0,0,0,1.62-3.08,5.82,5.82,0,0,1,.33-1.29c.41-.83.83-1.66,1.85-1.91,1.17.43,1.23,1.25.79,2.24,1.08,2.08-.49,4-.45,6A1.14,1.14,0,0,1,577.1,351Z"
      transform="translate(-429.92 -141.92)"
      fill="#b8a089"
    />
    <path
      d="M582,332c-3.23-1.46-5.14-.29-6,3-1.84.55-2.61-.66-3.3-2-.26-2.68,2.77-4.29,2.32-7a11.68,11.68,0,0,1,7,4Z"
      transform="translate(-429.92 -141.92)"
      fill="#35333c"
    />
    <path
      d="M578.18,344c-.27-.71-.16-1.65-1.19-1.88a3.81,3.81,0,0,1-3.45-2.18,2.82,2.82,0,0,1,0-1.43c.65-.94,1.41-1.3,2.41-.48l2,2C578.51,341.3,579.74,342.57,578.18,344Z"
      transform="translate(-429.92 -141.92)"
      fill="#3c352c"
    />
    <path
      d="M577.1,351c-.19-.59.08-.93.63-1.1A3,3,0,0,0,581,348c2,2.08-.53,2.69-1.33,3.74C578.44,353.37,577.94,351.38,577.1,351Z"
      transform="translate(-429.92 -141.92)"
      fill="#39393d"
    />
    <path
      d="M594,344c-.63-1.37-5.42,1.44-3-3l0-1C592.56,340.9,593.92,342,594,344Z"
      transform="translate(-429.92 -141.92)"
      fill="#2b2c30"
    />
    <path
      d="M531.18,339.06c-1.86,0-3.71.37-3.71-2.72,0-1.3.06-3.27-1.47-4.34a12,12,0,0,0,1.53-2.54c.43-1.4,4.24,1.22,2.65-2.3a3,3,0,0,1,2.81.56c.75.66.89,1.48.08,2.09-1.11.84-2.07,1.68-2.06,3.2.73.86-.66,2.45,1,3l1.39.2C533.78,338,533.15,339.06,531.18,339.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#2d3035"
    />
    <path
      d="M531.18,339.06a3.26,3.26,0,0,0,2.23-2.86c1.52,0,1.91-1.33,2.72-2.18a1.44,1.44,0,0,1,1.94-.2c.62,1.27,0,2.35-.53,3.43-1.15,1.59-2.28,3.19-3.42,4.79-1.77,2.5-4.05,4-6.81,1C527,340.13,530.45,340.92,531.18,339.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#b69e8a"
    />
    <path
      d="M538,334l-1.87,0c2.15-2.2-1-6.27,2.78-7.89l4.3,2.73A8.45,8.45,0,0,1,538,334Z"
      transform="translate(-429.92 -141.92)"
      fill="#ac937a"
    />
    <path
      d="M532,336c-.39.55-1,1-1.51.43-1.08-1.23.1-2.3.49-3.42C532.19,333.72,532,334.91,532,336Z"
      transform="translate(-429.92 -141.92)"
      fill="#2b2b2b"
    />
    <path
      d="M588.86,302.65a6.05,6.05,0,0,0-2.1,3.22,2,2,0,0,1-1.83,2c-2.2,2.49-4.11,5.27-6.9,7.2-3.11-2.38.46-3.79.81-5.67,1.79-4.64,4.61-8.71,7-13a13.89,13.89,0,0,0,3.8-6.77c.51-1.72.72-3.66,3.09-3.9,1.28.71,2.59,1.4,2.2,3.24v2a.5.5,0,0,0-.14.65c-.77,2.21-.74,4.82-3.13,6.21Z"
      transform="translate(-429.92 -141.92)"
      fill="#a08876"
    />
    <path
      d="M572,319.18c.08,2.27-2.35,3-2.95,4.87a1.62,1.62,0,0,1,.56,1.63,3,3,0,0,1-.6,1.07,3.1,3.1,0,0,1-1,.65,2.32,2.32,0,0,1-1.19-.14,11.92,11.92,0,0,1-1.79-1.59c-.76-.67-1.84-.93-2.38-1.87-.55-2.51,1.8-3.88,2.3-5.95.42-.3,1.51-.26.44-1.29-.84-.8-.46-1.67.59-2.16a4.8,4.8,0,0,1,3.86.87,6.71,6.71,0,0,1,2.18,3.26C571.94,318.74,571.95,319,572,319.18Z"
      transform="translate(-429.92 -141.92)"
      fill="#161713"
    />
    <path
      d="M568.95,326,569,324c2.09-.36,3.95.65,5.91,1q.06.43.1.87c3.7,3.59-1.63,4.61-2,7s-1.51.72-2.39.54a9.8,9.8,0,0,1-3.17-4.54,2,2,0,0,1,.53-1.93l1-1.12c.45.47,1.1.5,1.64.76C570.07,326.4,569.41,326.4,568.95,326Z"
      transform="translate(-429.92 -141.92)"
      fill="#3a3b40"
    />
    <path
      d="M580,310c-.39,1.79-3.63,2.48-2,5.07a8.09,8.09,0,0,1-6.08,4.11l.11-.43A6.84,6.84,0,0,1,580,310Z"
      transform="translate(-429.92 -141.92)"
      fill="#af967b"
    />
    <path
      d="M584.93,307.86l1.83-2L588,307C587.21,308.12,586.6,309.87,584.93,307.86Z"
      transform="translate(-429.92 -141.92)"
    />
    <path
      d="M591.71,297.85l3.13-6.21L596,295C593.58,294.46,595.32,300.16,591.71,297.85Z"
      transform="translate(-429.92 -141.92)"
      fill="#120906"
    />
    <path
      d="M512.85,297l2.28,4.82c-3.54,1-3.25-2-4.14-3.85Z"
      transform="translate(-429.92 -141.92)"
      fill="#090404"
    />
    <path
      d="M595,347q0-1,0-2c2.17.69,2.15,4.14,5,4l4,3c-2.05,1.86-4.44.6-6.53.38C594.37,352,596.87,348.37,595,347Z"
      transform="translate(-429.92 -141.92)"
      fill="#2d2e2f"
    />
    <path
      d="M595,289c-.63-1-2.14-1.41-2-2.95-3.18-5,.36-10,.16-15,.49-1.39.56-3,1.83-4l1-1c2.8.39,1.91,3,2.72,4.55.59,1.86-.06,4.11,1.73,5.61,1.92,4.28-.63,6.75-3.63,9-1.93-.17,0,1.44-.82,1.8Z"
      transform="translate(-429.92 -141.92)"
      fill="#9e8067"
    />
    <path
      d="M596,285c2.28-2.58,5.08-4.92,4-9a2.29,2.29,0,0,1,.71-2.89c1.23-.61,1.52-2.76,3.51-2.16,1.17,1.09.78,2.85,1.76,4a6.71,6.71,0,0,0-1,4,2.55,2.55,0,0,1,.05,3.18,7.26,7.26,0,0,1-5,3.89C598.43,286.86,597,286.65,596,285Z"
      transform="translate(-429.92 -141.92)"
      fill="#b39079"
    />
    <path
      d="M605.06,282.17,605,279h2.92c.81,1.19.64,2-.89,2.27Z"
      transform="translate(-429.92 -141.92)"
      fill="#b39588"
    />
    <path
      d="M596,285l4.1,1c-1.16,1.21-2.71.69-4.09.95C595.91,286.34,594.9,285.68,596,285Z"
      transform="translate(-429.92 -141.92)"
      fill="#897063"
    />
    <path
      d="M607,281.26a2.25,2.25,0,0,0,.89-2.27l1.07-1c-.39,1.33,1,2.66,0,4Z"
      transform="translate(-429.92 -141.92)"
      fill="#130906"
    />
    <path
      d="M610,267c-.17.68-.21,2-1.05.35s-1.8-1.6-2.94-.35c.09,1.05-.33,1.35-1.28.87-1.21-2.28.12-3.75,1.63-5.14.32-.28,1-.63.9-.88-.37-.64-1,0-1.51,0-1.81.38-3.66,1.5-5.35-.27-.85-1.45-1.3-2.82.8-3.63,1.6.29,3.2,3,4.81,0C612,258.12,613.44,261.26,610,267Z"
      transform="translate(-429.92 -141.92)"
      fill="#bf947a"
    />
    <path
      d="M610,267c2.08-6.15,1.84-6.7-4-9,2.75-2.09,5.58-1,5.93,2.41a68.31,68.31,0,0,1,0,7.47Z"
      transform="translate(-429.92 -141.92)"
      fill="#c8a085"
    />
    <path
      d="M601.19,258a2.4,2.4,0,0,0-.2,3c-.57.72,0,2.3-1.7,2.18-1.37-1.35-.75-2.9-.45-4.41L599,252c1.6.86.39,3,1.84,3.95Z"
      transform="translate(-429.92 -141.92)"
      fill="#211d12"
    />
    <path
      d="M500,277c.07-1.39,0-3-1.63-3.18-3.4-.38-1.25-2.44-1.38-3.82-1-4.08-.49-4.87,3.31-4.82,2.79,2.7,3.61,6.13,3.67,9.85C503.69,277.76,502.84,279.38,500,277Z"
      transform="translate(-429.92 -141.92)"
      fill="#d5a78b"
    />
    <path
      d="M504,275l-4-9a11.18,11.18,0,0,1-1.08-1.87c-.25-1.24-1.73-2.89,1-3.1h0c1.24.66,2.26,2.17,4,1l.06-2.11a1,1,0,0,1,1.36.21,5.31,5.31,0,0,1,.82,2.89,9.2,9.2,0,0,1-.49,3.6c-1.9,2.55.44,5.27-.3,7.86L505,275h-1Z"
      transform="translate(-429.92 -141.92)"
      fill="#b28f76"
    />
    <path
      d="M507,282c-1.68-2-.88-4.79-2-7l.05,0c2.43-2.09-1.25-5.23,1.26-7.31a2.19,2.19,0,0,1,1.42.39c1.77,1.71,1.57,3.92,1.59,6.08-.47,2.7-.44,5.55-2.3,7.85Z"
      transform="translate(-429.92 -141.92)"
      fill="#b38c6e"
    />
    <path
      d="M504.81,260.13l-.77-.18a3.19,3.19,0,0,0-1.93-3c-.09-1.39,0-2.83-1.3-3.82,1.28-.71,1.19-1.94,1.19-3.13,1.22-3.15,2.61.5,3.89-.09l.61.53c1.19,2.29.74,4.74.7,7.16a5.37,5.37,0,0,1-.43,1.57C506.31,259.9,505.78,260.47,504.81,260.13Z"
      transform="translate(-429.92 -141.92)"
      fill="#271f1e"
    />
    <path
      d="M500,264q0,1,0,2c-3.47-.52-2.76,2.11-3,4a2.61,2.61,0,0,0-3,0c-1-3.66-2.26-7.33,0-11,1.4.11,3-.46,4.06.95C495.67,262.75,499,262.83,500,264Z"
      transform="translate(-429.92 -141.92)"
      fill="#cb9c7e"
    />
    <path
      d="M494,259q0,5.5,0,11l-.92,1L492,269l-.11-4.77a10.79,10.79,0,0,1,.07-6.33,2.3,2.3,0,0,1,2-2A2.72,2.72,0,0,1,494,259Z"
      transform="translate(-429.92 -141.92)"
      fill="#cfae99"
    />
    <path
      d="M500,264a11.94,11.94,0,0,1-2.33-.65c-.86-.43-2.52.83-2.61-1.19-.1-2.2,1.51-2.14,3-2.21A2.06,2.06,0,0,1,500,261C498.41,262,499.74,263,500,264Z"
      transform="translate(-429.92 -141.92)"
      fill="#c09071"
    />
    <path
      d="M504,262.05c-1.9,1.86-3,.56-4-1Z"
      transform="translate(-429.92 -141.92)"
      fill="#c09071"
    />
    <path
      d="M595,347c1.36,4.63,5.11,5,9,5l5,2.08,2,1.93c-.42,2.52-2.11,2.14-3.76,1.56-1.29-.46-2.7-1-3.81-.13-2.51,2-4,.35-4.36-1.62-.54-3.22-2.28-2.22-4.07-1.81v-1Q595,350,595,347Z"
      transform="translate(-429.92 -141.92)"
      fill="#303135"
    />
    <path
      d="M505,247l2.83-1c1.33,2.15.63,3.46-1.7,4.1l-.25-.19Z"
      transform="translate(-429.92 -141.92)"
      fill="#271f1e"
    />
    <path
      d="M492,257.91q0,3.17-.07,6.33c-1.29-1.91-.44-4-.66-6.07Z"
      transform="translate(-429.92 -141.92)"
      fill="#ba9b86"
    />
    <path
      d="M605,268l1-1c3.12,1.63,1.63,4.58,2,7a2.07,2.07,0,0,0-2,1c-2.72-.3-1.78-2.43-2-4C603,269.54,603.64,268.66,605,268Z"
      transform="translate(-429.92 -141.92)"
      fill="#c8a189"
    />
    <path
      d="M516,293l-3-4-2-4c-.92-1.5-.29-3.08-.29-4.63a5,5,0,0,0-1.46-4.65,4.05,4.05,0,0,1-.56-1.22l.13-.68c.2-.43.4-.86.59-1.29,1.12-2.09-1.21-5.71,2.88-6.46,1.54,4.4,1.34,9.27,3.64,13.47.52,2.2.21,4.52,1,6.69.25,2.14,1.26,4.31-.3,6.37Z"
      transform="translate(-429.92 -141.92)"
      fill="#c4a185"
    />
    <path
      d="M509,274l1,1c1.38,1.38.45,3.69,2,5l-1,5c-1.22-1.15-2.32-2.47-4-3-.49-2.77.94-5.3,1-8A.6.6,0,0,1,509,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#bc977b"
    />
    <path
      d="M530,366c.06-1.15-.12-2.4,1.18-3.07,2.57.79,1.88,2.78,1.7,4.59A4,4,0,0,1,531,370C529.56,369,530.13,367.4,530,366Z"
      transform="translate(-429.92 -141.92)"
      fill="#2e3131"
    />
    <path
      d="M531,370a2.21,2.21,0,0,1,1-2,3.67,3.67,0,0,1,1.3,2.54c.24,1.67.89,3.29.69,5a3.67,3.67,0,0,1-.57,1.35,1,1,0,0,1-1.3.07A18.41,18.41,0,0,1,531,370Z"
      transform="translate(-429.92 -141.92)"
      fill="#222425"
    />
    <path
      d="M532.05,377h.77c2.46,1.61,2.65,3.86,1.79,6.4l-.54.6C532.51,381.92,532.32,379.45,532.05,377Z"
      transform="translate(-429.92 -141.92)"
      fill="#262624"
    />
    <path
      d="M535.23,385l-.2,3-1,1q0-2.47,0-4.94l0-.08C535,383.76,535.36,384.09,535.23,385Z"
      transform="translate(-429.92 -141.92)"
      fill="#1e1f1f"
    />
    <path
      d="M532.38,370.91l-.45-2.9c-.34-1.67.92-3.59-.78-5.06-.44-1-1.54-1.72-.86-3-.07-4.56,2.92-3.3,5.47-2.9.94.33,1.83,1.25,2.89.23a6.7,6.7,0,0,1,5.58,1.55,2.29,2.29,0,0,1,.1,2.12c-1,.81-2.12.43-3.18.54l-.45,0c-.51.29-.52.31,0,0a31.79,31.79,0,0,0,3.9-.07,4.68,4.68,0,0,1,1.35.48c4.89,1.35,9.68-.89,14.54-.38,2.27-.53,4.54-1.15,6.85-.25a1.85,1.85,0,0,1,.91,1.08c-.71,2.93-3.21,2.28-5.22,2.58s-3.9-.08-5.58.07c1.14.44,3.95-.82,3.08,2.59-1.94,1-4,.75-6.1.77-4-.13-7.82-1.36-11.84-1-1.66.14-3.29.15-4.64,1.37s-2.71,4.85-3.73-.17c0-.19-.15.2-.17.28C533.81,369.75,533.68,370.79,532.38,370.91Z"
      transform="translate(-429.92 -141.92)"
      fill="#ccc8c0"
    />
    <path
      d="M536,358c-2,.4-4.8-1.56-5.7,2l-1.48-7,.24-1c3.33-1.07,5.19,1.41,7.38,3.07A2.47,2.47,0,0,1,536,358Z"
      transform="translate(-429.92 -141.92)"
      fill="#bdb6ad"
    />
    <path
      d="M554,367h7a4.18,4.18,0,0,1,4-1.12c3.66.58,4.5-1.53,4.61-4.49,1.33-2,3-2.83,5.21-1.4-.57,4-2.27,7.87-1.75,12,.55,1,.48,1.74-.66,2.2-.91-.29-1-1-1.05-1.84,0-1.24-.61.33-.88-.1-1.09-.21-2-1-3.09-1.11-3.13-.43-6.25.46-9.37,0C555.61,370.88,553.42,370.25,554,367Z"
      transform="translate(-429.92 -141.92)"
      fill="#c9c7c2"
    />
    <path
      d="M574.85,360a5.76,5.76,0,0,0-4.86,2,1.37,1.37,0,0,1-2,0v0c-.59-.92-.17-1.76.22-2.6a4.33,4.33,0,0,1,.86-1,10.94,10.94,0,0,0,3.94-4.25l1-.13c1.89-.06,1.56,1,1.1,2.16C575.32,357.43,573.58,358.62,574.85,360Z"
      transform="translate(-429.92 -141.92)"
      fill="#d1d1ca"
    />
    <path
      d="M572.17,374.32l.93-2.28c.93,3.11,2.41,6.28-.92,9a2.67,2.67,0,0,1-1.16-2.09C570.75,377.2,570.57,375.53,572.17,374.32Z"
      transform="translate(-429.92 -141.92)"
      fill="#303030"
    />
    <path
      d="M575.08,356.12,574,354a3.45,3.45,0,0,1,2.11-2q0,1,0,2Z"
      transform="translate(-429.92 -141.92)"
      fill="#bbb7ad"
    />
    <path
      d="M571.89,379l.28,2L571,384l-.23-1.13a8.35,8.35,0,0,1-.13-3.64A1,1,0,0,1,571.89,379Z"
      transform="translate(-429.92 -141.92)"
      fill="#abaca7"
    />
    <path
      d="M571.89,379l-.84.1A1.8,1.8,0,0,0,570,379c-1.29.19-3.23-.1-3.76.63-3.29,4.59-8,2.77-11.71,2-4.23-.81-8.53-.08-12.72-1.43-2.87-.93-3.77,2.57-5.74,3.81l-.85.93-1.14-1.08c.64-2.5-.3-4.71-1.27-6.91l.46-1c.19-.77.54-1.34,1.47-1.17a3.43,3.43,0,0,1,1.71,4.13c2.17-4.83,4.25-5.82,9.8-3.93,3.14,1.07,6.4,1.64,9.59,2.47,6.11,1.59,10.86-1.53,15.14-5.49.2-.39.15-1.65.88-.58.49.71.23,1.93.3,2.92Z"
      transform="translate(-429.92 -141.92)"
      fill="#d5d2cc"
    />
    <path
      d="M570,379c.4-.77.74-.55,1.06.07q-.14,1.9-.29,3.8C569.57,381.76,570.15,380.31,570,379Z"
      transform="translate(-429.92 -141.92)"
      fill="#dedfd9"
    />
    <path
      d="M522.9,188.73c.22.43.56.81.58,1.21,0,.86-.66,1-1.27.81-.32-.1-.51-.61-.75-.93Z"
      transform="translate(-429.92 -141.92)"
      fill="#252523"
    />
    <path
      d="M505.24,196.73a13.38,13.38,0,0,1,1,1.12,4.72,4.72,0,0,1-1.27,1.38c-.66.34-.86-.21-.66-.75A15.8,15.8,0,0,1,505.24,196.73Z"
      transform="translate(-429.92 -141.92)"
      fill="#1c1c1a"
    />
    <path
      d="M571,181c-3.63-3.12-9.27-1.83-12.62-6.37-1.48-2-5.69-.59-8.64-.57-2.8,0-1.59-1-.74-2.05,3.44,0,6.88.09,10.31,0,4.73-.16,9.49-.58,12.69,4-.15.56-1.23.9-1,1C575.45,178.31,572.14,179.66,571,181Z"
      transform="translate(-429.92 -141.92)"
      fill="#1f1f1d"
    />
    <path
      d="M571,181c-.68-1,2.92-2.61-.52-3.46-1-.25-.87-.85,1.53-1.54a38.91,38.91,0,0,1,9,4l1.41,2.52c-1.89.64-2.95-1.73-4.72-1,.28,2,2.48,2.09,3.3,3.5-2,1-3.51.39-5.2-1C574.36,182.86,573.26,180.94,571,181Z"
      transform="translate(-429.92 -141.92)"
      fill="#21211f"
    />
    <path
      d="M590,178a2.06,2.06,0,0,1-1,2c-5.73-3.54-11.26-7.47-18-9,3.58-2.07,6.68,0,9.65,1.43A99.38,99.38,0,0,1,590,178Z"
      transform="translate(-429.92 -141.92)"
      fill="#242422"
    />
    <path
      d="M506,226a2.06,2.06,0,0,1,1-2c3.41,3.31,1.72,7.37,1.4,11.55,1.54-2.2,1.47-2.2,1.63-5.19.09-1.66-.82-3.89,2-4.36,2.29,2.06.07,5.69,2.67,7.63,1.75,2.07-.66,4.58.71,6.71-1,2.31-.52,5.59-4,6.41a2.9,2.9,0,0,1-2.47-1.33c.64-1.4-1.11-2.14-1-3.41.35-2.62-3-4.21-2-7C506.12,232,505.14,229,506,226Z"
      transform="translate(-429.92 -141.92)"
      fill="#252625"
    />
    <path
      d="M514,234c-2.66.63-1.83-1.52-2-2.65A51.71,51.71,0,0,1,512,226c2-2.67.8-6.4,3-9,1-.26,2.15-.72,2.71.77.43,2.17-.87,4.38.18,6.53a9.16,9.16,0,0,1,0,4.2,20.89,20.89,0,0,1-1.19,3.34A4.59,4.59,0,0,1,514,234Z"
      transform="translate(-429.92 -141.92)"
      fill="#201e1a"
    />
    <path
      d="M523,205c-1.93,2.08-3.51,4.5-6,6a4.07,4.07,0,0,1-4-1c.9-4.91,5.78-6.26,8.55-9.5a1.2,1.2,0,0,1,1.75,0c.61.56.32,1.16-.07,1.71C522.59,203.08,521.54,203.94,523,205Z"
      transform="translate(-429.92 -141.92)"
      fill="#262826"
    />
    <path
      d="M513,210c1.39.14,3-.46,4,1a2.06,2.06,0,0,0,1,2c.4.69,0,1.22-.36,1.74-.77.63-1.24,1.92-2.63,1.25C511.38,215,513.67,212,513,210Z"
      transform="translate(-429.92 -141.92)"
      fill="#22272a"
    />
    <path
      d="M518.47,200.87l-5.87,4.86C513.55,202.12,513.55,202.12,518.47,200.87Z"
      transform="translate(-429.92 -141.92)"
      fill="#2b2b29"
    />
    <path
      d="M515,216l2-2a2.09,2.09,0,0,1,0,3c-.67.08-1.35,1.12-2,0Q515,216.5,515,216Z"
      transform="translate(-429.92 -141.92)"
      fill="#121515"
    />
    <path
      d="M593,202v2c-.73,4.74,1.72,9.26,1,14,.61,5.81,0,11.32-3.93,16,.68,1.2,2.18,2.23.81,3.85-1.76.45-4.73-.84-4.17,2.91a2.63,2.63,0,0,1-1.93,1.75,3.2,3.2,0,0,1-1.37-.09,4.83,4.83,0,0,1-2.14-2.64c-.48-1.89-2.13-3-3-4.62-.5-2.63-1.23-5.37,2.75-5.89,2.53.54,1.76,3.28,3.13,4.71,1.42-.4,1.32-2.05,2.24-2.84,2.77-7,5.67-14,2.65-21.7a49.19,49.19,0,0,1-1.65-6.69A6.34,6.34,0,0,1,587,200c.14-1.38-.46-3,1-4C591.65,196.35,592.26,199.23,593,202Z"
      transform="translate(-429.92 -141.92)"
      fill="#191916"
    />
    <path
      d="M547,181c-.14-1.86-4.38.38-3-3,8.39,2.08,17.32,1.29,25.43,4.94A16.79,16.79,0,0,1,576,188c.41,1.14-.18,1.8-1.1,2.31a134.75,134.75,0,0,0-14.15-6c-1.2-.46-2-.88-3,.12a3.21,3.21,0,0,1-1.38.14C553.47,182.75,549.89,182.79,547,181Z"
      transform="translate(-429.92 -141.92)"
      fill="#20201f"
    />
    <path
      d="M575,190l1-2c4.88,2.89,9.1,6.38,11,12a2.07,2.07,0,0,1,1,2c2.3,5.53-2.53,1.25-3.38,2.46-.69.11-1.57,0-1.77-.53-1.7-4.89-6-8.1-8.19-12.64A1.42,1.42,0,0,1,575,190Z"
      transform="translate(-429.92 -141.92)"
      fill="#21211f"
    />
    <path
      d="M593,202c-2.09-1.65-2.54-4.66-5-6l-1-3c1-.85,2,1,3,0,1.5,1.89,2,4.44,4,6C594,200.1,594.18,201.29,593,202Z"
      transform="translate(-429.92 -141.92)"
      fill="#21211f"
    />
    <path
      d="M590,193c-1,1.59-2,.26-3,0a14.19,14.19,0,0,1-6-8C585.43,186.06,586.27,191.15,590,193Z"
      transform="translate(-429.92 -141.92)"
      fill="#242422"
    />
    <path
      d="M554.83,235.9l1-5,.64-.28a4.22,4.22,0,0,1,3.15,1.39c1.07,1.38,2,2.8,1.87,4.68-1.08,5.84-2.1,11.7-3.6,17.45.05,6.44-2.59,12.81-.44,19.29,2.43,3.84,2,7.16-1.83,9.83a4,4,0,0,1-1.49.5c-1.06,0-2-.18-2.44-1.36.18-1.24,1.1-1.93,2-2.7,1.07-1,1.74-2,.41-3.28a2.5,2.5,0,0,0-3.54-.09c-1.34,1-1.24,2.15-.23,3.35a3.34,3.34,0,0,1,1.18,2.58,1.38,1.38,0,0,1-.83,1.18,5.9,5.9,0,0,1-6.47-3.65,4.12,4.12,0,0,1,.81-3.74c3.41-3.58,3.07-7.83,2.1-12.05-.81-3.53.54-7.32-1.49-10.65a8.18,8.18,0,0,1-.79-3,11.35,11.35,0,0,0-1.57-6.53c-.92-1.39-1.35-3-.13-4.55,1.64-.58.21-1.63.37-2.44a2,2,0,0,1,.72-1.2,2.59,2.59,0,0,1,1.43-.06c2.77,1.73,3.8,4.26,3.67,7.46a18.49,18.49,0,0,0,.43,6.31,11.26,11.26,0,0,1,.34,1.42c.4,2.38,0,4.84.81,7.17.61,2.11.28,4.47,1.79,6.76,1.68-3.66.87-7.24,1.06-10.7a16,16,0,0,1,.36-3.51c.42-4.23,3.25-8.16,1.51-12.63a6.3,6.3,0,0,1-.87-.86A1.07,1.07,0,0,1,554.83,235.9Z"
      transform="translate(-429.92 -141.92)"
      fill="#d8b298"
    />
    <path
      d="M559,225c-1.64-6.94-8-11.25-10-18a1.44,1.44,0,0,1,.44-2.37c1.24-.71,1.51-1.51.57-2.63h0c-.89-3.65,1.66-3.16,3.8-3.17,6.28,6.54,9.57,14.75,12.76,23a3,3,0,0,1-.52,3.22c-1.52,1.08-3.05-.38-4.58,0C560.63,225.22,559.79,225.62,559,225Z"
      transform="translate(-429.92 -141.92)"
      fill="#252523"
    />
    <path
      d="M560.88,236l-2.11-4c-1-1-2.14-1.87-2-3.49l.41-.57,1.85-1c.88-.82,1.68-.43,2.48.13,2.3,1.35,5.43,1.29,6.93,4,1.08-.82.33-2.41,1.41-3.2a1.72,1.72,0,0,1,1.39-.05,5.28,5.28,0,0,1,1.6,2.48,6.44,6.44,0,0,1-.2,4.46,10.72,10.72,0,0,1-4.48,3.85,6.11,6.11,0,0,1-2.93.32,11.54,11.54,0,0,1-3.47-1.16C561.1,237.38,560.63,236.87,560.88,236Z"
      transform="translate(-429.92 -141.92)"
      fill="#1f1f1d"
    />
    <path
      d="M551,227c-.15,2.3,1.64,3.91,2.11,6a1.38,1.38,0,0,1,.11,1.42c-.35,2.45.71,5.06-.81,7.38-3.56.76-2.4-3.05-4-4.16-1.68-1.45-3.74-2.69-3.12-5.46.69-2.15,1.09-4.42,2.47-6.31a2.88,2.88,0,0,1,1.43-.6C550.16,225.4,551.36,225.37,551,227Z"
      transform="translate(-429.92 -141.92)"
      fill="#e6c4a9"
    />
    <path
      d="M544,210c3.3,0,4,2.63,5,5-1,1.27.19,3.54-2,4.29-3.15-.18-3.43-3-4.61-5a4.69,4.69,0,0,1-.22-2.17A2.56,2.56,0,0,1,544,210Z"
      transform="translate(-429.92 -141.92)"
      fill="#24221e"
    />
    <path
      d="M544,210,543,212.13a1.35,1.35,0,0,1-1.23.16A25.35,25.35,0,0,1,538.6,210a6,6,0,0,1-1.31-1.42,3.1,3.1,0,0,1-.54-2.45L540,205C541.72,206.36,544.37,207,544,210Z"
      transform="translate(-429.92 -141.92)"
      fill="#22211e"
    />
    <path
      d="M547,218.95l2-3.94c-.45,2.94,4.25,4.6,2,8a2.56,2.56,0,0,1-2.27.6C546.83,222.54,545.75,221.17,547,218.95Z"
      transform="translate(-429.92 -141.92)"
      fill="#2e2c29"
    />
    <path
      d="M550,202c4.78,2.69-2,3.06-1,5l-2-3C548.45,204,549.91,204,550,202Z"
      transform="translate(-429.92 -141.92)"
      fill="#242321"
    />
    <path
      d="M548.86,223l2.14,0c-.37,1.33,1.82,2.68,0,4l-1.79-1.07A1.92,1.92,0,0,1,548.86,223Z"
      transform="translate(-429.92 -141.92)"
      fill="#261a11"
    />
    <path
      d="M561,228a2.08,2.08,0,0,0-2-1v-2l2-1a3.75,3.75,0,0,1,1.57,2.3C562.49,227.28,562.46,228.29,561,228Z"
      transform="translate(-429.92 -141.92)"
      fill="#272424"
    />
    <path
      d="M552.85,234l.25-1.06,1.73,2.91.23,1.11c0,.8-.43,1.27-1.19.87C552.19,237,552.33,235.55,552.85,234Z"
      transform="translate(-429.92 -141.92)"
      fill="#4a3b2a"
    />
    <path
      d="M555.83,230.92c-1.26-1.46-1.32-3,.26-4.13.61-.44.87.59,1.06,1.16l-.27.19c-.38.94.22,2.11-.71,2.92Z"
      transform="translate(-429.92 -141.92)"
      fill="#2f271f"
    />
    <path
      d="M554,199c-1.26,1.1-3.85.42-4,3-1.15-1.5-3.08-2.85-1-5,1.25-1.18,2.5-.38,3.76,0a2.51,2.51,0,0,1,1.41,1.36Z"
      transform="translate(-429.92 -141.92)"
      fill="#242321"
    />
    <path
      d="M553,198l-4-1v-1l1-3c1.52-.56,2.58.13,3.47,1.27A3.05,3.05,0,0,1,553,198Z"
      transform="translate(-429.92 -141.92)"
      fill="#1a1e20"
    />
    <path
      d="M517,217q0-1.5,0-3l1-1,2-2a3.75,3.75,0,0,1,1.19,2.86,8.13,8.13,0,0,1-.46,3.08c-1.81,2-.75,5.62-3.72,7.05C514.51,221.67,517.6,219.34,517,217Z"
      transform="translate(-429.92 -141.92)"
      fill="#221d18"
    />
    <path
      d="M520.06,214.15,520,211c.72-1.17,1.9-1,3-1l.63,1.06.54.45C523.4,213.34,522.54,215,520.06,214.15Z"
      transform="translate(-429.92 -141.92)"
      fill="#291910"
    />
    <path
      d="M553,194l-3-1c-1.84-.71-2.67-3.1-5-3-.35-2.06-3.21-2.61-3-5v-1h0c4.59-1.23,8.44.51,12.07,3.05,2.06.73-3.06,1.29,0,2.27a5.78,5.78,0,0,1,3.42,3.22,2.53,2.53,0,0,1-.13,1.33c-1.15,1.22-2.43.72-3.71.29Z"
      transform="translate(-429.92 -141.92)"
      fill="#232321"
    />
    <path
      d="M542,185c1.44,1.4,3.56,2.4,3,5-1.62-1-3.06-2.35-5.22-2s-3-1.33-3.78-3Z"
      transform="translate(-429.92 -141.92)"
      fill="#20201e"
    />
    <path
      d="M554,188a34.79,34.79,0,0,0-12-4c.69-1.31,3.19-.81,3-3h2a12.34,12.34,0,0,1,10,3c2.61,1.86,3.82,3.74.09,5.71A2.59,2.59,0,0,1,554,188Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1b19"
    />
    <path
      d="M536.75,206.09l1,2c-.4,1.57-1.73,1.86-3,2.07a8.39,8.39,0,0,0-6.16,4.37c-3.11,2.4-4,5.79-4.27,9.48-.15,2.16-.35,4.33-2.73,5.37a3.52,3.52,0,0,1-1.4.21c-3.79-3.22-.28-6.39.06-9.59.47-3.35,3.54-5.59,3.83-9l-.43.07,1.14-1.18c.76.23,1.56,1,2.31.36,2.07-1.8,4-3.72,6-5.59Z"
      transform="translate(-429.92 -141.92)"
      fill="#cbae94"
    />
    <path
      d="M506,226a9.06,9.06,0,0,1,0,9c-3.94-5.59-1.5-11.45-1-17.23C506.28,220.44,503.44,223.46,506,226Z"
      transform="translate(-429.92 -141.92)"
      fill="#242422"
    />
    <path
      d="M509,244.93l1.87,1.13a1.37,1.37,0,0,1,.63,1.12c-2.28,3.31-.48,8.6-5.18,10.75l-.2-7.83a4.44,4.44,0,0,0,1.7-4.1,4.13,4.13,0,0,0,.3-.92A.53.53,0,0,1,509,244.93Z"
      transform="translate(-429.92 -141.92)"
      fill="#998476"
    />
    <path
      d="M509,244.93a4.13,4.13,0,0,1-.87.15c-.83-1-3.09-1.92-.14-3.08C508.54,242.91,510.16,243.44,509,244.93Z"
      transform="translate(-429.92 -141.92)"
      fill="#161a16"
    />
    <path
      d="M594,271c.45,5-1.93,9.91-1,15-3.32,1.85-1.57,6-3.87,8.5-1,1.06-1.44,2.43-3.13,2.51-1.43-2.94.81-5.36,1.38-7.93a134.11,134.11,0,0,0,2.48-14.71c.92-3,.69-6.22,1.24-9.29.69-3.91-2.61-5.29-4.52-7.57-.34-1.71.71-2.85,1.63-4.05,1.52-1.77,3.09-3.44,5.78-2.45.88,4-.57,8.1,1,12C593.65,265.56,595.3,268.46,594,271Z"
      transform="translate(-429.92 -141.92)"
      fill="#af9179"
    />
    <path
      d="M598,271c-1.88-1.19-.1-3.83-2-5,.66-1-1.58-3.84,1.93-3a19.22,19.22,0,0,0,2.53.71c4.7,1.6,4.91,3.82.8,8.57C600.18,271.83,599.42,270.55,598,271Z"
      transform="translate(-429.92 -141.92)"
      fill="#8d745f"
    />
    <path
      d="M588,241a2,2,0,0,1,2,1c.14,1.19,1.16,1.89,1.63,2.92,2.47,5.41,2.51,5.4-3.54,7.17a3.48,3.48,0,0,1-1.21-2C586.74,247,585.86,243.82,588,241Z"
      transform="translate(-429.92 -141.92)"
      fill="#b29b7d"
    />
    <path
      d="M588.92,252.22c4.4-2.54,3.57-5.47.69-8.61-.51-.56-.21-1.19.39-1.61,2.53,2.47,4.68,5.1,4,9-1.86.85-3.89,1.42-5.22,3.13l-.27-.64A1.8,1.8,0,0,1,588.92,252.22Z"
      transform="translate(-429.92 -141.92)"
      fill="#a99177"
    />
    <path
      d="M588,241l0,10.15a1.84,1.84,0,0,1-1.79-1.28c-.11-2.78-2.55-5.21-1.26-8.21.32-.87,1-.91,1.8-.88Z"
      transform="translate(-429.92 -141.92)"
      fill="#b59e86"
    />
    <path
      d="M594,271c.41-2.66-1-5.54,1-8q0,2,0,4C594.86,268.39,595.44,269.95,594,271Z"
      transform="translate(-429.92 -141.92)"
      fill="#a99177"
    />
    <path
      d="M590.87,237.88l-.81-3.85,1.74.07,1.13,4Z"
      transform="translate(-429.92 -141.92)"
      fill="#61594f"
    />
    <path
      d="M599.89,263.84a1.75,1.75,0,0,1-2-.85c.2-1.43-.13-3,.91-4.24.39,1.38-.28,3,.91,4.21q.43.24.35.55T599.89,263.84Z"
      transform="translate(-429.92 -141.92)"
      fill="#3b2e1f"
    />
    <path
      d="M527.33,343c2.73.64,5.44,1.56,6.28-2.67.31-1.54,1.92-2.56,3.39-3.35,1.69-2.36,2.87-5.28,6.25-5.84,2.3,0,4.59.95,6.9,0a4.54,4.54,0,0,1,2.92.35,2.2,2.2,0,0,1,1.05,2.57c-1.52,1.36-3.41,1.07-5.21,1.12-7.79.22-10.73,3.1-11.31,11.16-.84,2.31-2.92,2.88-5,3.52-1.67.34-3.3.4-4.65-.91-1.26-.63-.32-2.55-1.79-3.06C525.86,344.69,527,344,527.33,343Z"
      transform="translate(-429.92 -141.92)"
      fill="#caa98d"
    />
    <path
      d="M528,349h5c4,.74,6.08,4.28,9.27,6.22a1.35,1.35,0,0,1-.62,1.31c-2.21.71-4.27.86-5.66-1.51-2.76,0-4.32-2.72-6.94-3C528.13,351.19,527,350.48,528,349Z"
      transform="translate(-429.92 -141.92)"
      fill="#bfa58d"
    />
    <path
      d="M534.1,318c-4.42-1.86-6.11-7-10.6-8.88-.52-.22-.36-2.06-.51-3.15a1.62,1.62,0,0,1,1.22-.34c1.77.5,2.88,1.95,4.26,3a30.73,30.73,0,0,0,9.89,5.44C538.52,317.15,536.73,318.06,534.1,318Z"
      transform="translate(-429.92 -141.92)"
      fill="#bfa185"
    />
    <path
      d="M528,309c-1.94-.19-2.72-1.93-4-3s-2.06-2.62-3-4h0a8.13,8.13,0,0,1-2-3q0-.49,0-1a5.51,5.51,0,0,1-.76-5.25c.89-1.48,1.8-1,2.56.08a46.84,46.84,0,0,1,2.49,4.12,9.48,9.48,0,0,1,.59,1.28c.67,3.78,3.7,6.1,5.65,9.09C529.46,308.3,529.5,309.34,528,309Z"
      transform="translate(-429.92 -141.92)"
      fill="#cca88a"
    />
    <path
      d="M534.1,318c1-1.65,3.71-1.6,4.07-3.93a1.52,1.52,0,0,1,1.88-.36c1.56,1.12,1.53,2.2-.06,3.26-.82,2.28-3.34,1.79-4.84,3Z"
      transform="translate(-429.92 -141.92)"
      fill="#2c2014"
    />
    <path
      d="M519,292q0,3,0,6c-2-1.06-3.23-2.6-3-5l0,0a9.12,9.12,0,0,0,1.91-1.21A1.15,1.15,0,0,1,519,292Z"
      transform="translate(-429.92 -141.92)"
      fill="#c4a185"
    />
    <path
      d="M519,299c2,.1,2,1.55,2,3C517.87,302.63,517.8,301.23,519,299Z"
      transform="translate(-429.92 -141.92)"
      fill="#c0a084"
    />
    <path
      d="M521,302c1.62.87,2.93,2,3,4h-1C521.18,305.24,520.91,303.72,521,302Z"
      transform="translate(-429.92 -141.92)"
      fill="#c4a285"
    />
    <path
      d="M568,327.07l.16,2c.17,2.22,2.2,3.76,2.19,6.05a4.1,4.1,0,0,1-4.2,2.58,12.87,12.87,0,0,1-7.41-3.47c-3.17-3.25-7.17-3.59-11.39-3.07a4.59,4.59,0,0,1-2.09-.69,1,1,0,0,1-.4-.82q0-.48.13-.48l8-.1c1.81-1.78,4.12-1.3,6.3-1.44,2.63.45,4.95-2,7.65-.85Z"
      transform="translate(-429.92 -141.92)"
      fill="#a48a71"
    />
    <path
      d="M566.94,326.77c-2.34.68-4.3,2.5-6.94,2.23-2.19-1.36-4.8.3-7-1-2.33-2.91-5.53-.64-8.27-1.31-1.24-.3-1.57-.69-1.73-1.69v0c3.19-3.31,7-2.22,10.73-1.51,3.69,3.64,8.18,1,12.26,1.53Z"
      transform="translate(-429.92 -141.92)"
      fill="#17130d"
    />
    <path
      d="M545,329.16q0,.44,0,.87c.54,1.88-1.53,1.11-2,2-2.6,1-3.61,3.81-6,5l1-3a15.69,15.69,0,0,1,5.22-5.14Z"
      transform="translate(-429.92 -141.92)"
      fill="#bc9e86"
    />
    <path
      d="M553,328c2.32.39,4.89-.94,7,1a19.49,19.49,0,0,1-7,.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#0e0500"
    />
    <path
      d="M540,317a2.37,2.37,0,0,0,.06-2.82l.53-.66c2.36-1.32,4.94-.7,7.44-.89,1.93,0,3.86,0,5.79,0h4.06a10.71,10.71,0,0,1,4.57.68c.12,2.94-1.5,5-4.35,5.31-3.72.34-7.41,1.27-11.2.7-1.62-.14-3.34,1-4.87-.36C543.11,316.5,541.22,317.09,540,317Z"
      transform="translate(-429.92 -141.92)"
      fill="#302e2b"
    />
    <path
      d="M542,319l5-1c2.27,1.58,4.86,1.32,7.42,1.27a10.29,10.29,0,0,1,6.48,1.59c-.52,4.08-1.61,4.57-6.91,3.14-3.64.6-7.45-.67-11,1C543.86,322.79,540.52,321.27,542,319Z"
      transform="translate(-429.92 -141.92)"
      fill="#1e1d1b"
    />
    <path
      d="M571,333c.67.09,1.33,1.12,2,0l3,2q0,1.5,0,3a2.16,2.16,0,0,0-2.13,1.25,2,2,0,0,1-1.73-1.08C571.51,336.51,569.76,335.08,571,333Z"
      transform="translate(-429.92 -141.92)"
      fill="#383538"
    />
    <path
      d="M576,344q0,.5,0,1a11.88,11.88,0,0,1-2,4h-1a1.8,1.8,0,0,1-.51-1.29c0,.63,0,1.26,0,1.89-.39,1.45-2.27,1.81-2.48,3.39v1c-2.26,2.36-4.62,2.85-7.16.43-1.19-1.91-1.18-4,.44-5.39,2.25-1.88,2.59-4.39,3.26-6.87,2.49-2.43,4.87,1,7.33.14A2.43,2.43,0,0,1,576,344Z"
      transform="translate(-429.92 -141.92)"
      fill="#c7a688"
    />
    <path
      d="M573,354.09c.38,3-1,4.64-4,4.91-6.71.56-13.29,3.14-20.16,1.4A6.61,6.61,0,0,1,544,359l-6-1c-.13-2,1.39-1.39,2.38-1.46,3.76-.26,7.52.25,11.28.07,6.05-1.14,12.25-.59,18.32-1.61Z"
      transform="translate(-429.92 -141.92)"
      fill="#d2c8bb"
    />
    <path
      d="M570,355c-5.73,2.61-12,1.83-18,3-.6-.81-2.67-.24-2.06-2.19a3.69,3.69,0,0,1,1.94-.88,9.79,9.79,0,0,1,1.42-.14,29.53,29.53,0,0,0,9-.82l.7,0c2.32,1.76,4.65.51,7,0Q570,354.5,570,355Z"
      transform="translate(-429.92 -141.92)"
      fill="#c6b098"
    />
    <path
      d="M576,344l-2-1c-1.07-.5-2.58-.57-2.37-2.36.55-1.14,1.31-1.48,2.4-.65,1.12.51,2.37.85,3,2.09A1.91,1.91,0,0,1,576,344Z"
      transform="translate(-429.92 -141.92)"
      fill="#ab957e"
    />
    <path
      d="M570,353c-1.77-2.62.51-2.55,2-3a1.34,1.34,0,0,1,0,2A2.07,2.07,0,0,1,570,353Z"
      transform="translate(-429.92 -141.92)"
      fill="#bfa386"
    />
    <path
      d="M572,352l0-2,.19-3.24c1.11.67.69,1.54.83,2.25C573.54,350.29,574.62,351.76,572,352Z"
      transform="translate(-429.92 -141.92)"
      fill="#ba9f7f"
    />
    <path
      d="M574,349a5.46,5.46,0,0,1,2-4C577.25,347.3,575.49,348.08,574,349Z"
      transform="translate(-429.92 -141.92)"
      fill="#bfa07d"
    />
    <path
      d="M574,340a2.13,2.13,0,0,0-2,1c-1,.55-1.74,0-2.55-.39-1.2-1.14-3.64-1.13-3.43-3.61,1.67.12,2.54-1.26,3.76-2a4.72,4.72,0,0,1,3.09,3.34l1,.91Q573.94,339.62,574,340Z"
      transform="translate(-429.92 -141.92)"
      fill="#a28a76"
    />
    <path
      d="M591,274a62.46,62.46,0,0,1-5,23c-.72,4.92-5,8.19-6,13-4.72,1-7.66,3.68-7.92,8.75-1.73,0-2.11-1.17-2.11-2.61-.94-1.15-.53-2.29,0-3.44,2.25-2.64,4.78-5.07,6.43-8.19a22.07,22.07,0,0,0,6.08-9.76c2.54-4,2.26-8.84,3.74-13.17C587.92,279.13,586.91,274.95,591,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#bc9d81"
    />
    <path
      d="M561,321c-4.38.09-8.62-1.56-13-1-1.64.19-1.22-1-.95-2,3.88,1.57,7.6-1.29,11.62-.39,1.13.25,2.9-2.37,4.37-3.67,1.4-.76,2.64-1.07,3.08,1-.8.58-.42,1.05.1,1.58s1.84.59,1.13,1.62c-.23.32-1.5-.08-2.29-.16-1,1.11-1.77,2.48-3.34,2.93Z"
      transform="translate(-429.92 -141.92)"
      fill="#272420"
    />
    <path
      d="M554,324c2.48-.66,5.88.82,7-3h0c2.56-.26.79,2.36,2,3,1.1,0,2.29-.18,3,1C559.51,327.94,556.69,327.7,554,324Z"
      transform="translate(-429.92 -141.92)"
      fill="#191919"
    />
    <path
      d="M566.06,315c-.69-1.35-1.83-1.34-3.08-1l-5-.14a1.43,1.43,0,0,1,0-2,4.26,4.26,0,0,1,1.21-.78c2.28-.77,4.58-1.28,7-.49a18.72,18.72,0,0,1,2.69.72A4.84,4.84,0,0,1,571,313l-1,3.14Z"
      transform="translate(-429.92 -141.92)"
      fill="#c4a994"
    />
    <path
      d="M563,324l-2-3a5.8,5.8,0,0,1,4-3C566.72,320.79,562.45,321.59,563,324Z"
      transform="translate(-429.92 -141.92)"
      fill="#1e1d1b"
    />
    <path
      d="M572.86,338.34,569.77,335c-.91-1.88-2.4-3.61-1.64-5.95L571,333C570.83,335.05,573.42,336.15,572.86,338.34Z"
      transform="translate(-429.92 -141.92)"
      fill="#413835"
    />
    <path
      d="M568.95,326c1.56.08,3.24,0,3.84,2.55-2-.24-2.82-1.55-3.85-2.55Z"
      transform="translate(-429.92 -141.92)"
      fill="#32373d"
    />
    <path
      d="M598,271c.15-1,.45-2,1.75-1.79,1.55.31,1.15,1.71,1.27,2.78a1.3,1.3,0,0,1,0,2l-1,2C595.91,275.74,599,272.56,598,271Z"
      transform="translate(-429.92 -141.92)"
      fill="#8d6f55"
    />
    <path
      d="M601,274l0-2a2.4,2.4,0,0,0,.39-.3c2.81-3.25,1.84-5.78-1.51-7.86a2.65,2.65,0,0,0-.14-.88l1.24-2c1.67,1.83,3.33-.67,5,0,1.84-.08,1.6.88,1,2-.88,1.58-2.42,2.9-2,5l-1,3C602.69,271.68,603.19,274.21,601,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#a3866e"
    />
    <path
      d="M607,263a2.09,2.09,0,0,0-1-2c1.38-1.23,3.08-1.83,3.68.37C610.17,263.19,608.18,262.85,607,263Z"
      transform="translate(-429.92 -141.92)"
      fill="#b0876b"
    />
    <path
      d="M506.33,257.94c2.45-3.31,1.69-8,4.9-11,1.46,0,2.93-.17,4.1,1a2.89,2.89,0,0,1,.37,2.1,2.45,2.45,0,0,1-1.37,1.56c-3.75,1.1-3,4-2.6,6.69a27.18,27.18,0,0,1-.89,6.15,5.32,5.32,0,0,1-1,1.77A4.89,4.89,0,0,1,507,268h-1a1.2,1.2,0,0,1-1-1l.14-4.28c2.08-.84.86-2.51,1-3.85A1.4,1.4,0,0,1,506.33,257.94Z"
      transform="translate(-429.92 -141.92)"
      fill="#aa917a"
    />
    <path
      d="M505,267l1,1c.34,2,1.25,4,1,6.11-.19,1.68-1.1,1.14-2,.87C505.51,272.32,501.2,269.66,505,267Z"
      transform="translate(-429.92 -141.92)"
      fill="#a37c62"
    />
    <path
      d="M506.11,258.85c1.31,1.09.83,2.62,1,4,0,.56.08,1.48-.79,1.31-.46-.09-.76-.94-1.13-1.45l-.34-2.58Z"
      transform="translate(-429.92 -141.92)"
      fill="#4e3924"
    />
    <path
      d="M507,268a3.43,3.43,0,0,1,2-2,7.77,7.77,0,0,1,0,8h-1C508,271.94,508.19,269.86,507,268Z"
      transform="translate(-429.92 -141.92)"
      fill="#b28f76"
    />
    <path
      d="M515,280a22.81,22.81,0,0,1-3-14c-1.56-3.74-1.82-7.16,2.31-9.52a2.46,2.46,0,0,1,2.11,2.24c-.93,5.22-1.63,10.42.18,15.64a5.83,5.83,0,0,1-.22,5.27A1.2,1.2,0,0,1,515,280Z"
      transform="translate(-429.92 -141.92)"
      fill="#d0ae90"
    />
    <path
      d="M515,257c-4.56,1.81-2.43,5.86-3,9-2.4,2.23.4,5.77-2,8a18.07,18.07,0,0,1,0-9c-.28-2.42.42-4.7,1-7,.17-1.88.6-3.59,2.69-4.26a2.69,2.69,0,0,1,1.65,2A1.65,1.65,0,0,1,515,257Z"
      transform="translate(-429.92 -141.92)"
      fill="#bfa084"
    />
    <path
      d="M518,292c.05,1.76-.89,1.53-2,1,.81-2-.06-4,0-6a1.33,1.33,0,0,1,1.36-.19,3.17,3.17,0,0,1,1.39,1.7A3.36,3.36,0,0,1,518,292Z"
      transform="translate(-429.92 -141.92)"
      fill="#cca88a"
    />
    <path d="M510,265v9h-1q0-4,0-8Z" transform="translate(-429.92 -141.92)" fill="#bc977b" />
    <path
      d="M517,287h-1c-1.39-2.18-.93-4.63-1-7h1l.56.52C517.35,282.64,518.71,284.72,517,287Z"
      transform="translate(-429.92 -141.92)"
      fill="#cfab8e"
    />
    <path
      d="M512,280c-3.19-.66-1.56-3.24-2-5C512.34,276,512,278.07,512,280Z"
      transform="translate(-429.92 -141.92)"
      fill="#bfa084"
    />
    <path
      d="M534.12,375.09l-.84.88c.55-1.84-1.87-3.15-.9-5.07l2.34-5.88.48,5.42c2.44-4.55,6.54-5.76,13.91-4.19A19.24,19.24,0,0,0,554,367c1.85,4.94,6.08,2.85,9.3,2.78a22.08,22.08,0,0,1,5.7.22c1.57,3.28-.8,4.26-3.1,4.74-4.41.91-8.91,1.22-13.24-.38-2.66-1-5.49-1.31-8.1-2.41C540.18,370.11,537.66,374.27,534.12,375.09Z"
      transform="translate(-429.92 -141.92)"
      fill="#cecbc5"
    />
    <path
      d="M568,362h2c1.15,3.38,1.73,6.25-3.64,5.12A27.86,27.86,0,0,0,561,367c-2.41-2.27-5.82.05-9.72-2.48,5.38-.42,9.47-1,13.55-.94C566.44,363.59,567.34,363.35,568,362Z"
      transform="translate(-429.92 -141.92)"
      fill="#cbc5be"
    />
    <path
      d="M550,356l2,2c-4.66,1.12-9.32-2-14,0-.69,1.1-1.35.1-2,0q0-1.48,0-3c1.87,1.13,3.95,1,6,1C544.67,354.22,547.34,354,550,356Z"
      transform="translate(-429.92 -141.92)"
      fill="#ccb6a4"
    />
    <path
      d="M561,363c-3.92.14-7.85-.28-11.74.84-1.5.43-3.79.93-4.26-1.85,1.29-1.38,3-1.26,4.67-1.33a16.72,16.72,0,0,1,2.45.07,35,35,0,0,0,6.42.26,3.55,3.55,0,0,1,2.32.59A1,1,0,0,1,561,363Z"
      transform="translate(-429.92 -141.92)"
      fill="#dcd9d0"
    />
    <path
      d="M550,362h-5c-.29-.38-.95-.4-1-1v-2h5C550.07,359.75,551.15,360.5,550,362Z"
      transform="translate(-429.92 -141.92)"
      fill="#ccc9c0"
    />
    <path
      d="M561,363v-1c1.75-4.32,5-2.52,8-2l-1,2C565.63,362.09,563.18,361.61,561,363Z"
      transform="translate(-429.92 -141.92)"
      fill="#d6d6d1"
    />
    <path
      d="M544,361l1,1h-6c-.23-.89-.06-1.39,1-1Z"
      transform="translate(-429.92 -141.92)"
      fill="#d6d7d2"
    />
    <path
      d="M540,361l-1,1c-.79-.14-2-.32-1.42-1.34S539.29,360.1,540,361Z"
      transform="translate(-429.92 -141.92)"
      fill="#d0cfca"
    />
    <path
      d="M534.12,375.09c2.21-4.77,6.23-6.09,11.62-4.26,5.69,1.94,11.44,4.08,17.63,3.11,2.4-.37,5.67.09,5.64-3.94l2,2c-2.47,5.59-11.24,9.27-17,6.61-3.43-1.58-7.1-1.92-10.59-3.16-4.36-1.55-5.15,2.74-7,5.57C535.62,379,536.17,376.48,534.12,375.09Z"
      transform="translate(-429.92 -141.92)"
      fill="#d2cfc8"
    />
    <path
      d="M569,360c-2.85-.08-5.65.06-8,2h-2a10.36,10.36,0,0,0-7,0h-2l-1-3c4.3.4,8.51,1.83,12.81-.83,2.09-1.29,4.71.94,7.19.83Q569,359.5,569,360Z"
      transform="translate(-429.92 -141.92)"
      fill="#cfcdc5"
    />
    <path
      d="M515,248c-1.29-.24-2.73,0-3.77-1.08l-.35-.85c3.45-.61,1.53-4.87,4.12-6.07a3,3,0,0,1,1.84,1,4.66,4.66,0,0,1,1.07,1.91,7,7,0,0,1-.28,4.51C516.91,248.34,516.11,248.87,515,248Z"
      transform="translate(-429.92 -141.92)"
      fill="#342b21"
    />
    <path
      d="M516,241l-1-1c-3.74-1.44.32-4.16-1-6l1.85-2c1.06-.17,2.15-.73,3.09.32a4,4,0,0,1,.54,4.54,3.74,3.74,0,0,1-1.59,1.12C516.56,238.54,517,240.23,516,241Z"
      transform="translate(-429.92 -141.92)"
      fill="#24211a"
    />
    <path
      d="M521,220c.51,3.12-3.16,5.94-.64,9.2a1.82,1.82,0,0,1-.27,1.27,2,2,0,0,1-2.38.71c-.71-.59-1.31-1.22-.84-2.25L517,224c2.1-1.87-.17-5.6,3-7A2.5,2.5,0,0,1,521,220Z"
      transform="translate(-429.92 -141.92)"
      fill="#ba9e8a"
    />
    <path
      d="M516.88,228.92l1.19,2.37a.5.5,0,0,1,0,.85c-.75.09-1.54.95-2.21-.14Z"
      transform="translate(-429.92 -141.92)"
      fill="#7e776e"
    />
    <path
      d="M585,204c.21-.51-.18-1.95,1.16-.69,2.66,2.49,1.47-.53,1.85-1.31,1.31,4.54,4,9.2,3.6,13.6-.46,5.51-.6,11.65-4.6,16.4-2.65-.18-2.63-2.14-2.71-4,1.58-6.17,3.48-12.33.57-18.64C584.09,207.53,583.53,205.74,585,204Z"
      transform="translate(-429.92 -141.92)"
      fill="#1e1f1c"
    />
    <path
      d="M582,230c-4.89.11-2.36,3.85-3,6.06l-.69.14a3.94,3.94,0,0,1-2.15-2.62,36.63,36.63,0,0,1-.57-4.63c-.18-1.38-1.54-2-2-3.23a25.22,25.22,0,0,1,.43-5.49,4.27,4.27,0,0,1,1.48-2.41,2.59,2.59,0,0,1,2.06-.33,2.18,2.18,0,0,1,1,.88c.89,2,.19,4.28.87,6.34a10.67,10.67,0,0,0,.64,1c.87,1.18,2.64,1.3,3.28,2.76C583.41,229.43,583.37,230.32,582,230Z"
      transform="translate(-429.92 -141.92)"
      fill="#201f1d"
    />
    <path
      d="M579,236.06c2.84-.19,3.22,1.6,3.08,3.81l-.18.69c-1.47,1.93-2.73,4.54-5.65,1.72-.16.63-.42,1.1-1.21.79-1.56-1.48-1.4-3.26-.91-5.1.93-2.4,3.13-1.57,4.86-1.92Z"
      transform="translate(-429.92 -141.92)"
      fill="#a78f7d"
    />
    <path
      d="M584.9,241.67c.71,2.88,3,5.4,2,8.66-1.76.81-3.27-.07-4.83-.69a3.49,3.49,0,0,1-1.66-2.21,2.83,2.83,0,0,1,.18-1.31c.31-1,3,0,1.81-2.17a2,2,0,0,1,1.59-1.79Z"
      transform="translate(-429.92 -141.92)"
      fill="#c7ab8b"
    />
    <path
      d="M582,230a2.06,2.06,0,0,0,1-2l.43-.39a2,2,0,0,1,1.14,0l.43.4a5.47,5.47,0,0,0,2,4c-1.64.77-.58,4.49-3.33,3.6S582.25,232,582,230Z"
      transform="translate(-429.92 -141.92)"
      fill="#171d1f"
    />
    <path
      d="M584,242.16,583,244c-.89.32-1.32-.22-1.67-.91a3.45,3.45,0,0,1,.44-2.79l.35-.43C582.91,240.5,582.61,242,584,242.16Z"
      transform="translate(-429.92 -141.92)"
      fill="#a99177"
    />
    <path
      d="M557,189c3.21-1.67.29-3.33,0-5h1c3.8-.28,5.69,3.13,8.66,4.46,7.41,6.1,11.73,14.08,14.17,23.21a10.87,10.87,0,0,1,1.1,5.78,8.42,8.42,0,0,1-.31,1.48c-1.22,2.23,1.28,5.84-2.61,7.08h0c-1.32-2.54.38-5.46-1-8h0a7.59,7.59,0,0,1-1.93-5c-.43-5.35-2.91-9.73-6.07-13.84a11.09,11.09,0,0,1-.76-1.08c-.77-1.72-2.52-2-4-2.59a2.22,2.22,0,0,1-.77-1c-.78-3.34-3.87-1.84-5.81-2.76C557.56,191.16,556.52,190.54,557,189Z"
      transform="translate(-429.92 -141.92)"
      fill="#1f1f1d"
    />
    <path
      d="M566,189c-3.14-.92-5.1-3.7-8-5-.61-1.4-1.32-3.65,1.29-1.87,4.92,3.36,11.75,2.76,15.71,7.87q0,.5,0,1a3.07,3.07,0,0,1-.92,1C570.16,194.33,568.94,189.34,566,189Z"
      transform="translate(-429.92 -141.92)"
      fill="#232321"
    />
    <path
      d="M574,191h1c3.2,3.75,7.27,6.88,8.37,12.11.08.39,1.06.6,1.63.89a8.24,8.24,0,0,0,1,5c1.62,2.9-.79,5.53-.71,8.42,0,1.57-2.43,3-4.29.58.35-2.11-.67-4-1-6,1.84-6.62-3.13-10.76-6-15.45C572.5,194.21,572.43,192.85,574,191Z"
      transform="translate(-429.92 -141.92)"
      fill="#252523"
    />
    <path
      d="M546,250l0,3-.61.25c-1.73-.25-3.18-2.5-5.2-.74a5.88,5.88,0,0,1-1,.77,2.1,2.1,0,0,1-1.26,0,6.06,6.06,0,0,1-1-.79c-1-1.09-2.86-1.16-3.33-2.86.32-2.22-.47-3.66-2.84-4-1.21-.74-2.91-.57-2.44-3.23.67-3.83,2.49-5.1,6.05-4.71a14.39,14.39,0,0,1,6.56,1.57A30.41,30.41,0,0,1,546,250Z"
      transform="translate(-429.92 -141.92)"
      fill="#c6a587"
    />
    <path
      d="M546,253c1.06.19,1.83.67,1.91,1.87.35,5,.68,10.1,1.07,15.14a6.08,6.08,0,0,1-2.18,5.69A4.69,4.69,0,0,0,545,280c-1.18,1.22-2.76,1.67-4.27,2.28-3-1.86-2-4.62-1.16-6.95,1-2.84,1.61-5.23-1.14-7.45-1-.82-.81-2.07.27-3a1.67,1.67,0,0,1,1.38,0c5.29,2.5,5.35,2.46,5.6-3.65.51-2.73-1.2-5.55.32-8.23Z"
      transform="translate(-429.92 -141.92)"
      fill="#c6a587"
    />
    <path
      d="M554,283l1-.06c4.45-2,4.6-5.43,3.25-9.41.34-1.9,1.53-2.5,3.32-2.2,2.36.9,2.67,3.36,3.88,5.14,1.51,2.26-1,4.55,0,6.82a2,2,0,0,1-.35,1.92,3,3,0,0,1-1.37.33,31.54,31.54,0,0,0-5.07-.24c-1.56,0-3.12,0-4.5-.89A1,1,0,0,1,554,283Z"
      transform="translate(-429.92 -141.92)"
      fill="#ae9078"
    />
    <path
      d="M555,254c-.28,4.62,1.19,9.6-3,13.83a22.66,22.66,0,0,1-2-9.83c-1.33-2.54.39-5.47-1-8h0c-.85-1.6-.5-3.26-.25-4.92,2.55-.52,2.35,1.77,3.14,3.05a31.49,31.49,0,0,1,.32,9.41A8.16,8.16,0,0,0,552,259a2.05,2.05,0,0,0,.07.42,1,1,0,0,0,0-.17c.36-1.84.54-3.69,1.67-5.23A1,1,0,0,1,555,254Z"
      transform="translate(-429.92 -141.92)"
      fill="#e5c1a7"
    />
    <path
      d="M551,282c-1.27-1.38-3.55-2.11-2.92-4.71.47-1.95,2.12-2.47,3.64-3,1.73-.62,3,.61,3.74,1.83,2.53,4.06-1.4,4.5-3.52,5.92Q551.48,282.73,551,282Z"
      transform="translate(-429.92 -141.92)"
      fill="#e8c6a9"
    />
    <path
      d="M541,240l-7-1c-1.54-1-3.21-.41-4.82-.41-1.24,0-2.4,0-2.22-1.76a5,5,0,0,1,3.19-1.19c3.18,0,6.37,0,9.55,0,1.47,0,2.95.05,4.17,1.07.14.76,1.17,1.47.15,2.31C543.06,239.5,542.3,240.56,541,240Z"
      transform="translate(-429.92 -141.92)"
      fill="#beab99"
    />
    <path
      d="M560.88,236l1.11,1c.72,1.3,1.59,2.7,1,4.17-1.65,4.37-2.34,9.14-5.36,12.95L557,254C558.1,248,558.67,241.81,560.88,236Z"
      transform="translate(-429.92 -141.92)"
      fill="#caa58a"
    />
    <path
      d="M557,274a1.93,1.93,0,0,1-1.93-2.32c.83-5.88.24-11.91,1.94-17.69h0c2.49,6.36,1.5,12.83.6,19.3Z"
      transform="translate(-429.92 -141.92)"
      fill="#caa58a"
    />
    <path
      d="M541,282c.33-2.68,2.43-1.78,4-2a11.31,11.31,0,0,0,6,3,1,1,0,0,1-.17,1.42,5.47,5.47,0,0,1-3,.89,19.47,19.47,0,0,1-6-.41,2.93,2.93,0,0,1-1.05-.76C540,283.33,542.05,282.8,541,282Z"
      transform="translate(-429.92 -141.92)"
      fill="#b1947b"
    />
    <path
      d="M549,245v5c-1.6-1.42-1.1-3.35-.94-5,.35-3.66-.34-6.78-3.37-9.11a4,4,0,0,1-.06-4.66c.9-.54,1.5-.52,1.37.77-.56,2.6,1.55,3.61,3,5C549.79,239.67,551.1,242.33,549,245Z"
      transform="translate(-429.92 -141.92)"
      fill="#e2c0a6"
    />
    <path
      d="M556,237c1-1,1.68-1.06,1.64.56A32.87,32.87,0,0,1,555,250c-2.34-2.78-.87-5.95-.91-9C554,239.39,555.12,238.26,556,237Z"
      transform="translate(-429.92 -141.92)"
      fill="#e5c1a7"
    />
    <path
      d="M559,274c2,5.73,1.49,6.8-4.05,8.93,2.87-2.48,3.72-5.41,2-8.93h0a1.14,1.14,0,0,1,2,0Z"
      transform="translate(-429.92 -141.92)"
      fill="#bf9885"
    />
    <path
      d="M555,241q0,4.51,0,9,0,2,0,4h-1c-1.86-2.32-1.8-5.13-2-7.87.28-1.38.32-2.8.71-4.17C553.25,241.1,553.89,240.49,555,241Z"
      transform="translate(-429.92 -141.92)"
      fill="#e6c4a9"
    />
    <path
      d="M555,241l-2,1a.65.65,0,0,1-1,0c.39-2.64-.88-5.46.85-8,.95.83-.65,3.56,2.21,3l.93,0Z"
      transform="translate(-429.92 -141.92)"
      fill="#e9ceb4"
    />
    <path
      d="M541,240l3-1a3.38,3.38,0,0,0,.34,4.51c1.73,1.93,1.76,4.15,1.66,6.47Z"
      transform="translate(-429.92 -141.92)"
      fill="#c6a488"
    />
    <path
      d="M545,231l-.3,4.88h-.36l-.36,0a5.26,5.26,0,0,1-2.13-1.66,3.64,3.64,0,0,1-.34-3.93C542.88,229.4,544.19,228.94,545,231Z"
      transform="translate(-429.92 -141.92)"
      fill="#271e13"
    />
    <path
      d="M550.9,284.18,551,283q0-.49,0-1l1,0a2.1,2.1,0,0,0,2,1q0,.45,0,.89c.53,1.59.52,3.07-.84,4.29a2.19,2.19,0,0,1-2.41-.85,2.94,2.94,0,0,1-.45-2A3.07,3.07,0,0,1,550.9,284.18Z"
      transform="translate(-429.92 -141.92)"
      fill="#bbada1"
    />
    <path
      d="M543,234a1.9,1.9,0,0,1,1,1.9q-.07.4-.12.8L540,237a1.52,1.52,0,0,1-.51-1.12,2,2,0,0,1,1.14-1.45C541.36,234,542.3,234.67,543,234Z"
      transform="translate(-429.92 -141.92)"
      fill="#221d14"
    />
    <path
      d="M549,250c2,2.46.56,5.35,1,8C548,255.54,549.43,252.66,549,250Z"
      transform="translate(-429.92 -141.92)"
      fill="#e2c0a6"
    />
    <path
      d="M556.17,231.06c-.23-1.09-.45-2.17.71-2.92l1.88,3.87Z"
      transform="translate(-429.92 -141.92)"
      fill="#caa58a"
    />
    <path
      d="M561,228a2.05,2.05,0,0,0,1-2c.72-1.19,2.13-.28,3-1,1.53-4.75-2.07-8.08-3.5-12-1.83-5-5.75-9-7.5-14h0c4.35-.68,6.47,1.81,7.77,5.45.07,1-.16,2.09.53,2.83,4.75,5.1,5.48,12.06,8.4,18,.36.88.8,1.75.29,2.71h-1c-1.23,1.48.19,3.5-1,5C567.09,230.12,563.42,230.06,561,228Z"
      transform="translate(-429.92 -141.92)"
      fill="#242321"
    />
    <path
      d="M565,225c-.72,1.18-1.9,1-3,1a2.07,2.07,0,0,1-1-2C562.74,222.72,563.72,224.45,565,225Z"
      transform="translate(-429.92 -141.92)"
      fill="#1f1f1d"
    />
    <path
      d="M558,274h-1q0-10,0-20c2.39-5.44,4.85-10.86,5-17l2.82,1c3.29,1.5,7,2.53,8.09,6.65-.18,2.72-1.65,3.91-4.29,3.29-2-.47-3.29-.23-3.2,2.2a3.55,3.55,0,0,1-2.18,2.38,4.48,4.48,0,0,0-3.53,4,18.37,18.37,0,0,0-.32,3.69C559.14,264.89,560.2,269.6,558,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#bb9c80"
    />
    <path
      d="M579,236c-1.12,1.18-3.17.43-4.12,2-.77,1.41-.1,4-2.84,3.8-2.3-.16-4-1.23-4.1-3.84,1.28-1.07,2.07-2.79,4-3,1.3-2.14,3.21-1.25,5-1Z"
      transform="translate(-429.92 -141.92)"
      fill="#1c1914"
    />
    <path
      d="M568,238c3.53,4.11,4.22,4.11,6.93,0,.47,1.67-.16,3.56,1,5.11,1.16,1.3.9,2.38-.51,3.28-1.55.36-2.53-.46-3.33-1.63-1.47-3.28-5.4-3.88-7.27-6.72Z"
      transform="translate(-429.92 -141.92)"
      fill="#22180d"
    />
    <path
      d="M577,234c-1.31,2.12-3.54-.41-5,1q0-2.5,0-5c-.78-1.16-.51-2.43-.4-3.67a1.15,1.15,0,0,1,1.21-.48c.5,2.44,2.68,1.65,4.19,2.15Q577,231,577,234Z"
      transform="translate(-429.92 -141.92)"
      fill="#171a1a"
    />
    <path
      d="M572,226q0,2,0,4a2.07,2.07,0,0,1-1-2l-1-2c-.22-3.45-2.64-6.4-2.22-10a2.06,2.06,0,0,1,1.58-.42C572.72,218.43,574.52,221.66,572,226Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1b1a"
    />
    <path
      d="M569,233c.26-1.68-.66-3.6,1-5C569.55,229.64,571,231.67,569,233Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1714"
    />
    <path
      d="M545,231l-3-.87a2,2,0,0,1-1.74.45,4.66,4.66,0,0,1-1.14-.52,30.44,30.44,0,0,0-2.74-1.62,6.39,6.39,0,0,1-3-2.71c-.68-4.24,2.82-5.84,5.16-8.18a5.3,5.3,0,0,1,3.48-.95c1.46.74,3.06,1.37,3.19,3.37-1.49,1.65-4.38,0-5.57,2.4-.76,1.05-1.4,2.08.35,2.8,2.31.81,4.26-.82,6.43-.93.92.22,2,.32,1.56,1.75a9.51,9.51,0,0,1-2,6Z"
      transform="translate(-429.92 -141.92)"
      fill="#eecdb0"
    />
    <path
      d="M552,242h1c.26,1,1.59,2,0,3-.92.83-.77,2.38-2,3l-2-3q0-4,0-8C550.91,238.12,550.41,240.69,552,242Z"
      transform="translate(-429.92 -141.92)"
      fill="#ecc5a6"
    />
    <path
      d="M545,220l-3-3a1.16,1.16,0,0,1-.41-1.11,3.06,3.06,0,0,1,1.44-2c1.73,1.37,1.85,4,4,5.07a7,7,0,0,0,1.85,4.08l.34,2.9L548,226a2.06,2.06,0,0,0-2-1C545.28,223.41,543.73,222,545,220Z"
      transform="translate(-429.92 -141.92)"
      fill="#dbc8b9"
    />
    <path
      d="M543,213.88a2.25,2.25,0,0,1-1,2.11,12.88,12.88,0,0,0-13,.39c-.86-.58-1.42-1.28-1-2.39,1-5.61,6.36-4.16,9.73-5.91l1.23,1.15c.82,1.16,1.51,2.46,3.1,2.73l.88.16Z"
      transform="translate(-429.92 -141.92)"
      fill="#e0be9d"
    />
    <path
      d="M542.07,212c-3.06,1.38-3-.81-3.1-2.73C540.59,209.47,541.2,210.87,542.07,212Z"
      transform="translate(-429.92 -141.92)"
      fill="#c3ad99"
    />
    <path
      d="M572,226c.58-3.81-.84-7-3-10-1.69-1.53-1.13-4.51-3.6-5.53-1.71-1.62-3.67-3.05-4.4-5.47-.87-3.71-4.13-4.63-7-6l-1-1q0-2,0-4h0c.72-.43,1.22,0,1.73.44,2.83,1,4.32,3.74,6.84,5.13,4.73,4.52,11.81,6.67,13.88,13.88.43,1.52,1.92,2.84.55,4.56l-1,2c-1,.29-1.49,0-1.23-1.13-.54.84.17,1.43.44,2.09.67,1.68.07,3.12-.76,4.53L573,226Z"
      transform="translate(-429.92 -141.92)"
      fill="#1f1f1d"
    />
    <path
      d="M521,220l-1-3,.07-2.82c2.09-.09,2.33-2.52,4-3.17C525.88,215,521.66,216.88,521,220Z"
      transform="translate(-429.92 -141.92)"
      fill="#baa38f"
    />
    <path
      d="M561,200c-3.42-.14-4-4.32-7-5,.75-1.06,2.21,0,3-1v-1c2.56-.61,4,3.39,6.79,1.69A1.22,1.22,0,0,1,565,195h0c1.09,2.1,3,2.14,5,2q0,.5,0,1c1,3.73-1.65,4-4.16,4.13C563.95,202.23,562.5,201,561,200Z"
      transform="translate(-429.92 -141.92)"
      fill="#262624"
    />
    <path
      d="M564,195c-.22,1.63-1,2.52-2.57,1.43s-3-2.28-4.43-3.44-3.34-2.27-4.41-3.82c-1.49-2.17,1-.63,1.41-1.19l3,1a3.46,3.46,0,0,0,2,2C560.95,192,563.51,192.19,564,195Z"
      transform="translate(-429.92 -141.92)"
      fill="#2a2a28"
    />
    <path
      d="M557,194c-.72,1.17-1.89,1-3,1l-1-1C554.34,192.2,555.67,194.36,557,194Z"
      transform="translate(-429.92 -141.92)"
      fill="#2b2b29"
    />
    <path
      d="M528,214l1,2c-.33,3.75-1.85,7.21,1.47,11,1.7,2-2.68,2-4.24,3-1.86.25-3.73.54-5.22-1a5.94,5.94,0,0,0,2.07-4.75C523.22,220.2,523.82,216.19,528,214Z"
      transform="translate(-429.92 -141.92)"
      fill="#debc9f"
    />
    <path
      d="M521,229l6,0a2.21,2.21,0,0,1,2.14-.27c1.1.49,2.73.11,3,1.88-3.37,3-7,1.86-10.68.76a3.35,3.35,0,0,1-1.08-1.22,1.8,1.8,0,0,1-.07-.91A.5.5,0,0,0,521,229Z"
      transform="translate(-429.92 -141.92)"
      fill="#292116"
    />
    <path
      d="M591,274c-2.58,2-1.83,5.75-4,8-2-2.17-1.3-4.71-1-7.19.42-1.61,1.47-2.94,2.09-4.45,1.83-4.42.44-7.88-3.9-10a2.13,2.13,0,0,1-.59-2.08,2.67,2.67,0,0,1,3.28-1.35C593.23,260.5,594.2,264.5,591,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#c8a78c"
    />
    <path
      d="M586.86,256.93,584,258.06a1.5,1.5,0,0,1-2.37-.43,2.7,2.7,0,0,1-.12-1.32,3.14,3.14,0,0,0-.29-3.56,3.29,3.29,0,0,1-.39-1.3,2.09,2.09,0,0,1,1.57-1.27c3.1-.34,4.61,2.09,6.56,3.77l-.19.2Z"
      transform="translate(-429.92 -141.92)"
      fill="#cec6c0"
    />
    <path
      d="M589,253.93c-2.9.08-4-3.66-7-3.32a1.31,1.31,0,0,1-1.14-1.57.8.8,0,0,1,1.22-.12l4.88,1.41,1,.83,1,1.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#48392b"
    />
    <path
      d="M542,355c-4.15-.28-6.51-3.24-9-6,1-1.44,3.48-.91,4-3,1.33-2.37,3-1.63,4.68-.5a27.43,27.43,0,0,1,4,4.25,3.49,3.49,0,0,1,.39,4.12C545.14,355.51,543.75,356,542,355Z"
      transform="translate(-429.92 -141.92)"
      fill="#caa888"
    />
    <path
      d="M541,346a3.27,3.27,0,0,0-4,0c-1.38-5.87,3.15-11.9,9-12,2.65,0,5.3,0,8,0a15,15,0,0,1,7.29,4.86,1.82,1.82,0,0,1-.21,1.34,2.58,2.58,0,0,1-2,.35c-2-.54-3.58-2.07-5.52-2.82-9.65-2.37-11.6-.79-10.57,8.53A1.6,1.6,0,0,1,541,346Z"
      transform="translate(-429.92 -141.92)"
      fill="#d2ae90"
    />
    <path
      d="M566,337l4,3c-.53,1.46-1.82,1.44-3,1.56a3,3,0,0,1-2.78-.14c-2.89-4.13-8-5.59-11.18-9.41h-3c-1.66.49-3.62,1.49-3-1.8,5.49-.58,10.56-.16,14.32,4.76C562.29,336.28,564.8,335.41,566,337Z"
      transform="translate(-429.92 -141.92)"
      fill="#bc9e86"
    />
    <path
      d="M553,332c3.94,2.66,8.74,4.27,11,9l-.64.23c-1.37-.12-1.7-1.34-2.36-2.22-2.57-1.34-5.22-2.56-7-5Z"
      transform="translate(-429.92 -141.92)"
      fill="#c5a489"
    />
    <path
      d="M547,330.2c.24,1.9,1.67,1.79,3,1.8-2.33,2.31-4.67.16-7,0l2-2Z"
      transform="translate(-429.92 -141.92)"
      fill="#c5a489"
    />
    <path
      d="M541,346h2a1.88,1.88,0,0,1,2.17-.24c2.92,3.65,7.58,2.3,11.22,3.9,1.77,2,2.7,4-.36,5.78a1.4,1.4,0,0,1-1.26-.51c-.66-1-1.06-2.86-2.59-2.27s.74,2.22-.19,3.33h-2l-8,0q0-.49,0-1c3.9-.48,5.11-2,2.17-5.33C543.1,348.47,542.06,347.23,541,346Z"
      transform="translate(-429.92 -141.92)"
      fill="#d0ae8c"
    />
    <path
      d="M540.06,314.19l-1.88-.09c-4.82,1.16-7.41-2.15-10.17-5.1a2,2,0,0,0,1-2c-1.15-3.57-4.54-5.64-6-9h0a8.62,8.62,0,0,1-.9-3.49,3.38,3.38,0,0,1,.46-1.3c2.48-1.17,3.09,3,5.54,1.93a4.89,4.89,0,0,1,1.33.26c3.59,3.24,7,6.68,11.45,8.82a3.88,3.88,0,0,1,1.51,2.1c0,1.57,1,2.54,2.14,3.47a2.29,2.29,0,0,1,.62,2.37c-1.41,1.66-3.61.79-5.27,1.65Z"
      transform="translate(-429.92 -141.92)"
      fill="#e2b99a"
    />
    <path
      d="M523,294v4c-2-1.55-2.49-4.11-4-6h-1q0-2,0-4c-.83-2.63-.58-5.52-2-8h0c.09-6-3.11-11.69-1.63-17.92.32-1.36.33-2.44,1.64-3.09a3.39,3.39,0,0,1,3-.78c1.94.89,5.14-.22,5.36,3.38a2,2,0,0,1-1.49,1.14c-4.17.88-5.68,2.81-4.66,7.17,1.42,6.1,2.15,12.35,4.18,18.31C522.72,290.14,521.73,292.18,523,294Z"
      transform="translate(-429.92 -141.92)"
      fill="#d9b497"
    />
    <path
      d="M523,298c2.26,2.83,7.1,3.93,6,9A10.37,10.37,0,0,1,523,298Z"
      transform="translate(-429.92 -141.92)"
      fill="#d7b394"
    />
    <path
      d="M539.9,313.81c-.08-.63-.78-2,.6-1.42,1.78.72,3.07-.46,4.6-.44a2.25,2.25,0,0,1,2.93-.22,1.6,1.6,0,0,1,0,2.16Z"
      transform="translate(-429.92 -141.92)"
      fill="#caae9a"
    />
    <path
      d="M548,313.88v-1.68a1.87,1.87,0,0,1,1.86-.83,9.63,9.63,0,0,1,4.09,1.31,1,1,0,0,1,0,1.28Z"
      transform="translate(-429.92 -141.92)"
      fill="#dcccbf"
    />
    <path
      d="M554,314a6.05,6.05,0,0,0,0-.95,2.1,2.1,0,0,1,1.09-1.53,2.67,2.67,0,0,1,2.51.13l.35.55,0,1.61Z"
      transform="translate(-429.92 -141.92)"
      fill="#c2b2a5"
    />
    <path
      d="M564,341l3,0q.53.33.36.66c-.12.22-.23.33-.35.33-.05,2.79,1.6,6-2.78,7.49-1.67.55-1.19,2.87-1.22,4.51h0a1,1,0,0,1-1.41,0c-2.45-4.93-.16-9,2.41-13Z"
      transform="translate(-429.92 -141.92)"
      fill="#cea88c"
    />
    <path
      d="M567,342q0-.5,0-1l3-1,2,1,2,2C571.24,345.57,569.46,341.4,567,342Z"
      transform="translate(-429.92 -141.92)"
      fill="#c5a489"
    />
    <path
      d="M562,354h1c-2.84,3.13-6.6,1.64-10,2,0-1.69.84-1.63,2-1,3.6-1,1.55-3.15,1-5a3,3,0,0,1,3.65-.56C561,350.65,560.35,352.92,562,354Z"
      transform="translate(-429.92 -141.92)"
      fill="#d2b293"
    />
    <path
      d="M555,355a2.05,2.05,0,0,0-2,1h-1c-.25-1.78-3.71-1.84-2.53-4.1.88-1.67,3-1,4.45-.68C556.22,351.74,555.88,353.38,555,355Z"
      transform="translate(-429.92 -141.92)"
      fill="#c8a784"
    />
    <path
      d="M587,274q0,4,0,8c-1.39,4.32-.07,9.47-4,13l-.53-.5a7.41,7.41,0,0,1-.41-4.88c.69-2.54-.46-5.21.47-7.74a11.23,11.23,0,0,0,1.69-4.73c.48-1.25.73-2.64,2.1-3.33Z"
      transform="translate(-429.92 -141.92)"
      fill="#cfad8f"
    />
    <path
      d="M571,313a2.07,2.07,0,0,1-2-1,5,5,0,0,1,1.06-2.2c.2-.37.42-.73.62-1.1.83-1.8,1.71-3.57,2.72-5.29a2.22,2.22,0,0,1,2.54-.84c.91.56,1.5,1.27,1.07,2.43C576,308.41,573.42,310.65,571,313Z"
      transform="translate(-429.92 -141.92)"
      fill="#d1b08e"
    />
    <path
      d="M577,305l-1-2c-.48-2,1.41-2.59,2.2-3.84,1.77-1.19,1.92-4.25,4.8-4.16l0,0A12.74,12.74,0,0,1,577,305Z"
      transform="translate(-429.92 -141.92)"
      fill="#cfad8f"
    />
    <path
      d="M579,300l-3,3a2.07,2.07,0,0,0-2,1,11.88,11.88,0,0,0-3,6h0c-1.42,1.28-3.6.66-5,2-2.34-2-4.73.36-7.08-.06-.45-1.34.51-2,1.33-2.67a9.71,9.71,0,0,0,3.06-3.14,5.45,5.45,0,0,1,.93-1,6.16,6.16,0,0,1,2.57-1.42c5.15-.77,7.16-4.66,9-8.81,2.39-.29,2.2,2.37,3.62,3.18A2.05,2.05,0,0,1,579,300Z"
      transform="translate(-429.92 -141.92)"
      fill="#dbb296"
    />
    <path
      d="M566,312c1-2.33,3.07-2,5-2a3.47,3.47,0,0,1-2,2Z"
      transform="translate(-429.92 -141.92)"
      fill="#daaf8f"
    />
    <path
      d="M561,309.77a3.47,3.47,0,0,0-2,2.18q-.49.1-1,.23l.09-.33c-.8-.65-3.61-.21-1.35-2.51,1.27-.66,2.56-1.26,4.05-.72a.74.74,0,0,1,.41.72Q561.09,309.77,561,309.77Z"
      transform="translate(-429.92 -141.92)"
      fill="#170400"
    />
    <path
      d="M514,254l-3,4c-1.78-4.92-.72-7.39,3-7A2.07,2.07,0,0,1,514,254Z"
      transform="translate(-429.92 -141.92)"
      fill="#b99c7c"
    />
    <path
      d="M514,254q0-1.5,0-3l1-1c1-.6,1.54,0,2.14.65a8.16,8.16,0,0,1,.49,2.4,4.81,4.81,0,0,1,0,1.24,3.14,3.14,0,0,1-.48,1.15c-.63.57-1.24,1.21-2.19.57A2.07,2.07,0,0,1,514,254Z"
      transform="translate(-429.92 -141.92)"
      fill="#b4a383"
    />
    <path
      d="M517.25,251.12,515,250q0-1,0-2c.88-.15,1.89,0,2.42-1,2.8-.64,2.37,1.3,2.34,2.92C519.28,251.07,518.57,251.72,517.25,251.12Z"
      transform="translate(-429.92 -141.92)"
      fill="#b1a289"
    />
    <path
      d="M515,256l1.91-1a4.08,4.08,0,0,1,2.35,3.32L519,259l-3,0-1-2Q515,256.5,515,256Z"
      transform="translate(-429.92 -141.92)"
      fill="#c1aa90"
    />
    <path
      d="M516,280c2.62,2.18,1.89,5.2,2,8l-1-1Z"
      transform="translate(-429.92 -141.92)"
      fill="#d0ae90"
    />
    <path d="M552,362a5.8,5.8,0,0,1,7,0Z" transform="translate(-429.92 -141.92)" fill="#ccc9c0" />
    <path
      d="M519,250c0-1.26.25-2.69-1.59-3l-.44-5a1.66,1.66,0,0,1,1.39-1.34c3.18.83,3,3.65,3.52,6a5.91,5.91,0,0,1-.18,2.7,2.34,2.34,0,0,1-.87,1A1.52,1.52,0,0,1,519,250Z"
      transform="translate(-429.92 -141.92)"
      fill="#c1a491"
    />
    <path
      d="M518,241l-1,1-1-1c1.28-1-2.18-3.32,1.06-3.78A4,4,0,0,1,518,241Z"
      transform="translate(-429.92 -141.92)"
      fill="#a79585"
    />
    <path
      d="M518,241c-1.33-1-.73-2.5-.89-3.8l1.93-.37a6.4,6.4,0,0,1,7.64-1.37,1.05,1.05,0,0,1,.39,1.43c1.79,2.45,5.1-.16,6.95,2.09-1.32.23-2.76-.51-4,.52,4.1,1.15-3.57,4.41,1,5.48-.06.17-.12.33-.18.5-.38.63-.43,1.43-1,2a4.23,4.23,0,0,1-1.18.49,22.32,22.32,0,0,1-4.16.28A4.79,4.79,0,0,1,521,247C520.1,245,520.83,242.07,518,241Z"
      transform="translate(-429.92 -141.92)"
      fill="#d1b095"
    />
    <path
      d="M526.93,236.27a18.11,18.11,0,0,0-7.92.57,7.76,7.76,0,0,0-.94-4.71,1.41,1.41,0,0,0,0-.85l2.36-1.17a2.31,2.31,0,0,1,.55.1C522.1,233.08,526.93,232.3,526.93,236.27Z"
      transform="translate(-429.92 -141.92)"
      fill="#242112"
    />
    <path
      d="M581,218c3,.87,4.88-.24,3.42-3.28-1.08-2.25-2.79-3.56,1.36-2.83L586,209c2.94,6.51,2.14,12.82-1,19-1.58-2.39-3.75-4.43-4.44-7.36,0-.91-.24-1.85.44-2.64Z"
      transform="translate(-429.92 -141.92)"
      fill="#222220"
    />
    <path
      d="M561,200c3.19.2,7.11,3.66,9-2,6.42,5.17,7.23,12.57,8,20h-2c-1.13-4.53-3.67-10.86-6.48-11.39C564.73,205.71,564.16,201.59,561,200Z"
      transform="translate(-429.92 -141.92)"
      fill="#242422"
    />
    <path
      d="M581,218v3c-.51,2.67,3.27,4.11,2,7h0c-1.71.09-3.24-.18-4-2C581.4,223.77,578.6,220.24,581,218Z"
      transform="translate(-429.92 -141.92)"
      fill="#1c1a17"
    />
    <path
      d="M577,228c-2.43-.11-1.48,2.66-3.15,3.59-1.48-1.72-.57-3.78-.85-5.6h0q.5-.72,1,0A3,3,0,0,1,577,228Z"
      transform="translate(-429.92 -141.92)"
      fill="#171d20"
    />
    <path
      d="M574,226h-1c.37-2,1.49-3.93.17-6-.21-.32-.4-1.4.74-.91A4.87,4.87,0,0,1,575,220C575,222.06,575.19,224.14,574,226Z"
      transform="translate(-429.92 -141.92)"
      fill="#1b1b1a"
    />
    <path
      d="M578,218c2,2.46.56,5.34,1,8C577,223.54,578.44,220.65,578,218Z"
      transform="translate(-429.92 -141.92)"
      fill="#252523"
    />
    <path
      d="M575,246.09c1.55-.6.74-1.93.93-3,1.68-1.51,4.46-.75,5.86-2.84q.07,1.37.15,2.74c-.51.93.19,2.22-.92,3l0,1.09c-1.95,1.67-4.09,2.47-6.62,1.42C573.21,247.34,573.93,246.67,575,246.09Z"
      transform="translate(-429.92 -141.92)"
      fill="#c6a592"
    />
    <path
      d="M574,248.06l7-1,1.06,1.83a9.13,9.13,0,0,0-.88.44,3.33,3.33,0,0,1-1.29.66,13.21,13.21,0,0,1-4.39,0,4,4,0,0,1-1.33-.62,1,1,0,0,1-.3-.86Q573.91,248.06,574,248.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#947e6d"
    />
    <path
      d="M581,246c0-1.07-.19-2.22.92-3l1.08,1C584.11,246.44,582.27,245.93,581,246Z"
      transform="translate(-429.92 -141.92)"
      fill="#cbab8c"
    />
    <path
      d="M583,228c-1-2.25-2.72-4.27-2-7,2.44,1.7,4.61,3.56,4,7Z"
      transform="translate(-429.92 -141.92)"
      fill="#1e1f1c"
    />
    <path
      d="M574,191c-1.22,4.85,2.47,8,5,10.68,3.14,3.34,1.74,7,2.81,10.34L580,212c-3.06-8.64-7-16.73-14-23,1.22-3,2.07-.19,2.73.32C570.33,190.57,571.48,192.78,574,191Z"
      transform="translate(-429.92 -141.92)"
      fill="#272725"
    />
    <path
      d="M570,197c-1.12.82-1.86,2.5-3.68,1.81s-1.11-2.46-1.32-3.81C566.93,195,569,194.67,570,197Z"
      transform="translate(-429.92 -141.92)"
      fill="#242422"
    />
    <path
      d="M564,195l-5-4c2.15,1.1,7.64-2.8,6,4Z"
      transform="translate(-429.92 -141.92)"
      fill="#242422"
    />
    <path
      d="M546,253a23.54,23.54,0,0,1,1,9c-1.65,3.48-4.33,2.85-7.12,1.81a2.29,2.29,0,0,1-1.42-2.33,2.72,2.72,0,0,1,2.37-2.14c3.13-.44,1.65-1.87.76-3.2a6.33,6.33,0,0,0-2.59-4.25C542,248.22,543.86,251.35,546,253Z"
      transform="translate(-429.92 -141.92)"
      fill="#b99a81"
    />
    <path
      d="M537.85,252a1.45,1.45,0,0,1,0,.93,5.33,5.33,0,0,1-1.39,5.39c-1.5,1-3,1.62-4.61.17A5.11,5.11,0,0,1,530.6,256a4.22,4.22,0,0,1,.86-2.56C533.1,250.8,535.44,251.24,537.85,252Z"
      transform="translate(-429.92 -141.92)"
      fill="#494038"
    />
    <path
      d="M535.85,258c1.65-1.31.87-3.59,2-5.09l1,.25a2.55,2.55,0,0,1,2,2.38c.28,2.7-.39,4.58-3.64,4.27C536.41,259.49,535.72,259,535.85,258Z"
      transform="translate(-429.92 -141.92)"
      fill="#e4d9d0"
    />
    <path
      d="M531,245c3.95-.27,5.05,1.25,3,4.76-.56,1.06-1.52,1.07-2.53,1a4.68,4.68,0,0,1-2.49-1.42c-.6-1.18.25-1.72,1-2.3l0,0c1-.31.81-1.25,1-2Z"
      transform="translate(-429.92 -141.92)"
      fill="#d1b095"
    />
    <path
      d="M531,249.65l2.95.11c.91,1.4,3.59-.3,3.86,2.21-1.86.74-4.38-.4-5.65,2-1.62-.36-2-1.52-2-3A2.26,2.26,0,0,1,531,249.65Z"
      transform="translate(-429.92 -141.92)"
      fill="#38281a"
    />
    <path
      d="M540.07,255l-1.22-1.86.13-1.26c3-.13,4,1.26,3.07,4.07C540.95,256.57,540.56,255.68,540.07,255Z"
      transform="translate(-429.92 -141.92)"
      fill="#ad8c75"
    />
    <path
      d="M539,261a2.11,2.11,0,0,0,1,2c.57,1.12-.75,1.29-1,2a6.14,6.14,0,0,0-.41,1.36c5.39,3,3,7,1.6,11-.5,1.41-.75,3.31.83,4.61l1.21.62-1.39.52c-1.66,1.37-3.46,1.25-5.32.54a1.52,1.52,0,0,1-.84-1.16c.74-2.13,3.23-3.19,3.29-5.86s.27-5-3.1-5.68-5.11-2.17-2.78-5.71c.22-.34-.61-.56-1.08-.64-1.79-.19-3.64-.07-5.23-1.15a2.66,2.66,0,0,1-1.09-1.7c.88-2.52,3.12-1.1,4.69-1.65a14.6,14.6,0,0,1,2.06-.27C534,260.16,536.63,259.56,539,261Z"
      transform="translate(-429.92 -141.92)"
      fill="#d5b195"
    />
    <path
      d="M539,265c-1-1.36,1.14-1.1,1-2,2.4.16,5,1.45,7-1,.14,2.32.07,5.14-2,6C542.52,269.11,540.74,266.58,539,265Z"
      transform="translate(-429.92 -141.92)"
      fill="#c49f82"
    />
    <path
      d="M545.84,273.9a2.26,2.26,0,0,1-2.42,1.92c-.82,0-1.24-.62-1-1.31a2.81,2.81,0,0,1,2.46-2.1C545.79,272.39,545.83,273.17,545.84,273.9Z"
      transform="translate(-429.92 -141.92)"
      fill="#c2947f"
    />
    <path
      d="M565.13,283.08c-2.16-2,.69-4.07-.12-6.08-2.33-4.4-3.36-8.72.73-12.75a10.84,10.84,0,0,0,3.07-2.66,5.87,5.87,0,0,1,2.52-1.22,2.31,2.31,0,0,1,2,.65,2.1,2.1,0,0,1-.06,2.07c-.66.81-1.87.06-2.4.73,1.74-.36,2.21,1,2.74,2.28a2.53,2.53,0,0,1-.82,2.72c-5.34,3-5.71,7.59-4.29,12.81a2.74,2.74,0,0,1-1.27,1.72A1.94,1.94,0,0,1,565.13,283.08Z"
      transform="translate(-429.92 -141.92)"
      fill="#d2ae91"
    />
    <path
      d="M567,265c-4.77,3.31-2.6,7.79-2,12-2.32-.87-1.86-3.42-3-5a3.7,3.7,0,0,1-2.06-3.57c.62-3.25,2.77-6.13,2.3-9.64a2.49,2.49,0,0,1,.84-1,1.5,1.5,0,0,1,1.24.31c.9,1.25.87,2.88,1.69,4.16C566.42,263.11,567.56,263.76,567,265Z"
      transform="translate(-429.92 -141.92)"
      fill="#b4987a"
    />
    <path
      d="M564.43,284.88l.18,0c2.15-1.92,4-1.1,5.82.57.63.81,1.17,1.65.61,2.74a3.92,3.92,0,0,1-2,.87c-3.07.47-6.21-.76-9.28.31a1.55,1.55,0,0,1-1.26-.8,3,3,0,0,1,.37-3.08C560.58,284.14,562.49,284.36,564.43,284.88Z"
      transform="translate(-429.92 -141.92)"
      fill="#20241c"
    />
    <path
      d="M559,286v2.85c-.91,1.27-2.18,1.2-3.51,1a3.63,3.63,0,0,1-2.39-1.84l.86-4.08,5,.15A1.29,1.29,0,0,1,559,286Z"
      transform="translate(-429.92 -141.92)"
      fill="#271f0f"
    />
    <path
      d="M561,268a6.78,6.78,0,0,0,1,4c-1.46,0-2.91,0-3,2h-1q0-7.5,0-15c.94-.24,1.4.34,1.78,1.05C561.05,262.57,559.23,265.56,561,268Z"
      transform="translate(-429.92 -141.92)"
      fill="#b19479"
    />
    <path
      d="M570,286c-1.7-.83-3.32-2-5.38-1.07l.51-1.84,1.86-.17c1.45-.72,2.91-1.3,4.51-.46a1.8,1.8,0,0,1,.54,2.68A2.73,2.73,0,0,1,570,286Z"
      transform="translate(-429.92 -141.92)"
      fill="#201f12"
    />
    <path
      d="M559,286q0-1,0-1.95c1.87-.08,3.85-.94,5.43.84C562.56,285,560.67,284.94,559,286Z"
      transform="translate(-429.92 -141.92)"
      fill="#1d1a10"
    />
    <path
      d="M551,248a3,3,0,0,1,2-3l1,9-1,7c-2,.63-1.1-1.57-2-2Z"
      transform="translate(-429.92 -141.92)"
      fill="#eecbb3"
    />
    <path
      d="M551,259l2,2c-.07.59-.19,1.52-.86,1.24C550.72,261.66,551.07,260.2,551,259Z"
      transform="translate(-429.92 -141.92)"
      fill="#e6c4a9"
    />
    <path
      d="M553.91,277.84c0,1.11-.31,2-1.65,2a2.06,2.06,0,0,1-2-1.84c-.21-1.26.53-1.82,1.72-1.85A1.67,1.67,0,0,1,553.91,277.84Z"
      transform="translate(-429.92 -141.92)"
      fill="#fee6c2"
    />
    <path
      d="M526.93,236.27c-1.35-2.65-6.07-2-6-6.06,3.68.94,7.36,1.58,11-.1,2.59-2.46,5.34-1,8.05-.32l-.1.34c1.3,1.4,2.16,2.91,1.07,4.84l-1,1c-3.24,1.3-6.74-.34-10,.92l-3,0A1.41,1.41,0,0,1,526.93,236.27Z"
      transform="translate(-429.92 -141.92)"
      fill="#24221e"
    />
    <path
      d="M530,236.93c3.18-1.92,6.67-.52,10-.92q0,.49,0,1A39.52,39.52,0,0,1,530,236.93Z"
      transform="translate(-429.92 -141.92)"
      fill="#180b02"
    />
    <path
      d="M535,282.82l5.86.31q.24.36.46.73c-.92,1.69-3.79.93-4.18,3.32a3.28,3.28,0,0,1-1.24.7c-3.16,0-6.29-.14-9.12-1.79a2.53,2.53,0,0,1,0-2.47C529.29,281.16,532,281.1,535,282.82Z"
      transform="translate(-429.92 -141.92)"
      fill="#292419"
    />
    <path
      d="M537,286c.36-1.84.36-1.84,4.29-2.15l6.7.13a1.92,1.92,0,0,1-.7,2.1C543.84,289,540.42,287.86,537,286Z"
      transform="translate(-429.92 -141.92)"
      fill="#1f2316"
    />
    <path
      d="M547,285l1-1,2.9.2a1.39,1.39,0,0,1-.12.79c-.93,1.11-1.78,2.55-3.53,2C546.28,286.65,546.43,285.75,547,285Z"
      transform="translate(-429.92 -141.92)"
      fill="#1c1002"
    />
    <path
      d="M541,235l-1.07-4.84H542c.11,1.34-.44,2.86,1,3.87A2,2,0,0,1,541,235Z"
      transform="translate(-429.92 -141.92)"
      fill="#2a2923"
    />
    <path
      d="M547,285c1.29,3.4,2.51-1.18,3.78,0l.16,2a2.55,2.55,0,0,1-1.88,2.74,4.89,4.89,0,0,1-2.11,0,8.1,8.1,0,0,0-5.35.16,12.17,12.17,0,0,1-2.89.36c-1.48-.1-3-.06-3.9-1.61.29-1.7,1.52-.94,2.48-1,.65,0,.63-.86.13-.42s-.32-.89-.41-.22q0-.49,0-1C540.3,285.31,544,288.41,547,285Z"
      transform="translate(-429.92 -141.92)"
      fill="#29281f"
    />
    <path
      d="M549,289.06l1.91-2.08,2.17,1,1.91,1c-.68,3.41-2.95,2.44-5.08,1.85C549.28,290.42,548.74,289.95,549,289.06Z"
      transform="translate(-429.92 -141.92)"
      fill="#b99a8f"
    />
    <path
      d="M561,205c2.29,1,3.31,3.35,5,5,1.3,1.78,2.41,3.64,2,6,1,3.27,2.65,6.4,2,10a53.93,53.93,0,0,1-4.15-10.3,11.78,11.78,0,0,0-3.58-6.23C561.09,208.44,559.31,207.07,561,205Z"
      transform="translate(-429.92 -141.92)"
      fill="#252523"
    />
    <path
      d="M574,248.06q0,.43-.05.85a5.12,5.12,0,0,1-2.67,2.19,6.67,6.67,0,0,1-4.17.75A2.88,2.88,0,0,1,565,250c-1-.6-2.15-1.18-.91-2.57s2.74-2,4.34-1c2.34,1.55,3.18.46,3.64-1.71a4.31,4.31,0,0,1,2.92,1.31Z"
      transform="translate(-429.92 -141.92)"
      fill="#c1a288"
    />
    <path
      d="M559,260l-1-1c0-1.1-.19-2.28,1-3,1.43-1.52,1.86-6.06,5.24-1.75a3.42,3.42,0,0,1,.28,1.35,3.69,3.69,0,0,1-1.42,2.27l-.09.21a2.45,2.45,0,0,0-.53,1.33c-.2,1.22.73,3.09-.83,3.51C559.59,263.47,559.87,261,559,260Z"
      transform="translate(-429.92 -141.92)"
      fill="#a8886d"
    />
    <path
      d="M564.1,255c-2.4-3.44-3.45.4-5.12.94-.17-2.86,1.16-4.2,4-4a2.69,2.69,0,0,1,3.42,1.41,2.56,2.56,0,0,1,0,1.35,1.72,1.72,0,0,1-1.08.77A1.77,1.77,0,0,1,564.1,255Z"
      transform="translate(-429.92 -141.92)"
      fill="#ac8b73"
    />
    <path
      d="M566.11,254.2c-.66-1.26-2-1.56-3.1-2.21l2-2,2.15,1.05a2.66,2.66,0,0,1,.61,1.78,2.83,2.83,0,0,1-.47,1.19A1.15,1.15,0,0,1,566.11,254.2Z"
      transform="translate(-429.92 -141.92)"
      fill="#b09785"
    />
    <path
      d="M568,216c-.87-1.93-2.25-3.69-2-6,3.5.74,2.86,3.57,3,6h-1Z"
      transform="translate(-429.92 -141.92)"
      fill="#191917"
    />
    <path
      d="M528.72,229.11,527,229c.68-1.15,2-.86,3.14-1.17-4.69-3.94-4.87-6.16-1.16-11.81,6.11-4.09,8.71-4.09,13,0q0,.51,0,1l-3,1c-4,1.57-5.63,4.2-5,8l3,2C534.51,230.24,531.6,229.58,528.72,229.11Z"
      transform="translate(-429.92 -141.92)"
      fill="#e9c4a7"
    />
    <path
      d="M545,220c-.29,1.79,2.48,2.94,1,5a5.58,5.58,0,0,1-6,1c-1.21-1.12-1.19-2.54-1-4C539.59,217.11,543,220.6,545,220Z"
      transform="translate(-429.92 -141.92)"
      fill="#f7d5b8"
    />
    <path
      d="M534,226c-1.46-.14-2.06-.76-1.36-2.25a27.4,27.4,0,0,0,2.27-5.35c1.05-4.73,2.86.85,4.1-.4C537.73,220.92,533.53,222,534,226Z"
      transform="translate(-429.92 -141.92)"
      fill="#ebc8aa"
    />
    <path
      d="M528.72,229.11A26.64,26.64,0,0,0,537,228a3.34,3.34,0,0,1,3,1.81l-8.05.32Z"
      transform="translate(-429.92 -141.92)"
      fill="#debc9f"
    />
    <path
      d="M539,222c1.46,1.05.86,2.62,1,4-1.11-.1-2.54.25-2.82-1.34C536.94,223.33,537.88,222.54,539,222Z"
      transform="translate(-429.92 -141.92)"
      fill="#eed3bb"
    />
    <path
      d="M584,260c5.29.18,8,5.59,5.36,10.89A20.51,20.51,0,0,1,587,274h0c-1.63-1.61-1-3.6-.95-5.5s.34-3.9-1.14-5.5a10.06,10.06,0,0,1-1-.74,1.88,1.88,0,0,1-.29-1.78Z"
      transform="translate(-429.92 -141.92)"
      fill="#cfad8f"
    />
    <path
      d="M581.84,256.86a2.14,2.14,0,0,0,2.18,1.2q0,1,0,1.94l0,0a2.43,2.43,0,0,1-2.74.47,2.27,2.27,0,0,1-1-1.85,3.38,3.38,0,0,1,.35-1.41A1.15,1.15,0,0,1,581.84,256.86Z"
      transform="translate(-429.92 -141.92)"
      fill="#c2a796"
    />
    <path
      d="M579.85,249.26l1.3.1.81,1.25-.78,1.35-.28.64a2.46,2.46,0,0,1-3.15.69,2.09,2.09,0,0,1-.9-2.43C577.63,249.92,579,250.07,579.85,249.26Z"
      transform="translate(-429.92 -141.92)"
      fill="#4b413f"
    />
    <path
      d="M581.89,252c.88,1.26,3,2.46.22,3.93C580.78,254.7,581,253.38,581.89,252Z"
      transform="translate(-429.92 -141.92)"
      fill="#fbf9f8"
    />
    <path
      d="M581.89,252l.22,3.93q-.15.45-.27.92l-.72.24a2.41,2.41,0,0,1-.95-1.22c-.47-1.36.11-2.58.55-3.81l.45-.11A3.13,3.13,0,0,0,581.89,252Z"
      transform="translate(-429.92 -141.92)"
      fill="#7c7373"
    />
    <path
      d="M560,350h-4c-4-.53-9,1.93-11-4l.52-.48c1.48-.72,2.92-.11,4.37.13,6.89,1.12,6.89,1.13,8.59-5.17L559,340h2C563.1,343.58,561.61,346.8,560,350Z"
      transform="translate(-429.92 -141.92)"
      fill="#dcb595"
    />
    <path
      d="M545,346h-2c-2.13-2.72-4.4-6.08-.9-8.6A10.55,10.55,0,0,1,554,337l-.51.53a8.85,8.85,0,0,1-4.23.72,12.47,12.47,0,0,0-2,.09c-4,.86-4.14,1.36-1.72,5A2.56,2.56,0,0,1,545,346Z"
      transform="translate(-429.92 -141.92)"
      fill="#dcb595"
    />
    <path
      d="M560,350l1-10v-1l3,2c-.41,4.37-3.4,8.34-2,13C559.32,353.67,560.19,351.57,560,350Z"
      transform="translate(-429.92 -141.92)"
      fill="#d2ac8e"
    />
    <path
      d="M554,337c2.13.24,3.51,1.71,5,3h0a2.36,2.36,0,0,1-2.35.72,4,4,0,0,1-1.19-.52c-.85-.9-2.2-1.58-1.46-3.2Z"
      transform="translate(-429.92 -141.92)"
      fill="#dcb595"
    />
    <path
      d="M564,306l-.11,1.19a6.46,6.46,0,0,1-3,.8c-2.68,0-5.15,1.18-7.81,1.3a9.15,9.15,0,0,1-1.65,0c-3.09-1.09-6.74,0-9.46-2.49L541,305c-.85-.66-1.76-1.3-.81-2.54,3.21-2.39,6.57-.41,9.87-.37,4.8,1.14,9.81.21,14.59,1.46C565.95,304.77,564.78,305.33,564,306Z"
      transform="translate(-429.92 -141.92)"
      fill="#be9f8e"
    />
    <path
      d="M523,294c-2.13-1.31-2.81-2.91-1-5,.77-1.88.58-5,4.16-3.21.51,2.45,2.79.64,3.94,1.59,1,.52,2.06,1,2.16,2.4-1.21,1.06-2.4,2.13-1.8,4A3.51,3.51,0,0,1,529,296h-1c-1.72-.92-1.82-4.52-5-3Z"
      transform="translate(-429.92 -141.92)"
      fill="#dfb99b"
    />
    <path
      d="M552,308.1h1c.83,1.69,3.78-1.19,4,1.85-1.09,1.42,1.14,1,1,1.89l-2.85.29a9.58,9.58,0,0,1-5.43,0l-1.73.05-2.93-.26-1.16-1.83c-.11-2.64,1.47-2.69,3.41-2.26C548.88,308.2,550.39,309,552,308.1Z"
      transform="translate(-429.92 -141.92)"
      fill="#311b0f"
    />
    <path
      d="M529,296a2.08,2.08,0,0,1,1.12-2,2,2,0,0,1,1.34,0c2,1.09,3.42,3,5.11,4.46,1,1.61,3.57,2.09,3.46,4.57l1,2C535.67,303.76,532.22,300,529,296Z"
      transform="translate(-429.92 -141.92)"
      fill="#d9b196"
    />
    <path
      d="M531.67,302.11l5.69,3.09c1.42.78,1.25,1.79.27,2.75-.8.79-.22,2.69-1.75,2.63-1.72-.06-1.19-1.42-1.06-2.58C535.11,305.42,530.59,305.85,531.67,302.11Z"
      transform="translate(-429.92 -141.92)"
      fill="#e7bd9d"
    />
    <path
      d="M523,293c.12-1.39.84-2.29,2.25-1.73A4.28,4.28,0,0,1,528,296C524.3,298.4,524.5,294.28,523,293Z"
      transform="translate(-429.92 -141.92)"
      fill="#ecc2a5"
    />
    <path
      d="M552,308.1c-1.38,1.37-3,1.1-4.55.52-1.8-.69-2.78-.08-3.49,1.49-2.13-.23-3-1.23-2-3.32C545.39,306.56,548.68,307.38,552,308.1Z"
      transform="translate(-429.92 -141.92)"
      fill="#352319"
    />
    <path
      d="M526.07,286c-2.79-1-2.2,2.7-4.08,3-3-4.21-2.48-9.43-3.95-14.08a31.06,31.06,0,0,1-1.19-11.56c.08-1.3.56-1.14,1.29-1.4,2-.72,3.91,0,5.86,0,.33-.49.66-.47,1,0l1,1c.93,1.17-1.81,2.67,0,3.4,2.17.87,3.65-.89,5-2.4.93-1.11,2-1.34,2.84,0,1.74,2.55-2.14,2.47-2,4.66,2.53,1.73,8.13.59,7.53,6.13-.31,2.91.2,6.72-4.35,7.26-1.1-1.21-.4-2.4,0-3.59a5.58,5.58,0,0,0,.6-2.22,4,4,0,0,0-.73-2.14,3.36,3.36,0,0,0-2.76-.77c-2.79.2-6.28-1.16-7.73,2.5-1.3,3.29.32,6,2.72,8.27l-.28,1.88A.46.46,0,0,1,526.07,286Z"
      transform="translate(-429.92 -141.92)"
      fill="#e6bea2"
    />
    <path
      d="M525,262h-1c-.27-3.33-3.94-1-5-3l0-.13a4.2,4.2,0,0,1,1.07-.85,7,7,0,0,1,4-.75c1.65,1.2,4.77.42,4.93,3.64C527.93,262.24,525.89,260,525,262Z"
      transform="translate(-429.92 -141.92)"
      fill="#cfae97"
    />
    <path
      d="M549.76,312.15l5.43,0L554,313C552.57,312.79,551,313.25,549.76,312.15Z"
      transform="translate(-429.92 -141.92)"
      fill="#513e34"
    />
    <path
      d="M585,262c3.86.6,2.26,3.92,2.35,5.8s-.24,4.12-.34,6.2l-2,3a1.55,1.55,0,0,1-1.92.28c-1-1.45-.69-3.2-1.12-4.78-.27-2,.45-3.93.68-5.89S583,262.93,585,262Z"
      transform="translate(-429.92 -141.92)"
      fill="#d9b799"
    />
    <path
      d="M583,282c-.06,2.33,1,4.67,0,7a1.87,1.87,0,0,1-1.22.56,4.4,4.4,0,0,1-2.46-1.22c-1.12-1.17-2.28-2.32-1.74-4.18.77-1.12,2-1.58,3.06-2.4a2.91,2.91,0,0,1,1.24-.34A1.89,1.89,0,0,1,583,282Z"
      transform="translate(-429.92 -141.92)"
      fill="#dbb7a1"
    />
    <path
      d="M582,289h1q0,3,0,6l-4,5q0-1,0-2A14.38,14.38,0,0,1,582,289Z"
      transform="translate(-429.92 -141.92)"
      fill="#d6b294"
    />
    <path
      d="M583,282h-1c-1-1.94-2.25-3.91,1-5h2C584.57,278.76,586.2,281.34,583,282Z"
      transform="translate(-429.92 -141.92)"
      fill="#d8b792"
    />
    <path d="M571,310c-.27-2.64.4-4.8,3-6Z" transform="translate(-429.92 -141.92)" fill="#d6b294" />
    <path
      d="M564,306l1-2c.2-1.37,1.25-2.16,2.06-3.13.28-.32.58-.62.88-.91q1.86-1.73,3.56-3.62a13,13,0,0,0,2.59-4.32,3.85,3.85,0,0,1,1.24-1.44c1.16-.72.73-2.56,2.17-3.09a1.8,1.8,0,0,1,1.92.73c1.52,3.59-.75,5.27-3.4,6.77C576.15,303.16,569.58,304,564,306Z"
      transform="translate(-429.92 -141.92)"
      fill="#d6b294"
    />
    <path
      d="M576,295c.61-2.44,4-3.64,3-6.79.2-.52.49-.61.91-.22l2.07,1c-.39,3.21-.9,6.37-3,9C575.62,299.35,577.89,295.12,576,295Z"
      transform="translate(-429.92 -141.92)"
      fill="#e4c0a0"
    />
    <path
      d="M561,307.1l2.88.09a4.58,4.58,0,0,1-2.92,2.58,6.76,6.76,0,0,1,0-.73A1.28,1.28,0,0,1,561,307.1Z"
      transform="translate(-429.92 -141.92)"
      fill="#2f1a10"
    />
    <path
      d="M561,307.1l0,1.93-4,.92c-.87-1.62-3.51.6-4-1.85C555.65,307.59,558.22,306.45,561,307.1Z"
      transform="translate(-429.92 -141.92)"
      fill="#352319"
    />
    <path
      d="M523.89,258l-3.63,1a10.41,10.41,0,0,1-3.21-5.17,3.65,3.65,0,0,0,0-.62c.51-2,2.75-1.85,3.82-3.15l.34.06a1.34,1.34,0,0,1,1.13-.58,1.7,1.7,0,0,1,1.07.72,3.22,3.22,0,0,1,.14,1.91c-.25,1.09-.9,2.2.13,3.25a2.75,2.75,0,0,1,.81,1.61A1.25,1.25,0,0,1,523.89,258Z"
      transform="translate(-429.92 -141.92)"
      fill="#e9dbd3"
    />
    <path
      d="M517.05,253.8c1,1.76,2.81,3,3.2,5.17l-1.23-.08c-.7-1.29-2.16-2.15-2.11-3.85Z"
      transform="translate(-429.92 -141.92)"
      fill="#9e8c7d"
    />
    <path
      d="M520.9,250c-.63,1.83-2.72,1.9-3.82,3.15-1.68-.83,0-1.39.17-2.06A1.94,1.94,0,0,0,519,250Z"
      transform="translate(-429.92 -141.92)"
      fill="#392a13"
    />
    <path
      d="M522.08,249.95l-.84.14q-.11-1.54-.23-3.09h4a1.65,1.65,0,0,1,.31,2C524.51,250.2,523,249.15,522.08,249.95Z"
      transform="translate(-429.92 -141.92)"
      fill="#cdb5a0"
    />
    <path
      d="M525,248.48V247h5l-1,1.61C527.6,250.17,526.27,250.36,525,248.48Z"
      transform="translate(-429.92 -141.92)"
      fill="#dabea4"
    />
    <path
      d="M531,245c.43,1.21,2.45.67,2.64,2.24-1.38,1-2.43-.51-3.63-.25C529.47,245.89,529.25,245,531,245Z"
      transform="translate(-429.92 -141.92)"
      fill="#c6a587"
    />
    <path
      d="M571,250.17l2.93-1.26,1.09.29c.65.28,1.33.52,1.27,1.43a2.26,2.26,0,0,1-1.63,1.27,4.71,4.71,0,0,1-3.53-.48.83.83,0,0,1-.34-.8Q570.91,250.17,571,250.17Z"
      transform="translate(-429.92 -141.92)"
      fill="#251a08"
    />
    <path
      d="M576,250l-1-.83,4.79.06c-.05,2-1.58,1.7-2.85,1.81C576.37,251,576.32,250.42,576,250Z"
      transform="translate(-429.92 -141.92)"
      fill="#211005"
    />
    <path
      d="M539,261c-2.71.67-5.39-.15-8.08-.13-.1-.85.39-1.28,1.1-1.54,1.61,0,3.21-.23,4.82-.15,3.18.22,3.25-2,3.26-4.21l2,1c1.09.85,3.11,1,2.75,3-.42,2.41-2.29,1-3.56,1.2A11.48,11.48,0,0,0,539,261Z"
      transform="translate(-429.92 -141.92)"
      fill="#a48e7a"
    />
    <path
      d="M530.87,251.18,532.2,254l-1.3,2c-1.07.48-1.76-.13-2.43-.82a6.27,6.27,0,0,1-.7-1.24c-.54-1.48-.61-2.93.94-3.81C529.81,249.43,530.49,250.15,530.87,251.18Z"
      transform="translate(-429.92 -141.92)"
      fill="#dfdbd5"
    />
    <path
      d="M536.81,259.21c-1.45,1.29-3.19.76-4.85.76a1.27,1.27,0,0,1-.39-1.55l.4-.43c1.29,1,2.58.14,3.87,0Z"
      transform="translate(-429.92 -141.92)"
      fill="#6b5447"
    />
    <path
      d="M529.12,254.7l1.78,1.23A2.18,2.18,0,0,1,532,258l0,0a2.32,2.32,0,0,1-3.74-.48C527.38,256.31,528,255.35,529.12,254.7Z"
      transform="translate(-429.92 -141.92)"
      fill="#221b15"
    />
    <path
      d="M530.87,251.18c-.84-.2-1.69-1.08-2.52-.06-1,1.22.7,1.85.68,2.87-1.93.57-2.78,2.93-5,3l-.92-1c-.68-.43-.62-1.08-.52-1.74.12-1.33,1.88-2.51.36-4a3.22,3.22,0,0,0-.87-.29c.42-1.61,2-1,2.93-1.47l4,.13c.84,0,1.74,0,2.07,1Z"
      transform="translate(-429.92 -141.92)"
      fill="#4b4743"
    />
    <path
      d="M536,278l-1,4q0,.41,0,.81c-2.58.56-5.38-.21-7.82,1.24-5.51-.25-4.26-4.86-4.36-7.78s2.43-4.81,5.52-4.19c2.57.52,6-2.15,7.7,1.91-1.29.8-2.68.14-4,.27s-3.08,0-2.92,1.81c.12,1.38,1.54,2,3.06,2C533.42,278,534.7,277.21,536,278Z"
      transform="translate(-429.92 -141.92)"
      fill="#f1caa7"
    />
    <path
      d="M531,264c1.35,3.51-1.8,3.28-3.49,3.84-1.25.41-3.25.86-4.05-.71-1.23-2.4,1.74-2.7,2.55-4.13Z"
      transform="translate(-429.92 -141.92)"
      fill="#e9c2a3"
    />
    <path
      d="M524,257c1.51-1.28,2.85-2.83,5-3a.55.55,0,0,1,.09.71c-1.51,3.2.67,3.21,2.82,3.25q0,1,0,2l-1.08.94-1.87,0c-.82-2.54-4.61.15-5.12-2.92Z"
      transform="translate(-429.92 -141.92)"
      fill="#3c342f"
    />
    <path
      d="M584,267c-.33,2-1.35,3.88-1,6-1.63.86-3.31.17-5,.16-1.49-.12-2.89-.78-4.41-.81-3.5-.06-4.86,1.44-4.19,4.91.31,1.65.93,3.22-.17,4.79A1,1,0,0,1,568,282c-2.78-7.88-2.79-7.88,3.75-13.43A3.38,3.38,0,0,0,573,266c3.22-.91,6.43-.34,9.64.09A7.21,7.21,0,0,1,584,267Z"
      transform="translate(-429.92 -141.92)"
      fill="#e0bca0"
    />
    <path
      d="M583,267c-3.34-.28-6.81.76-10-1l-2.16-2.5L573,263c1.88-1.76,3.76-1.88,5.66,0C579.89,264.54,585.13,261.84,583,267Z"
      transform="translate(-429.92 -141.92)"
      fill="#e3bc9d"
    />
    <path
      d="M578,264c-1.17-2.83-3.37-.44-5-1q0-1,0-1.94c2.39-1.73,4.93-2.52,7.79-1.18l3.2.14,0,2C582.47,264,580.21,263.92,578,264Z"
      transform="translate(-429.92 -141.92)"
      fill="#d5b39a"
    />
    <path
      d="M580.79,259.89,573,261.07l-2-.18c-1.65.54-1.34-.64-1.36-1.54,2.67-1.12,5.57-1.61,8.16-3a3.55,3.55,0,0,1,3,1.58Z"
      transform="translate(-429.92 -141.92)"
      fill="#685144"
    />
    <path
      d="M570.13,259a1.59,1.59,0,0,0,.85,1.91,2,2,0,0,1-2,1.13c-1.16,1-2.31,2.08-4,1a9.57,9.57,0,0,1-1.09-5.18.76.76,0,0,1,.1-1.09l.62-.16.61.2a9.76,9.76,0,0,1,1,.7,3.19,3.19,0,0,0,2.88.25C569.86,257.84,570.28,258.19,570.13,259Z"
      transform="translate(-429.92 -141.92)"
      fill="#af9784"
    />
    <path d="M565,263l4-1a3,3,0,0,1-2,3Z" transform="translate(-429.92 -141.92)" fill="#ccb194" />
    <path
      d="M568,282l1-.06c1.25-.82,2.37-.94,3.22.56l-.18.75-5.06-.33Z"
      transform="translate(-429.92 -141.92)"
      fill="#b0937e"
    />
    <path
      d="M559,260l2.27,2.38c1.48-1.22-.06-3.42,1.73-4.32a13.81,13.81,0,0,1-2,9.93C557,266.17,559.85,262.62,559,260Z"
      transform="translate(-429.92 -141.92)"
      fill="#ac8f70"
    />
    <path
      d="M564,256.86q0,.49-.08,1l-.41.06-.42,0a2,2,0,0,1,.81-2q.4.28.31.62T564,256.86Z"
      transform="translate(-429.92 -141.92)"
      fill="#574238"
    />
    <path
      d="M579.93,288a3,3,0,0,0-.91.22l-2,0a6.63,6.63,0,0,1-1.44.76c-1.66.32-3.27.4-4.59-1l-1-2,1-1c2,.65,3.37-.79,5-1.42a1.76,1.76,0,0,1,1.88.47C577.7,285.81,579.81,286.37,579.93,288Z"
      transform="translate(-429.92 -141.92)"
      fill="#28211b"
    />
    <path
      d="M550,290.08c1.78.13,3.74,1.06,5-1.11l4-.13h1a.94.94,0,0,1,1.32.34,2,2,0,0,1-.35,2.15c-2,1.18-4.33,1.16-6.5,1.72a7.23,7.23,0,0,1-2.95-.27,3.29,3.29,0,0,1-1.69-1.36A1.33,1.33,0,0,1,550,290.08Z"
      transform="translate(-429.92 -141.92)"
      fill="#a58979"
    />
    <path
      d="M571,288l5,.17c-.62,2.7-3.21,1.72-4.82,2.6a6,6,0,0,1-3,0,1.92,1.92,0,0,1-1.42-1.52c.49-1.08,1.73-.64,2.46-1.22Z"
      transform="translate(-429.92 -141.92)"
      fill="#a48f85"
    />
    <path
      d="M569.22,288.08l-2.18,1c-2,1.63-4,1.43-6.07.09a9.61,9.61,0,0,1-.94-.32C562.84,285.54,566.22,289.09,569.22,288.08Z"
      transform="translate(-429.92 -141.92)"
      fill="#28211b"
    />
    <path
      d="M576,284c-1.11,3.1-3,2.36-5,1l1-1.77-.1-.44C573.66,282,575.3,281.39,576,284Z"
      transform="translate(-429.92 -141.92)"
      fill="#2f2a1f"
    />
    <path
      d="M526.07,286l.8-.09L537,287l2.11.16c-1.33,1.49-2.91.5-4.19.89-1.62,1.48-3.3.45-5,.13l-3.3.07C523.5,288.29,526.08,286.82,526.07,286Z"
      transform="translate(-429.92 -141.92)"
      fill="#261a0f"
    />
    <path
      d="M539,289.11l3.09-.21a5.07,5.07,0,0,1,4,0c.31,1.92-1.19,2.35-2.44,3-3.13.54-6.26,1-9.3-.42-.92-1.16-.26-1.71.85-1.91S537.75,289.81,539,289.11Z"
      transform="translate(-429.92 -141.92)"
      fill="#997f72"
    />
    <path
      d="M539,289.11c-1.24,1.74-3.75.07-5,1.84a1.57,1.57,0,0,1-1.95.3.87.87,0,0,1-.26-.82q.11-.42.22-.42l-2-1.84,5-.13Z"
      transform="translate(-429.92 -141.92)"
      fill="#a38779"
    />
    <path
      d="M544,291l2-1.76c.13-.55.43-.69.92-.38l2.08.22,1,1q0,.47,0,.93A4.22,4.22,0,0,1,544,291Z"
      transform="translate(-429.92 -141.92)"
      fill="#a5897a"
    />
    <path
      d="M546.94,288.84q-.47.17-.92.38l-4-.32A3.59,3.59,0,0,1,546.94,288.84Z"
      transform="translate(-429.92 -141.92)"
      fill="#281811"
    />
    <path
      d="M571,250.17l0,1a1.39,1.39,0,0,1-.09,1.34c-1.13,1.15-2.34,1.69-3.74.41l-.09-1.9Z"
      transform="translate(-429.92 -141.92)"
      fill="#382a1d"
    />
    <path
      d="M564,256.86a1.77,1.77,0,0,0-.1-1,4.31,4.31,0,0,1,.21-.84l1.33,0a1.52,1.52,0,0,1-.66,1.95A4.89,4.89,0,0,1,564,256.86Z"
      transform="translate(-429.92 -141.92)"
      fill="#26140a"
    />
    <path
      d="M566.11,254.2a2.53,2.53,0,0,1,.75-.09,2.47,2.47,0,0,1,1.49,2c0,.22,0,.44,0,.66a1.72,1.72,0,0,1-1,.76h-.66a1.55,1.55,0,0,1-1-.77c-.06-.63-.28-1.3.48-1.69Q566.09,254.66,566.11,254.2Z"
      transform="translate(-429.92 -141.92)"
      fill="#fefbfa"
    />
    <path
      d="M566.1,255.12,566,257l-.37.31-.39-.28-.25-.09-.26,0,.66-1.95A.75.75,0,0,0,566.1,255.12Z"
      transform="translate(-429.92 -141.92)"
      fill="#d1c7c7"
    />
    <path
      d="M568.14,257l-1.28-2.86.39-1.14a5.62,5.62,0,0,0,3.65-1c1.34.61,2.44,1.86,4.13,1.54,1.2-.2,2.39-.36,3.33.69A2.14,2.14,0,0,1,578,257c-2.43,1.4-4.49,4.25-7.85,2l-1-1.11A1.36,1.36,0,0,1,568.14,257Z"
      transform="translate(-429.92 -141.92)"
      fill="#3e3732"
    />
    <path
      d="M578,264c1.59-1.92,4.18-.81,6-2l1,0a8.3,8.3,0,0,0-1,5h-1c-.19-1.47.28-3.85-2.48-2C579,266,578.21,265.88,578,264Z"
      transform="translate(-429.92 -141.92)"
      fill="#e2bc9d"
    />
    <path
      d="M578,257l0-3,.6-.26c1.28.17,1.7,1.25,2.28,2.16l.23,1.19a5.63,5.63,0,0,1-.32.87Z"
      transform="translate(-429.92 -141.92)"
      fill="#51403c"
    />
    <path
      d="M578,254l-2.88,1a2.77,2.77,0,0,1-.36-3.89L576,250l1,1,1,1.92q.52.34.35.68T578,254Z"
      transform="translate(-429.92 -141.92)"
      fill="#43413c"
    />
    <path
      d="M578,254q0-.51,0-1l2.72-.92.17,3.84Z"
      transform="translate(-429.92 -141.92)"
      fill="#32292a"
    />
    <path
      d="M556,340h3a38.14,38.14,0,0,1-.09,4.43c-.37,2.76-1.93,4-4.8,3.42-3-.64-6.06-1.25-9.09-1.87q0-1.49,0-3c-2.76-4.73,1.62-4.7,4-6h5l2,3a2.08,2.08,0,0,1-1.83.7c-1.26-.39-2.39-1.81-3.85-.44-1.9,1.68-1.19,2.85.83,3.46,1.47.44,3.25,1.32,4.19-.9C555.71,341.93,555.4,340.85,556,340Z"
      transform="translate(-429.92 -141.92)"
      fill="#e6be9d"
    />
    <path
      d="M549,337c-1.79,1.7-4.93,2.49-4,6-1.66-.13-2.9-.82-2.84-2.66,0-1.54,1.38-2,2.54-2.68A8.74,8.74,0,0,1,549,337Z"
      transform="translate(-429.92 -141.92)"
      fill="#dcb796"
    />
    <path
      d="M540,303c-1.23-1.45-3.34-2-4.07-4,2-1.42,3.93-.12,5.89.08,1.43.47,2.92.7,4.38,1,4.65.64,9.3,1.4,13.79-.76a11.52,11.52,0,0,1,2-1.09,8.6,8.6,0,0,1,3.12-.49,4.63,4.63,0,0,1,3,1A1.89,1.89,0,0,1,568,301h0c-5.7,3.62-11.92,2.51-18.07,2C546.65,303.62,543.34,301.63,540,303Z"
      transform="translate(-429.92 -141.92)"
      fill="#a57d68"
    />
    <path
      d="M550,303A65,65,0,0,0,568,301a7.09,7.09,0,0,1-3,3C559.93,304.47,554.89,304.52,550,303Z"
      transform="translate(-429.92 -141.92)"
      fill="#a7826e"
    />
    <path
      d="M532,290a5.74,5.74,0,0,0,.12.89,4.52,4.52,0,0,1-.68,2.81l-.48.35-.83-.1C528.7,291.68,527.19,289.35,532,290Z"
      transform="translate(-429.92 -141.92)"
      fill="#8f715e"
    />
    <path
      d="M541.89,300,536,299a17.49,17.49,0,0,1-5-5l.09-.12c.4-.42.59-1,1.19-1.28a7.87,7.87,0,0,1,2.94.47,4.58,4.58,0,0,1,1.1.51,4.65,4.65,0,0,1,1.36,2,4,4,0,0,0,2.41,1.72,5.29,5.29,0,0,1,2.13,1.49A1.13,1.13,0,0,1,541.89,300Z"
      transform="translate(-429.92 -141.92)"
      fill="#8f715e"
    />
    <path
      d="M536,278c-.76.32-1.54.59-2.27,1-3.09,1.55-5.55.14-6.25-2.56-.88-3.4,2.35-3.07,4.52-3.4.22,3.37,3.18,2.22,5,3A2,2,0,0,1,536,278Z"
      transform="translate(-429.92 -141.92)"
      fill="#f6cbad"
    />
    <path
      d="M537,276a5.42,5.42,0,0,1-4.6.65c-2.82-1-1.87-2.28-.37-3.66a6.72,6.72,0,0,1,4,1Z"
      transform="translate(-429.92 -141.92)"
      fill="#f2d0b2"
    />
    <path
      d="M578,272a8.23,8.23,0,0,1,5,1,3.27,3.27,0,0,1,0,4c-1.67,1.4-.76,3.32-1,5h-1c-1.69.44-2.3-.72-2.88-1.93a25.75,25.75,0,0,1-.47-5.22A4.45,4.45,0,0,1,578,272Z"
      transform="translate(-429.92 -141.92)"
      fill="#e4be9f"
    />
    <path
      d="M579,280a3.46,3.46,0,0,0,2,2c-.12,2.09-1.67,2-3.12,2L576,284c-1-1.53-2.75-.66-4.06-1.21-.75-1.07-1.92-.69-2.93-.87a11.69,11.69,0,0,0,0-2c-1.65-8.71.16-10.32,9-8l1,2a3.12,3.12,0,0,1-1.8.93c-1.86.3-3.67-1.21-5.53-.13a2.92,2.92,0,0,0-.42,2,2.33,2.33,0,0,0,1.34,1.64C574.73,279,577.17,278.21,579,280Z"
      transform="translate(-429.92 -141.92)"
      fill="#e6c2a6"
    />
    <path
      d="M575,292a6.45,6.45,0,0,1-3,5,.78.78,0,0,1-1.26,0c-.77-1.55-.13-3,.43-4.37a2.84,2.84,0,0,1,1-1.12A2.38,2.38,0,0,1,575,292Z"
      transform="translate(-429.92 -141.92)"
      fill="#8c705c"
    />
    <path
      d="M575,292l-3,0c-1.5.76-2.76.12-4-.69a1,1,0,0,1,0-1.27l3-.1c1.92-.25,4.23-1.88,5.16,1.43Z"
      transform="translate(-429.92 -141.92)"
      fill="#886d5f"
    />
    <path
      d="M576.22,291.38c-1.22-2.26-3.41-1-5.16-1.43,1.22-1.75,3.65-.15,4.92-1.76l1,0C576.5,289.21,579,291,576.22,291.38Z"
      transform="translate(-429.92 -141.92)"
      fill="#bea690"
    />
    <path
      d="M571,296.93l1,.07a10.11,10.11,0,0,1-4,4q0-1,0-2C568.44,297.56,569.19,296.51,571,296.93Z"
      transform="translate(-429.92 -141.92)"
      fill="#a4856d"
    />
    <path
      d="M522.95,250.24c2.86,1.17.1,2.61.19,3.91-.75-.55-.64-1.24-.32-2Z"
      transform="translate(-429.92 -141.92)"
      fill="#ccc1b8"
    />
    <path
      d="M522.82,252.18l.32,2,0,1.82C519.88,254.94,522.31,253.49,522.82,252.18Z"
      transform="translate(-429.92 -141.92)"
      fill="#f8f6f4"
    />
    <path
      d="M574.77,251.15l.36,3.89c-2.46.44-3.82-.64-4.23-3a.84.84,0,0,0,.17-.78Z"
      transform="translate(-429.92 -141.92)"
      fill="#d2d4cd"
    />
    <path
      d="M568.14,257l1,.9c-1.25,3.06-2.61,1.07-3.94.08a.72.72,0,0,1,.82-.42l1,0a.5.5,0,0,0,.67-.51A.41.41,0,0,1,568.14,257Z"
      transform="translate(-429.92 -141.92)"
      fill="#e5d5ca"
    />
    <path
      d="M566,258l-.85,0a1,1,0,0,1,.08-.93,5.91,5.91,0,0,1,.77,0l0,0q.48.33.34.68T566,258Z"
      transform="translate(-429.92 -141.92)"
      fill="#f2e5df"
    />
    <path
      d="M532,293.07l-.93.87c0-1.15-.15-2.33,1.07-3l1.86,0,10,0,6,0,1,1c-2.7,2.35-6,1-9,1.44-2-.09-4,1-6.09.13C534.6,293.56,533.42,292.14,532,293.07Z"
      transform="translate(-429.92 -141.92)"
      fill="#8c705f"
    />
    <path
      d="M568,291a7,7,0,0,1,4.05,1q0,.47-.09.94a3.41,3.41,0,0,1-2.77,1,7.25,7.25,0,0,1-1.49-.22,14.11,14.11,0,0,0-8,.18c-1.87.33-3.72.54-5.45-.52A1,1,0,0,1,554,292a19.41,19.41,0,0,1,7-1A6.71,6.71,0,0,1,568,291Z"
      transform="translate(-429.92 -141.92)"
      fill="#866a57"
    />
    <path
      d="M568,291l-7,0q0-.89,0-1.79l6.07-.09,1,1Z"
      transform="translate(-429.92 -141.92)"
      fill="#91776b"
    />
    <path
      d="M554,292q0,.5,0,1c-2.64,2.26-5.82,1.07-8.76,1.37-1.67-.31-3.89.34-4.22-2.36l10,0Z"
      transform="translate(-429.92 -141.92)"
      fill="#725849"
    />
    <path
      d="M566,258l0-1,1,0a.67.67,0,0,1-.18,1l-.41,0Z"
      transform="translate(-429.92 -141.92)"
      fill="#d1c7c7"
    />
    <path
      d="M566.86,258l.18-1h.6C567.77,257.64,567.37,257.88,566.86,258Z"
      transform="translate(-429.92 -141.92)"
      fill="#fefbfb"
    />
    <path
      d="M554,340h2c.8,1.66,1.75,3.45.18,5-2.1,2.12-4.32-.28-6.53-.22s-1.54-2.19-1.92-3.47c-.56-1.89.88-2.17,2.27-2.34C551,340.61,552.22,341.44,554,340Z"
      transform="translate(-429.92 -141.92)"
      fill="#edc3a2"
    />
    <path
      d="M554,340c-.2,1.5-.42,3-2.58,2.17-1.6-.58-2.4-1.46-1.42-3.17C551.53,338.54,552.94,338.56,554,340Z"
      transform="translate(-429.92 -141.92)"
      fill="#efc8a5"
    />
    <path
      d="M562,299l-.94,1c-4.36,2.2-9,1.29-13.6,1.37-1.19-.71-.49-1.32.1-1.94,3.28-1.23,6.81-1.36,10.16-2.3a5.91,5.91,0,0,1,3.2,0C561.68,297.58,562.3,298,562,299Z"
      transform="translate(-429.92 -141.92)"
      fill="#6b4033"
    />
    <path
      d="M569,293l3-.05-1,4-3,2.1-3,0c-.61-.91-.14-1.69.27-2.49a5.59,5.59,0,0,1,1.36-1.39A13.57,13.57,0,0,0,569,293Z"
      transform="translate(-429.92 -141.92)"
      fill="#7a6659"
    />
    <path
      d="M547,301a55.68,55.68,0,0,0,14-.9c-4.85,3.22-10,2.35-15.12,1A.75.75,0,0,1,547,301Z"
      transform="translate(-429.92 -141.92)"
      fill="#754f43"
    />
    <path
      d="M547,301,546,301c-1.41-.1-3,.34-4.06-1a3.4,3.4,0,0,0,0-.92,3.87,3.87,0,0,1,2.43-1.9,4.18,4.18,0,0,1,3.83.56A1.77,1.77,0,0,1,548,300Z"
      transform="translate(-429.92 -141.92)"
      fill="#69473a"
    />
    <path
      d="M566,296.92,565,299l-3,0L560.88,298a1.18,1.18,0,0,1,.23-1.34A4.42,4.42,0,0,1,564,296,3.12,3.12,0,0,1,566,296.92Z"
      transform="translate(-429.92 -141.92)"
      fill="#503a2e"
    />
    <path
      d="M541,292c1,1.52,2.6.83,4,1a1,1,0,0,1-.21,1.41,8.57,8.57,0,0,1-4.75.87,6.43,6.43,0,0,1-3.8-1.24l-1.2,0q-.4-.32-.29-.66T535,293C537.1,293.36,539,292.33,541,292Z"
      transform="translate(-429.92 -141.92)"
      fill="#978174"
    />
    <path
      d="M544.12,297.8a2.56,2.56,0,0,1-2.25,1.32L540,298.07a1,1,0,0,1,0-1.36,3.49,3.49,0,0,1,3.66-.22A1,1,0,0,1,544.12,297.8Z"
      transform="translate(-429.92 -141.92)"
      fill="#51382c"
    />
    <path
      d="M536.22,294.05l3.84.07c.55,1.3-.28,2.15-1,3-1.12.28-1.67-.33-2-1.29Z"
      transform="translate(-429.92 -141.92)"
      fill="#c8b5ab"
    />
    <path
      d="M537.09,295.88l2,1a.65.65,0,0,1,.95.33,7.57,7.57,0,0,1-.05.91C538.76,297.66,536.5,298.64,537.09,295.88Z"
      transform="translate(-429.92 -141.92)"
      fill="#614635"
    />
    <path
      d="M535,293l0,1-3-.93C532.93,291.42,533.94,291.81,535,293Z"
      transform="translate(-429.92 -141.92)"
      fill="#4a2b1a"
    />
    <path
      d="M577,274h2q0,3,0,6c-2.65-.44-5.54,1-8-1C572.78,277.08,575.47,276.24,577,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#efc6a7"
    />
    <path
      d="M577,274c-.37,3.62-2.84,4.72-6,5a2.06,2.06,0,0,1-1-2c.89-1,1.46-2,0-3C572.34,271.69,574.67,273.84,577,274Z"
      transform="translate(-429.92 -141.92)"
      fill="#f1caab"
    />
    <path
      d="M570,274c1.17.22,2.6-.53,3.54.93-.7,1.55-2.51,1.18-3.55,2.07Z"
      transform="translate(-429.92 -141.92)"
      fill="#e9cdaf"
    />
    <path
      d="M545,293.83q0-.4-.06-.8l9,0,6.06,0a.7.7,0,0,1,1.21.17,1.35,1.35,0,0,1-.54,1.34,5.22,5.22,0,0,1-2.18.7,53.53,53.53,0,0,1-10,.14C547.25,295.18,545.88,295.11,545,293.83Z"
      transform="translate(-429.92 -141.92)"
      fill="#836b5b"
    />
    <path
      d="M561,293.81q0-.4,0-.8a11.14,11.14,0,0,1,6.94,0l1,0c.09,1.45.09,2.85-1.87,3-.95-1.42-2.43-.76-3.7-.94A2.87,2.87,0,0,1,561,293.81Z"
      transform="translate(-429.92 -141.92)"
      fill="#8f7b6e"
    />
    <path
      d="M567.94,293,561,293l-.95,0A7.4,7.4,0,0,1,567.94,293Z"
      transform="translate(-429.92 -141.92)"
      fill="#6a5344"
    />
    <path
      d="M544.12,297.8q-.14-.32-.26-.64a4,4,0,0,1,3.22-1.47c4.2.3,8.45-.62,12.64.34a3,3,0,0,1,1.4,1.13q-.13.4-.25.81l-2.89.14c-3.34.16-6.67,1.7-10,0Z"
      transform="translate(-429.92 -141.92)"
      fill="#b0908c"
    />
    <path
      d="M548,298.12h10A23.39,23.39,0,0,1,548,300Z"
      transform="translate(-429.92 -141.92)"
      fill="#765047"
    />
    <path
      d="M563.9,294.14c1.18.45,4-1.88,3.19,1.91l-1.09.87-2.08-.15A1.9,1.9,0,0,1,563.9,294.14Z"
      transform="translate(-429.92 -141.92)"
      fill="#c0b0a7"
    />
    <path
      d="M563.9,294.14l0,2.64-2.79.39-1.19-.39c-.74-.73-1.54-1.43-.94-2.64l2-.32Z"
      transform="translate(-429.92 -141.92)"
      fill="#f1dcd6"
    />
    <path
      d="M547,296.81l-3.14.35H540l-.95-.33,1-2.71,5-.29,3.94.34C549.27,295.75,547.56,295.85,547,296.81Z"
      transform="translate(-429.92 -141.92)"
      fill="#f1dcd6"
    />
    <path
      d="M547,296.81c-1.5-2.49,1.76-1.44,2-2.65l10,0,.94,2.64Z"
      transform="translate(-429.92 -141.92)"
      fill="#feefeb"
    />
  </svg>
);

export default IconLogo;
